[
  {
    "fips": 1001,
    "state": "AL",
    "area_name": "Autauga County"
  },
  {
    "fips": 1003,
    "state": "AL",
    "area_name": "Baldwin County"
  },
  {
    "fips": 1005,
    "state": "AL",
    "area_name": "Barbour County"
  },
  {
    "fips": 1007,
    "state": "AL",
    "area_name": "Bibb County"
  },
  {
    "fips": 1009,
    "state": "AL",
    "area_name": "Blount County"
  },
  {
    "fips": 1011,
    "state": "AL",
    "area_name": "Bullock County"
  },
  {
    "fips": 1013,
    "state": "AL",
    "area_name": "Butler County"
  },
  {
    "fips": 1015,
    "state": "AL",
    "area_name": "Calhoun County"
  },
  {
    "fips": 1017,
    "state": "AL",
    "area_name": "Chambers County"
  },
  {
    "fips": 1019,
    "state": "AL",
    "area_name": "Cherokee County"
  },
  {
    "fips": 1021,
    "state": "AL",
    "area_name": "Chilton County"
  },
  {
    "fips": 1023,
    "state": "AL",
    "area_name": "Choctaw County"
  },
  {
    "fips": 1025,
    "state": "AL",
    "area_name": "Clarke County"
  },
  {
    "fips": 1027,
    "state": "AL",
    "area_name": "Clay County"
  },
  {
    "fips": 1029,
    "state": "AL",
    "area_name": "Cleburne County"
  },
  {
    "fips": 1031,
    "state": "AL",
    "area_name": "Coffee County"
  },
  {
    "fips": 1033,
    "state": "AL",
    "area_name": "Colbert County"
  },
  {
    "fips": 1035,
    "state": "AL",
    "area_name": "Conecuh County"
  },
  {
    "fips": 1037,
    "state": "AL",
    "area_name": "Coosa County"
  },
  {
    "fips": 1039,
    "state": "AL",
    "area_name": "Covington County"
  },
  {
    "fips": 1041,
    "state": "AL",
    "area_name": "Crenshaw County"
  },
  {
    "fips": 1043,
    "state": "AL",
    "area_name": "Cullman County"
  },
  {
    "fips": 1045,
    "state": "AL",
    "area_name": "Dale County"
  },
  {
    "fips": 1047,
    "state": "AL",
    "area_name": "Dallas County"
  },
  {
    "fips": 1049,
    "state": "AL",
    "area_name": "DeKalb County"
  },
  {
    "fips": 1051,
    "state": "AL",
    "area_name": "Elmore County"
  },
  {
    "fips": 1053,
    "state": "AL",
    "area_name": "Escambia County"
  },
  {
    "fips": 1055,
    "state": "AL",
    "area_name": "Etowah County"
  },
  {
    "fips": 1057,
    "state": "AL",
    "area_name": "Fayette County"
  },
  {
    "fips": 1059,
    "state": "AL",
    "area_name": "Franklin County"
  },
  {
    "fips": 1061,
    "state": "AL",
    "area_name": "Geneva County"
  },
  {
    "fips": 1063,
    "state": "AL",
    "area_name": "Greene County"
  },
  {
    "fips": 1065,
    "state": "AL",
    "area_name": "Hale County"
  },
  {
    "fips": 1067,
    "state": "AL",
    "area_name": "Henry County"
  },
  {
    "fips": 1069,
    "state": "AL",
    "area_name": "Houston County"
  },
  {
    "fips": 1071,
    "state": "AL",
    "area_name": "Jackson County"
  },
  {
    "fips": 1073,
    "state": "AL",
    "area_name": "Jefferson County"
  },
  {
    "fips": 1075,
    "state": "AL",
    "area_name": "Lamar County"
  },
  {
    "fips": 1077,
    "state": "AL",
    "area_name": "Lauderdale County"
  },
  {
    "fips": 1079,
    "state": "AL",
    "area_name": "Lawrence County"
  },
  {
    "fips": 1081,
    "state": "AL",
    "area_name": "Lee County"
  },
  {
    "fips": 1083,
    "state": "AL",
    "area_name": "Limestone County"
  },
  {
    "fips": 1085,
    "state": "AL",
    "area_name": "Lowndes County"
  },
  {
    "fips": 1087,
    "state": "AL",
    "area_name": "Macon County"
  },
  {
    "fips": 1089,
    "state": "AL",
    "area_name": "Madison County"
  },
  {
    "fips": 1091,
    "state": "AL",
    "area_name": "Marengo County"
  },
  {
    "fips": 1093,
    "state": "AL",
    "area_name": "Marion County"
  },
  {
    "fips": 1095,
    "state": "AL",
    "area_name": "Marshall County"
  },
  {
    "fips": 1097,
    "state": "AL",
    "area_name": "Mobile County"
  },
  {
    "fips": 1099,
    "state": "AL",
    "area_name": "Monroe County"
  },
  {
    "fips": 1101,
    "state": "AL",
    "area_name": "Montgomery County"
  },
  {
    "fips": 1103,
    "state": "AL",
    "area_name": "Morgan County"
  },
  {
    "fips": 1105,
    "state": "AL",
    "area_name": "Perry County"
  },
  {
    "fips": 1107,
    "state": "AL",
    "area_name": "Pickens County"
  },
  {
    "fips": 1109,
    "state": "AL",
    "area_name": "Pike County"
  },
  {
    "fips": 1111,
    "state": "AL",
    "area_name": "Randolph County"
  },
  {
    "fips": 1113,
    "state": "AL",
    "area_name": "Russell County"
  },
  {
    "fips": 1115,
    "state": "AL",
    "area_name": "St. Clair County"
  },
  {
    "fips": 1117,
    "state": "AL",
    "area_name": "Shelby County"
  },
  {
    "fips": 1119,
    "state": "AL",
    "area_name": "Sumter County"
  },
  {
    "fips": 1121,
    "state": "AL",
    "area_name": "Talladega County"
  },
  {
    "fips": 1123,
    "state": "AL",
    "area_name": "Tallapoosa County"
  },
  {
    "fips": 1125,
    "state": "AL",
    "area_name": "Tuscaloosa County"
  },
  {
    "fips": 1127,
    "state": "AL",
    "area_name": "Walker County"
  },
  {
    "fips": 1129,
    "state": "AL",
    "area_name": "Washington County"
  },
  {
    "fips": 1131,
    "state": "AL",
    "area_name": "Wilcox County"
  },
  {
    "fips": 1133,
    "state": "AL",
    "area_name": "Winston County"
  },
  {
    "fips": 2013,
    "state": "AK",
    "area_name": "Aleutians East Borough"
  },
  {
    "fips": 2016,
    "state": "AK",
    "area_name": "Aleutians West Census Area"
  },
  {
    "fips": 2020,
    "state": "AK",
    "area_name": "Anchorage Municipality"
  },
  {
    "fips": 2050,
    "state": "AK",
    "area_name": "Bethel Census Area"
  },
  {
    "fips": 2060,
    "state": "AK",
    "area_name": "Bristol Bay Borough"
  },
  {
    "fips": 2068,
    "state": "AK",
    "area_name": "Denali Borough"
  },
  {
    "fips": 2070,
    "state": "AK",
    "area_name": "Dillingham Census Area"
  },
  {
    "fips": 2090,
    "state": "AK",
    "area_name": "Fairbanks North Star Borough"
  },
  {
    "fips": 2100,
    "state": "AK",
    "area_name": "Haines Borough"
  },
  {
    "fips": 2105,
    "state": "AK",
    "area_name": "Hoonah-Angoon Census Area"
  },
  {
    "fips": 2110,
    "state": "AK",
    "area_name": "Juneau City and Borough"
  },
  {
    "fips": 2122,
    "state": "AK",
    "area_name": "Kenai Peninsula Borough"
  },
  {
    "fips": 2130,
    "state": "AK",
    "area_name": "Ketchikan Gateway Borough"
  },
  {
    "fips": 2150,
    "state": "AK",
    "area_name": "Kodiak Island Borough"
  },
  {
    "fips": 2164,
    "state": "AK",
    "area_name": "Lake and Peninsula Borough"
  },
  {
    "fips": 2170,
    "state": "AK",
    "area_name": "Matanuska-Susitna Borough"
  },
  {
    "fips": 2180,
    "state": "AK",
    "area_name": "Nome Census Area"
  },
  {
    "fips": 2185,
    "state": "AK",
    "area_name": "North Slope Borough"
  },
  {
    "fips": 2188,
    "state": "AK",
    "area_name": "Northwest Arctic Borough"
  },
  {
    "fips": 2195,
    "state": "AK",
    "area_name": "Petersburg Census Area"
  },
  {
    "fips": 2198,
    "state": "AK",
    "area_name": "Prince of Wales-Hyder Census Area"
  },
  {
    "fips": 2220,
    "state": "AK",
    "area_name": "Sitka City and Borough"
  },
  {
    "fips": 2230,
    "state": "AK",
    "area_name": "Skagway Municipality"
  },
  {
    "fips": 2240,
    "state": "AK",
    "area_name": "Southeast Fairbanks Census Area"
  },
  {
    "fips": 2261,
    "state": "AK",
    "area_name": "Valdez-Cordova Census Area"
  },
  {
    "fips": 2158,
    "state": "AK",
    "area_name": "Kusilvak Census Area"
  },
  {
    "fips": 2275,
    "state": "AK",
    "area_name": "Wrangell City and Borough"
  },
  {
    "fips": 2282,
    "state": "AK",
    "area_name": "Yakutat City and Borough"
  },
  {
    "fips": 2290,
    "state": "AK",
    "area_name": "Yukon-Koyukuk Census Area"
  },
  {
    "fips": 4001,
    "state": "AZ",
    "area_name": "Apache County"
  },
  {
    "fips": 4003,
    "state": "AZ",
    "area_name": "Cochise County"
  },
  {
    "fips": 4005,
    "state": "AZ",
    "area_name": "Coconino County"
  },
  {
    "fips": 4007,
    "state": "AZ",
    "area_name": "Gila County"
  },
  {
    "fips": 4009,
    "state": "AZ",
    "area_name": "Graham County"
  },
  {
    "fips": 4011,
    "state": "AZ",
    "area_name": "Greenlee County"
  },
  {
    "fips": 4012,
    "state": "AZ",
    "area_name": "La Paz County"
  },
  {
    "fips": 4013,
    "state": "AZ",
    "area_name": "Maricopa County"
  },
  {
    "fips": 4015,
    "state": "AZ",
    "area_name": "Mohave County"
  },
  {
    "fips": 4017,
    "state": "AZ",
    "area_name": "Navajo County"
  },
  {
    "fips": 4019,
    "state": "AZ",
    "area_name": "Pima County"
  },
  {
    "fips": 4021,
    "state": "AZ",
    "area_name": "Pinal County"
  },
  {
    "fips": 4023,
    "state": "AZ",
    "area_name": "Santa Cruz County"
  },
  {
    "fips": 4025,
    "state": "AZ",
    "area_name": "Yavapai County"
  },
  {
    "fips": 4027,
    "state": "AZ",
    "area_name": "Yuma County"
  },
  {
    "fips": 5001,
    "state": "AR",
    "area_name": "Arkansas County"
  },
  {
    "fips": 5003,
    "state": "AR",
    "area_name": "Ashley County"
  },
  {
    "fips": 5005,
    "state": "AR",
    "area_name": "Baxter County"
  },
  {
    "fips": 5007,
    "state": "AR",
    "area_name": "Benton County"
  },
  {
    "fips": 5009,
    "state": "AR",
    "area_name": "Boone County"
  },
  {
    "fips": 5011,
    "state": "AR",
    "area_name": "Bradley County"
  },
  {
    "fips": 5013,
    "state": "AR",
    "area_name": "Calhoun County"
  },
  {
    "fips": 5015,
    "state": "AR",
    "area_name": "Carroll County"
  },
  {
    "fips": 5017,
    "state": "AR",
    "area_name": "Chicot County"
  },
  {
    "fips": 5019,
    "state": "AR",
    "area_name": "Clark County"
  },
  {
    "fips": 5021,
    "state": "AR",
    "area_name": "Clay County"
  },
  {
    "fips": 5023,
    "state": "AR",
    "area_name": "Cleburne County"
  },
  {
    "fips": 5025,
    "state": "AR",
    "area_name": "Cleveland County"
  },
  {
    "fips": 5027,
    "state": "AR",
    "area_name": "Columbia County"
  },
  {
    "fips": 5029,
    "state": "AR",
    "area_name": "Conway County"
  },
  {
    "fips": 5031,
    "state": "AR",
    "area_name": "Craighead County"
  },
  {
    "fips": 5033,
    "state": "AR",
    "area_name": "Crawford County"
  },
  {
    "fips": 5035,
    "state": "AR",
    "area_name": "Crittenden County"
  },
  {
    "fips": 5037,
    "state": "AR",
    "area_name": "Cross County"
  },
  {
    "fips": 5039,
    "state": "AR",
    "area_name": "Dallas County"
  },
  {
    "fips": 5041,
    "state": "AR",
    "area_name": "Desha County"
  },
  {
    "fips": 5043,
    "state": "AR",
    "area_name": "Drew County"
  },
  {
    "fips": 5045,
    "state": "AR",
    "area_name": "Faulkner County"
  },
  {
    "fips": 5047,
    "state": "AR",
    "area_name": "Franklin County"
  },
  {
    "fips": 5049,
    "state": "AR",
    "area_name": "Fulton County"
  },
  {
    "fips": 5051,
    "state": "AR",
    "area_name": "Garland County"
  },
  {
    "fips": 5053,
    "state": "AR",
    "area_name": "Grant County"
  },
  {
    "fips": 5055,
    "state": "AR",
    "area_name": "Greene County"
  },
  {
    "fips": 5057,
    "state": "AR",
    "area_name": "Hempstead County"
  },
  {
    "fips": 5059,
    "state": "AR",
    "area_name": "Hot Spring County"
  },
  {
    "fips": 5061,
    "state": "AR",
    "area_name": "Howard County"
  },
  {
    "fips": 5063,
    "state": "AR",
    "area_name": "Independence County"
  },
  {
    "fips": 5065,
    "state": "AR",
    "area_name": "Izard County"
  },
  {
    "fips": 5067,
    "state": "AR",
    "area_name": "Jackson County"
  },
  {
    "fips": 5069,
    "state": "AR",
    "area_name": "Jefferson County"
  },
  {
    "fips": 5071,
    "state": "AR",
    "area_name": "Johnson County"
  },
  {
    "fips": 5073,
    "state": "AR",
    "area_name": "Lafayette County"
  },
  {
    "fips": 5075,
    "state": "AR",
    "area_name": "Lawrence County"
  },
  {
    "fips": 5077,
    "state": "AR",
    "area_name": "Lee County"
  },
  {
    "fips": 5079,
    "state": "AR",
    "area_name": "Lincoln County"
  },
  {
    "fips": 5081,
    "state": "AR",
    "area_name": "Little River County"
  },
  {
    "fips": 5083,
    "state": "AR",
    "area_name": "Logan County"
  },
  {
    "fips": 5085,
    "state": "AR",
    "area_name": "Lonoke County"
  },
  {
    "fips": 5087,
    "state": "AR",
    "area_name": "Madison County"
  },
  {
    "fips": 5089,
    "state": "AR",
    "area_name": "Marion County"
  },
  {
    "fips": 5091,
    "state": "AR",
    "area_name": "Miller County"
  },
  {
    "fips": 5093,
    "state": "AR",
    "area_name": "Mississippi County"
  },
  {
    "fips": 5095,
    "state": "AR",
    "area_name": "Monroe County"
  },
  {
    "fips": 5097,
    "state": "AR",
    "area_name": "Montgomery County"
  },
  {
    "fips": 5099,
    "state": "AR",
    "area_name": "Nevada County"
  },
  {
    "fips": 5101,
    "state": "AR",
    "area_name": "Newton County"
  },
  {
    "fips": 5103,
    "state": "AR",
    "area_name": "Ouachita County"
  },
  {
    "fips": 5105,
    "state": "AR",
    "area_name": "Perry County"
  },
  {
    "fips": 5107,
    "state": "AR",
    "area_name": "Phillips County"
  },
  {
    "fips": 5109,
    "state": "AR",
    "area_name": "Pike County"
  },
  {
    "fips": 5111,
    "state": "AR",
    "area_name": "Poinsett County"
  },
  {
    "fips": 5113,
    "state": "AR",
    "area_name": "Polk County"
  },
  {
    "fips": 5115,
    "state": "AR",
    "area_name": "Pope County"
  },
  {
    "fips": 5117,
    "state": "AR",
    "area_name": "Prairie County"
  },
  {
    "fips": 5119,
    "state": "AR",
    "area_name": "Pulaski County"
  },
  {
    "fips": 5121,
    "state": "AR",
    "area_name": "Randolph County"
  },
  {
    "fips": 5123,
    "state": "AR",
    "area_name": "St. Francis County"
  },
  {
    "fips": 5125,
    "state": "AR",
    "area_name": "Saline County"
  },
  {
    "fips": 5127,
    "state": "AR",
    "area_name": "Scott County"
  },
  {
    "fips": 5129,
    "state": "AR",
    "area_name": "Searcy County"
  },
  {
    "fips": 5131,
    "state": "AR",
    "area_name": "Sebastian County"
  },
  {
    "fips": 5133,
    "state": "AR",
    "area_name": "Sevier County"
  },
  {
    "fips": 5135,
    "state": "AR",
    "area_name": "Sharp County"
  },
  {
    "fips": 5137,
    "state": "AR",
    "area_name": "Stone County"
  },
  {
    "fips": 5139,
    "state": "AR",
    "area_name": "Union County"
  },
  {
    "fips": 5141,
    "state": "AR",
    "area_name": "Van Buren County"
  },
  {
    "fips": 5143,
    "state": "AR",
    "area_name": "Washington County"
  },
  {
    "fips": 5145,
    "state": "AR",
    "area_name": "White County"
  },
  {
    "fips": 5147,
    "state": "AR",
    "area_name": "Woodruff County"
  },
  {
    "fips": 5149,
    "state": "AR",
    "area_name": "Yell County"
  },
  {
    "fips": 6001,
    "state": "CA",
    "area_name": "Alameda County"
  },
  {
    "fips": 6003,
    "state": "CA",
    "area_name": "Alpine County"
  },
  {
    "fips": 6005,
    "state": "CA",
    "area_name": "Amador County"
  },
  {
    "fips": 6007,
    "state": "CA",
    "area_name": "Butte County"
  },
  {
    "fips": 6009,
    "state": "CA",
    "area_name": "Calaveras County"
  },
  {
    "fips": 6011,
    "state": "CA",
    "area_name": "Colusa County"
  },
  {
    "fips": 6013,
    "state": "CA",
    "area_name": "Contra Costa County"
  },
  {
    "fips": 6015,
    "state": "CA",
    "area_name": "Del Norte County"
  },
  {
    "fips": 6017,
    "state": "CA",
    "area_name": "El Dorado County"
  },
  {
    "fips": 6019,
    "state": "CA",
    "area_name": "Fresno County"
  },
  {
    "fips": 6021,
    "state": "CA",
    "area_name": "Glenn County"
  },
  {
    "fips": 6023,
    "state": "CA",
    "area_name": "Humboldt County"
  },
  {
    "fips": 6025,
    "state": "CA",
    "area_name": "Imperial County"
  },
  {
    "fips": 6027,
    "state": "CA",
    "area_name": "Inyo County"
  },
  {
    "fips": 6029,
    "state": "CA",
    "area_name": "Kern County"
  },
  {
    "fips": 6031,
    "state": "CA",
    "area_name": "Kings County"
  },
  {
    "fips": 6033,
    "state": "CA",
    "area_name": "Lake County"
  },
  {
    "fips": 6035,
    "state": "CA",
    "area_name": "Lassen County"
  },
  {
    "fips": 6037,
    "state": "CA",
    "area_name": "Los Angeles County"
  },
  {
    "fips": 6039,
    "state": "CA",
    "area_name": "Madera County"
  },
  {
    "fips": 6041,
    "state": "CA",
    "area_name": "Marin County"
  },
  {
    "fips": 6043,
    "state": "CA",
    "area_name": "Mariposa County"
  },
  {
    "fips": 6045,
    "state": "CA",
    "area_name": "Mendocino County"
  },
  {
    "fips": 6047,
    "state": "CA",
    "area_name": "Merced County"
  },
  {
    "fips": 6049,
    "state": "CA",
    "area_name": "Modoc County"
  },
  {
    "fips": 6051,
    "state": "CA",
    "area_name": "Mono County"
  },
  {
    "fips": 6053,
    "state": "CA",
    "area_name": "Monterey County"
  },
  {
    "fips": 6055,
    "state": "CA",
    "area_name": "Napa County"
  },
  {
    "fips": 6057,
    "state": "CA",
    "area_name": "Nevada County"
  },
  {
    "fips": 6059,
    "state": "CA",
    "area_name": "Orange County"
  },
  {
    "fips": 6061,
    "state": "CA",
    "area_name": "Placer County"
  },
  {
    "fips": 6063,
    "state": "CA",
    "area_name": "Plumas County"
  },
  {
    "fips": 6065,
    "state": "CA",
    "area_name": "Riverside County"
  },
  {
    "fips": 6067,
    "state": "CA",
    "area_name": "Sacramento County"
  },
  {
    "fips": 6069,
    "state": "CA",
    "area_name": "San Benito County"
  },
  {
    "fips": 6071,
    "state": "CA",
    "area_name": "San Bernardino County"
  },
  {
    "fips": 6073,
    "state": "CA",
    "area_name": "San Diego County"
  },
  {
    "fips": 6075,
    "state": "CA",
    "area_name": "San Francisco County"
  },
  {
    "fips": 6077,
    "state": "CA",
    "area_name": "San Joaquin County"
  },
  {
    "fips": 6079,
    "state": "CA",
    "area_name": "San Luis Obispo County"
  },
  {
    "fips": 6081,
    "state": "CA",
    "area_name": "San Mateo County"
  },
  {
    "fips": 6083,
    "state": "CA",
    "area_name": "Santa Barbara County"
  },
  {
    "fips": 6085,
    "state": "CA",
    "area_name": "Santa Clara County"
  },
  {
    "fips": 6087,
    "state": "CA",
    "area_name": "Santa Cruz County"
  },
  {
    "fips": 6089,
    "state": "CA",
    "area_name": "Shasta County"
  },
  {
    "fips": 6091,
    "state": "CA",
    "area_name": "Sierra County"
  },
  {
    "fips": 6093,
    "state": "CA",
    "area_name": "Siskiyou County"
  },
  {
    "fips": 6095,
    "state": "CA",
    "area_name": "Solano County"
  },
  {
    "fips": 6097,
    "state": "CA",
    "area_name": "Sonoma County"
  },
  {
    "fips": 6099,
    "state": "CA",
    "area_name": "Stanislaus County"
  },
  {
    "fips": 6101,
    "state": "CA",
    "area_name": "Sutter County"
  },
  {
    "fips": 6103,
    "state": "CA",
    "area_name": "Tehama County"
  },
  {
    "fips": 6105,
    "state": "CA",
    "area_name": "Trinity County"
  },
  {
    "fips": 6107,
    "state": "CA",
    "area_name": "Tulare County"
  },
  {
    "fips": 6109,
    "state": "CA",
    "area_name": "Tuolumne County"
  },
  {
    "fips": 6111,
    "state": "CA",
    "area_name": "Ventura County"
  },
  {
    "fips": 6113,
    "state": "CA",
    "area_name": "Yolo County"
  },
  {
    "fips": 6115,
    "state": "CA",
    "area_name": "Yuba County"
  },
  {
    "fips": 8001,
    "state": "CO",
    "area_name": "Adams County"
  },
  {
    "fips": 8003,
    "state": "CO",
    "area_name": "Alamosa County"
  },
  {
    "fips": 8005,
    "state": "CO",
    "area_name": "Arapahoe County"
  },
  {
    "fips": 8007,
    "state": "CO",
    "area_name": "Archuleta County"
  },
  {
    "fips": 8009,
    "state": "CO",
    "area_name": "Baca County"
  },
  {
    "fips": 8011,
    "state": "CO",
    "area_name": "Bent County"
  },
  {
    "fips": 8013,
    "state": "CO",
    "area_name": "Boulder County"
  },
  {
    "fips": 8014,
    "state": "CO",
    "area_name": "Broomfield County"
  },
  {
    "fips": 8015,
    "state": "CO",
    "area_name": "Chaffee County"
  },
  {
    "fips": 8017,
    "state": "CO",
    "area_name": "Cheyenne County"
  },
  {
    "fips": 8019,
    "state": "CO",
    "area_name": "Clear Creek County"
  },
  {
    "fips": 8021,
    "state": "CO",
    "area_name": "Conejos County"
  },
  {
    "fips": 8023,
    "state": "CO",
    "area_name": "Costilla County"
  },
  {
    "fips": 8025,
    "state": "CO",
    "area_name": "Crowley County"
  },
  {
    "fips": 8027,
    "state": "CO",
    "area_name": "Custer County"
  },
  {
    "fips": 8029,
    "state": "CO",
    "area_name": "Delta County"
  },
  {
    "fips": 8031,
    "state": "CO",
    "area_name": "Denver County"
  },
  {
    "fips": 8033,
    "state": "CO",
    "area_name": "Dolores County"
  },
  {
    "fips": 8035,
    "state": "CO",
    "area_name": "Douglas County"
  },
  {
    "fips": 8037,
    "state": "CO",
    "area_name": "Eagle County"
  },
  {
    "fips": 8039,
    "state": "CO",
    "area_name": "Elbert County"
  },
  {
    "fips": 8041,
    "state": "CO",
    "area_name": "El Paso County"
  },
  {
    "fips": 8043,
    "state": "CO",
    "area_name": "Fremont County"
  },
  {
    "fips": 8045,
    "state": "CO",
    "area_name": "Garfield County"
  },
  {
    "fips": 8047,
    "state": "CO",
    "area_name": "Gilpin County"
  },
  {
    "fips": 8049,
    "state": "CO",
    "area_name": "Grand County"
  },
  {
    "fips": 8051,
    "state": "CO",
    "area_name": "Gunnison County"
  },
  {
    "fips": 8053,
    "state": "CO",
    "area_name": "Hinsdale County"
  },
  {
    "fips": 8055,
    "state": "CO",
    "area_name": "Huerfano County"
  },
  {
    "fips": 8057,
    "state": "CO",
    "area_name": "Jackson County"
  },
  {
    "fips": 8059,
    "state": "CO",
    "area_name": "Jefferson County"
  },
  {
    "fips": 8061,
    "state": "CO",
    "area_name": "Kiowa County"
  },
  {
    "fips": 8063,
    "state": "CO",
    "area_name": "Kit Carson County"
  },
  {
    "fips": 8065,
    "state": "CO",
    "area_name": "Lake County"
  },
  {
    "fips": 8067,
    "state": "CO",
    "area_name": "La Plata County"
  },
  {
    "fips": 8069,
    "state": "CO",
    "area_name": "Larimer County"
  },
  {
    "fips": 8071,
    "state": "CO",
    "area_name": "Las Animas County"
  },
  {
    "fips": 8073,
    "state": "CO",
    "area_name": "Lincoln County"
  },
  {
    "fips": 8075,
    "state": "CO",
    "area_name": "Logan County"
  },
  {
    "fips": 8077,
    "state": "CO",
    "area_name": "Mesa County"
  },
  {
    "fips": 8079,
    "state": "CO",
    "area_name": "Mineral County"
  },
  {
    "fips": 8081,
    "state": "CO",
    "area_name": "Moffat County"
  },
  {
    "fips": 8083,
    "state": "CO",
    "area_name": "Montezuma County"
  },
  {
    "fips": 8085,
    "state": "CO",
    "area_name": "Montrose County"
  },
  {
    "fips": 8087,
    "state": "CO",
    "area_name": "Morgan County"
  },
  {
    "fips": 8089,
    "state": "CO",
    "area_name": "Otero County"
  },
  {
    "fips": 8091,
    "state": "CO",
    "area_name": "Ouray County"
  },
  {
    "fips": 8093,
    "state": "CO",
    "area_name": "Park County"
  },
  {
    "fips": 8095,
    "state": "CO",
    "area_name": "Phillips County"
  },
  {
    "fips": 8097,
    "state": "CO",
    "area_name": "Pitkin County"
  },
  {
    "fips": 8099,
    "state": "CO",
    "area_name": "Prowers County"
  },
  {
    "fips": 8101,
    "state": "CO",
    "area_name": "Pueblo County"
  },
  {
    "fips": 8103,
    "state": "CO",
    "area_name": "Rio Blanco County"
  },
  {
    "fips": 8105,
    "state": "CO",
    "area_name": "Rio Grande County"
  },
  {
    "fips": 8107,
    "state": "CO",
    "area_name": "Routt County"
  },
  {
    "fips": 8109,
    "state": "CO",
    "area_name": "Saguache County"
  },
  {
    "fips": 8111,
    "state": "CO",
    "area_name": "San Juan County"
  },
  {
    "fips": 8113,
    "state": "CO",
    "area_name": "San Miguel County"
  },
  {
    "fips": 8115,
    "state": "CO",
    "area_name": "Sedgwick County"
  },
  {
    "fips": 8117,
    "state": "CO",
    "area_name": "Summit County"
  },
  {
    "fips": 8119,
    "state": "CO",
    "area_name": "Teller County"
  },
  {
    "fips": 8121,
    "state": "CO",
    "area_name": "Washington County"
  },
  {
    "fips": 8123,
    "state": "CO",
    "area_name": "Weld County"
  },
  {
    "fips": 8125,
    "state": "CO",
    "area_name": "Yuma County"
  },
  {
    "fips": 9001,
    "state": "CT",
    "area_name": "Fairfield County"
  },
  {
    "fips": 9003,
    "state": "CT",
    "area_name": "Hartford County"
  },
  {
    "fips": 9005,
    "state": "CT",
    "area_name": "Litchfield County"
  },
  {
    "fips": 9007,
    "state": "CT",
    "area_name": "Middlesex County"
  },
  {
    "fips": 9009,
    "state": "CT",
    "area_name": "New Haven County"
  },
  {
    "fips": 9011,
    "state": "CT",
    "area_name": "New London County"
  },
  {
    "fips": 9013,
    "state": "CT",
    "area_name": "Tolland County"
  },
  {
    "fips": 9015,
    "state": "CT",
    "area_name": "Windham County"
  },
  {
    "fips": 10001,
    "state": "DE",
    "area_name": "Kent County"
  },
  {
    "fips": 10003,
    "state": "DE",
    "area_name": "New Castle County"
  },
  {
    "fips": 10005,
    "state": "DE",
    "area_name": "Sussex County"
  },
  {
    "fips": 11001,
    "state": "DC",
    "area_name": "District of Columbia"
  },
  {
    "fips": 12001,
    "state": "FL",
    "area_name": "Alachua County"
  },
  {
    "fips": 12003,
    "state": "FL",
    "area_name": "Baker County"
  },
  {
    "fips": 12005,
    "state": "FL",
    "area_name": "Bay County"
  },
  {
    "fips": 12007,
    "state": "FL",
    "area_name": "Bradford County"
  },
  {
    "fips": 12009,
    "state": "FL",
    "area_name": "Brevard County"
  },
  {
    "fips": 12011,
    "state": "FL",
    "area_name": "Broward County"
  },
  {
    "fips": 12013,
    "state": "FL",
    "area_name": "Calhoun County"
  },
  {
    "fips": 12015,
    "state": "FL",
    "area_name": "Charlotte County"
  },
  {
    "fips": 12017,
    "state": "FL",
    "area_name": "Citrus County"
  },
  {
    "fips": 12019,
    "state": "FL",
    "area_name": "Clay County"
  },
  {
    "fips": 12021,
    "state": "FL",
    "area_name": "Collier County"
  },
  {
    "fips": 12023,
    "state": "FL",
    "area_name": "Columbia County"
  },
  {
    "fips": 12027,
    "state": "FL",
    "area_name": "DeSoto County"
  },
  {
    "fips": 12029,
    "state": "FL",
    "area_name": "Dixie County"
  },
  {
    "fips": 12031,
    "state": "FL",
    "area_name": "Duval County"
  },
  {
    "fips": 12033,
    "state": "FL",
    "area_name": "Escambia County"
  },
  {
    "fips": 12035,
    "state": "FL",
    "area_name": "Flagler County"
  },
  {
    "fips": 12037,
    "state": "FL",
    "area_name": "Franklin County"
  },
  {
    "fips": 12039,
    "state": "FL",
    "area_name": "Gadsden County"
  },
  {
    "fips": 12041,
    "state": "FL",
    "area_name": "Gilchrist County"
  },
  {
    "fips": 12043,
    "state": "FL",
    "area_name": "Glades County"
  },
  {
    "fips": 12045,
    "state": "FL",
    "area_name": "Gulf County"
  },
  {
    "fips": 12047,
    "state": "FL",
    "area_name": "Hamilton County"
  },
  {
    "fips": 12049,
    "state": "FL",
    "area_name": "Hardee County"
  },
  {
    "fips": 12051,
    "state": "FL",
    "area_name": "Hendry County"
  },
  {
    "fips": 12053,
    "state": "FL",
    "area_name": "Hernando County"
  },
  {
    "fips": 12055,
    "state": "FL",
    "area_name": "Highlands County"
  },
  {
    "fips": 12057,
    "state": "FL",
    "area_name": "Hillsborough County"
  },
  {
    "fips": 12059,
    "state": "FL",
    "area_name": "Holmes County"
  },
  {
    "fips": 12061,
    "state": "FL",
    "area_name": "Indian River County"
  },
  {
    "fips": 12063,
    "state": "FL",
    "area_name": "Jackson County"
  },
  {
    "fips": 12065,
    "state": "FL",
    "area_name": "Jefferson County"
  },
  {
    "fips": 12067,
    "state": "FL",
    "area_name": "Lafayette County"
  },
  {
    "fips": 12069,
    "state": "FL",
    "area_name": "Lake County"
  },
  {
    "fips": 12071,
    "state": "FL",
    "area_name": "Lee County"
  },
  {
    "fips": 12073,
    "state": "FL",
    "area_name": "Leon County"
  },
  {
    "fips": 12075,
    "state": "FL",
    "area_name": "Levy County"
  },
  {
    "fips": 12077,
    "state": "FL",
    "area_name": "Liberty County"
  },
  {
    "fips": 12079,
    "state": "FL",
    "area_name": "Madison County"
  },
  {
    "fips": 12081,
    "state": "FL",
    "area_name": "Manatee County"
  },
  {
    "fips": 12083,
    "state": "FL",
    "area_name": "Marion County"
  },
  {
    "fips": 12085,
    "state": "FL",
    "area_name": "Martin County"
  },
  {
    "fips": 12086,
    "state": "FL",
    "area_name": "Miami-Dade County"
  },
  {
    "fips": 12087,
    "state": "FL",
    "area_name": "Monroe County"
  },
  {
    "fips": 12089,
    "state": "FL",
    "area_name": "Nassau County"
  },
  {
    "fips": 12091,
    "state": "FL",
    "area_name": "Okaloosa County"
  },
  {
    "fips": 12093,
    "state": "FL",
    "area_name": "Okeechobee County"
  },
  {
    "fips": 12095,
    "state": "FL",
    "area_name": "Orange County"
  },
  {
    "fips": 12097,
    "state": "FL",
    "area_name": "Osceola County"
  },
  {
    "fips": 12099,
    "state": "FL",
    "area_name": "Palm Beach County"
  },
  {
    "fips": 12101,
    "state": "FL",
    "area_name": "Pasco County"
  },
  {
    "fips": 12103,
    "state": "FL",
    "area_name": "Pinellas County"
  },
  {
    "fips": 12105,
    "state": "FL",
    "area_name": "Polk County"
  },
  {
    "fips": 12107,
    "state": "FL",
    "area_name": "Putnam County"
  },
  {
    "fips": 12109,
    "state": "FL",
    "area_name": "St. Johns County"
  },
  {
    "fips": 12111,
    "state": "FL",
    "area_name": "St. Lucie County"
  },
  {
    "fips": 12113,
    "state": "FL",
    "area_name": "Santa Rosa County"
  },
  {
    "fips": 12115,
    "state": "FL",
    "area_name": "Sarasota County"
  },
  {
    "fips": 12117,
    "state": "FL",
    "area_name": "Seminole County"
  },
  {
    "fips": 12119,
    "state": "FL",
    "area_name": "Sumter County"
  },
  {
    "fips": 12121,
    "state": "FL",
    "area_name": "Suwannee County"
  },
  {
    "fips": 12123,
    "state": "FL",
    "area_name": "Taylor County"
  },
  {
    "fips": 12125,
    "state": "FL",
    "area_name": "Union County"
  },
  {
    "fips": 12127,
    "state": "FL",
    "area_name": "Volusia County"
  },
  {
    "fips": 12129,
    "state": "FL",
    "area_name": "Wakulla County"
  },
  {
    "fips": 12131,
    "state": "FL",
    "area_name": "Walton County"
  },
  {
    "fips": 12133,
    "state": "FL",
    "area_name": "Washington County"
  },
  {
    "fips": 13001,
    "state": "GA",
    "area_name": "Appling County"
  },
  {
    "fips": 13003,
    "state": "GA",
    "area_name": "Atkinson County"
  },
  {
    "fips": 13005,
    "state": "GA",
    "area_name": "Bacon County"
  },
  {
    "fips": 13007,
    "state": "GA",
    "area_name": "Baker County"
  },
  {
    "fips": 13009,
    "state": "GA",
    "area_name": "Baldwin County"
  },
  {
    "fips": 13011,
    "state": "GA",
    "area_name": "Banks County"
  },
  {
    "fips": 13013,
    "state": "GA",
    "area_name": "Barrow County"
  },
  {
    "fips": 13015,
    "state": "GA",
    "area_name": "Bartow County"
  },
  {
    "fips": 13017,
    "state": "GA",
    "area_name": "Ben Hill County"
  },
  {
    "fips": 13019,
    "state": "GA",
    "area_name": "Berrien County"
  },
  {
    "fips": 13021,
    "state": "GA",
    "area_name": "Bibb County"
  },
  {
    "fips": 13023,
    "state": "GA",
    "area_name": "Bleckley County"
  },
  {
    "fips": 13025,
    "state": "GA",
    "area_name": "Brantley County"
  },
  {
    "fips": 13027,
    "state": "GA",
    "area_name": "Brooks County"
  },
  {
    "fips": 13029,
    "state": "GA",
    "area_name": "Bryan County"
  },
  {
    "fips": 13031,
    "state": "GA",
    "area_name": "Bulloch County"
  },
  {
    "fips": 13033,
    "state": "GA",
    "area_name": "Burke County"
  },
  {
    "fips": 13035,
    "state": "GA",
    "area_name": "Butts County"
  },
  {
    "fips": 13037,
    "state": "GA",
    "area_name": "Calhoun County"
  },
  {
    "fips": 13039,
    "state": "GA",
    "area_name": "Camden County"
  },
  {
    "fips": 13043,
    "state": "GA",
    "area_name": "Candler County"
  },
  {
    "fips": 13045,
    "state": "GA",
    "area_name": "Carroll County"
  },
  {
    "fips": 13047,
    "state": "GA",
    "area_name": "Catoosa County"
  },
  {
    "fips": 13049,
    "state": "GA",
    "area_name": "Charlton County"
  },
  {
    "fips": 13051,
    "state": "GA",
    "area_name": "Chatham County"
  },
  {
    "fips": 13053,
    "state": "GA",
    "area_name": "Chattahoochee County"
  },
  {
    "fips": 13055,
    "state": "GA",
    "area_name": "Chattooga County"
  },
  {
    "fips": 13057,
    "state": "GA",
    "area_name": "Cherokee County"
  },
  {
    "fips": 13059,
    "state": "GA",
    "area_name": "Clarke County"
  },
  {
    "fips": 13061,
    "state": "GA",
    "area_name": "Clay County"
  },
  {
    "fips": 13063,
    "state": "GA",
    "area_name": "Clayton County"
  },
  {
    "fips": 13065,
    "state": "GA",
    "area_name": "Clinch County"
  },
  {
    "fips": 13067,
    "state": "GA",
    "area_name": "Cobb County"
  },
  {
    "fips": 13069,
    "state": "GA",
    "area_name": "Coffee County"
  },
  {
    "fips": 13071,
    "state": "GA",
    "area_name": "Colquitt County"
  },
  {
    "fips": 13073,
    "state": "GA",
    "area_name": "Columbia County"
  },
  {
    "fips": 13075,
    "state": "GA",
    "area_name": "Cook County"
  },
  {
    "fips": 13077,
    "state": "GA",
    "area_name": "Coweta County"
  },
  {
    "fips": 13079,
    "state": "GA",
    "area_name": "Crawford County"
  },
  {
    "fips": 13081,
    "state": "GA",
    "area_name": "Crisp County"
  },
  {
    "fips": 13083,
    "state": "GA",
    "area_name": "Dade County"
  },
  {
    "fips": 13085,
    "state": "GA",
    "area_name": "Dawson County"
  },
  {
    "fips": 13087,
    "state": "GA",
    "area_name": "Decatur County"
  },
  {
    "fips": 13089,
    "state": "GA",
    "area_name": "DeKalb County"
  },
  {
    "fips": 13091,
    "state": "GA",
    "area_name": "Dodge County"
  },
  {
    "fips": 13093,
    "state": "GA",
    "area_name": "Dooly County"
  },
  {
    "fips": 13095,
    "state": "GA",
    "area_name": "Dougherty County"
  },
  {
    "fips": 13097,
    "state": "GA",
    "area_name": "Douglas County"
  },
  {
    "fips": 13099,
    "state": "GA",
    "area_name": "Early County"
  },
  {
    "fips": 13101,
    "state": "GA",
    "area_name": "Echols County"
  },
  {
    "fips": 13103,
    "state": "GA",
    "area_name": "Effingham County"
  },
  {
    "fips": 13105,
    "state": "GA",
    "area_name": "Elbert County"
  },
  {
    "fips": 13107,
    "state": "GA",
    "area_name": "Emanuel County"
  },
  {
    "fips": 13109,
    "state": "GA",
    "area_name": "Evans County"
  },
  {
    "fips": 13111,
    "state": "GA",
    "area_name": "Fannin County"
  },
  {
    "fips": 13113,
    "state": "GA",
    "area_name": "Fayette County"
  },
  {
    "fips": 13115,
    "state": "GA",
    "area_name": "Floyd County"
  },
  {
    "fips": 13117,
    "state": "GA",
    "area_name": "Forsyth County"
  },
  {
    "fips": 13119,
    "state": "GA",
    "area_name": "Franklin County"
  },
  {
    "fips": 13121,
    "state": "GA",
    "area_name": "Fulton County"
  },
  {
    "fips": 13123,
    "state": "GA",
    "area_name": "Gilmer County"
  },
  {
    "fips": 13125,
    "state": "GA",
    "area_name": "Glascock County"
  },
  {
    "fips": 13127,
    "state": "GA",
    "area_name": "Glynn County"
  },
  {
    "fips": 13129,
    "state": "GA",
    "area_name": "Gordon County"
  },
  {
    "fips": 13131,
    "state": "GA",
    "area_name": "Grady County"
  },
  {
    "fips": 13133,
    "state": "GA",
    "area_name": "Greene County"
  },
  {
    "fips": 13135,
    "state": "GA",
    "area_name": "Gwinnett County"
  },
  {
    "fips": 13137,
    "state": "GA",
    "area_name": "Habersham County"
  },
  {
    "fips": 13139,
    "state": "GA",
    "area_name": "Hall County"
  },
  {
    "fips": 13141,
    "state": "GA",
    "area_name": "Hancock County"
  },
  {
    "fips": 13143,
    "state": "GA",
    "area_name": "Haralson County"
  },
  {
    "fips": 13145,
    "state": "GA",
    "area_name": "Harris County"
  },
  {
    "fips": 13147,
    "state": "GA",
    "area_name": "Hart County"
  },
  {
    "fips": 13149,
    "state": "GA",
    "area_name": "Heard County"
  },
  {
    "fips": 13151,
    "state": "GA",
    "area_name": "Henry County"
  },
  {
    "fips": 13153,
    "state": "GA",
    "area_name": "Houston County"
  },
  {
    "fips": 13155,
    "state": "GA",
    "area_name": "Irwin County"
  },
  {
    "fips": 13157,
    "state": "GA",
    "area_name": "Jackson County"
  },
  {
    "fips": 13159,
    "state": "GA",
    "area_name": "Jasper County"
  },
  {
    "fips": 13161,
    "state": "GA",
    "area_name": "Jeff Davis County"
  },
  {
    "fips": 13163,
    "state": "GA",
    "area_name": "Jefferson County"
  },
  {
    "fips": 13165,
    "state": "GA",
    "area_name": "Jenkins County"
  },
  {
    "fips": 13167,
    "state": "GA",
    "area_name": "Johnson County"
  },
  {
    "fips": 13169,
    "state": "GA",
    "area_name": "Jones County"
  },
  {
    "fips": 13171,
    "state": "GA",
    "area_name": "Lamar County"
  },
  {
    "fips": 13173,
    "state": "GA",
    "area_name": "Lanier County"
  },
  {
    "fips": 13175,
    "state": "GA",
    "area_name": "Laurens County"
  },
  {
    "fips": 13177,
    "state": "GA",
    "area_name": "Lee County"
  },
  {
    "fips": 13179,
    "state": "GA",
    "area_name": "Liberty County"
  },
  {
    "fips": 13181,
    "state": "GA",
    "area_name": "Lincoln County"
  },
  {
    "fips": 13183,
    "state": "GA",
    "area_name": "Long County"
  },
  {
    "fips": 13185,
    "state": "GA",
    "area_name": "Lowndes County"
  },
  {
    "fips": 13187,
    "state": "GA",
    "area_name": "Lumpkin County"
  },
  {
    "fips": 13189,
    "state": "GA",
    "area_name": "McDuffie County"
  },
  {
    "fips": 13191,
    "state": "GA",
    "area_name": "McIntosh County"
  },
  {
    "fips": 13193,
    "state": "GA",
    "area_name": "Macon County"
  },
  {
    "fips": 13195,
    "state": "GA",
    "area_name": "Madison County"
  },
  {
    "fips": 13197,
    "state": "GA",
    "area_name": "Marion County"
  },
  {
    "fips": 13199,
    "state": "GA",
    "area_name": "Meriwether County"
  },
  {
    "fips": 13201,
    "state": "GA",
    "area_name": "Miller County"
  },
  {
    "fips": 13205,
    "state": "GA",
    "area_name": "Mitchell County"
  },
  {
    "fips": 13207,
    "state": "GA",
    "area_name": "Monroe County"
  },
  {
    "fips": 13209,
    "state": "GA",
    "area_name": "Montgomery County"
  },
  {
    "fips": 13211,
    "state": "GA",
    "area_name": "Morgan County"
  },
  {
    "fips": 13213,
    "state": "GA",
    "area_name": "Murray County"
  },
  {
    "fips": 13215,
    "state": "GA",
    "area_name": "Muscogee County"
  },
  {
    "fips": 13217,
    "state": "GA",
    "area_name": "Newton County"
  },
  {
    "fips": 13219,
    "state": "GA",
    "area_name": "Oconee County"
  },
  {
    "fips": 13221,
    "state": "GA",
    "area_name": "Oglethorpe County"
  },
  {
    "fips": 13223,
    "state": "GA",
    "area_name": "Paulding County"
  },
  {
    "fips": 13225,
    "state": "GA",
    "area_name": "Peach County"
  },
  {
    "fips": 13227,
    "state": "GA",
    "area_name": "Pickens County"
  },
  {
    "fips": 13229,
    "state": "GA",
    "area_name": "Pierce County"
  },
  {
    "fips": 13231,
    "state": "GA",
    "area_name": "Pike County"
  },
  {
    "fips": 13233,
    "state": "GA",
    "area_name": "Polk County"
  },
  {
    "fips": 13235,
    "state": "GA",
    "area_name": "Pulaski County"
  },
  {
    "fips": 13237,
    "state": "GA",
    "area_name": "Putnam County"
  },
  {
    "fips": 13239,
    "state": "GA",
    "area_name": "Quitman County"
  },
  {
    "fips": 13241,
    "state": "GA",
    "area_name": "Rabun County"
  },
  {
    "fips": 13243,
    "state": "GA",
    "area_name": "Randolph County"
  },
  {
    "fips": 13245,
    "state": "GA",
    "area_name": "Richmond County"
  },
  {
    "fips": 13247,
    "state": "GA",
    "area_name": "Rockdale County"
  },
  {
    "fips": 13249,
    "state": "GA",
    "area_name": "Schley County"
  },
  {
    "fips": 13251,
    "state": "GA",
    "area_name": "Screven County"
  },
  {
    "fips": 13253,
    "state": "GA",
    "area_name": "Seminole County"
  },
  {
    "fips": 13255,
    "state": "GA",
    "area_name": "Spalding County"
  },
  {
    "fips": 13257,
    "state": "GA",
    "area_name": "Stephens County"
  },
  {
    "fips": 13259,
    "state": "GA",
    "area_name": "Stewart County"
  },
  {
    "fips": 13261,
    "state": "GA",
    "area_name": "Sumter County"
  },
  {
    "fips": 13263,
    "state": "GA",
    "area_name": "Talbot County"
  },
  {
    "fips": 13265,
    "state": "GA",
    "area_name": "Taliaferro County"
  },
  {
    "fips": 13267,
    "state": "GA",
    "area_name": "Tattnall County"
  },
  {
    "fips": 13269,
    "state": "GA",
    "area_name": "Taylor County"
  },
  {
    "fips": 13271,
    "state": "GA",
    "area_name": "Telfair County"
  },
  {
    "fips": 13273,
    "state": "GA",
    "area_name": "Terrell County"
  },
  {
    "fips": 13275,
    "state": "GA",
    "area_name": "Thomas County"
  },
  {
    "fips": 13277,
    "state": "GA",
    "area_name": "Tift County"
  },
  {
    "fips": 13279,
    "state": "GA",
    "area_name": "Toombs County"
  },
  {
    "fips": 13281,
    "state": "GA",
    "area_name": "Towns County"
  },
  {
    "fips": 13283,
    "state": "GA",
    "area_name": "Treutlen County"
  },
  {
    "fips": 13285,
    "state": "GA",
    "area_name": "Troup County"
  },
  {
    "fips": 13287,
    "state": "GA",
    "area_name": "Turner County"
  },
  {
    "fips": 13289,
    "state": "GA",
    "area_name": "Twiggs County"
  },
  {
    "fips": 13291,
    "state": "GA",
    "area_name": "Union County"
  },
  {
    "fips": 13293,
    "state": "GA",
    "area_name": "Upson County"
  },
  {
    "fips": 13295,
    "state": "GA",
    "area_name": "Walker County"
  },
  {
    "fips": 13297,
    "state": "GA",
    "area_name": "Walton County"
  },
  {
    "fips": 13299,
    "state": "GA",
    "area_name": "Ware County"
  },
  {
    "fips": 13301,
    "state": "GA",
    "area_name": "Warren County"
  },
  {
    "fips": 13303,
    "state": "GA",
    "area_name": "Washington County"
  },
  {
    "fips": 13305,
    "state": "GA",
    "area_name": "Wayne County"
  },
  {
    "fips": 13307,
    "state": "GA",
    "area_name": "Webster County"
  },
  {
    "fips": 13309,
    "state": "GA",
    "area_name": "Wheeler County"
  },
  {
    "fips": 13311,
    "state": "GA",
    "area_name": "White County"
  },
  {
    "fips": 13313,
    "state": "GA",
    "area_name": "Whitfield County"
  },
  {
    "fips": 13315,
    "state": "GA",
    "area_name": "Wilcox County"
  },
  {
    "fips": 13317,
    "state": "GA",
    "area_name": "Wilkes County"
  },
  {
    "fips": 13319,
    "state": "GA",
    "area_name": "Wilkinson County"
  },
  {
    "fips": 13321,
    "state": "GA",
    "area_name": "Worth County"
  },
  {
    "fips": 15001,
    "state": "HI",
    "area_name": "Hawaii County"
  },
  {
    "fips": 15003,
    "state": "HI",
    "area_name": "Honolulu County"
  },
  {
    "fips": 15005,
    "state": "HI",
    "area_name": "Kalawao County"
  },
  {
    "fips": 15007,
    "state": "HI",
    "area_name": "Kauai County"
  },
  {
    "fips": 15009,
    "state": "HI",
    "area_name": "Maui County"
  },
  {
    "fips": 16001,
    "state": "ID",
    "area_name": "Ada County"
  },
  {
    "fips": 16003,
    "state": "ID",
    "area_name": "Adams County"
  },
  {
    "fips": 16005,
    "state": "ID",
    "area_name": "Bannock County"
  },
  {
    "fips": 16007,
    "state": "ID",
    "area_name": "Bear Lake County"
  },
  {
    "fips": 16009,
    "state": "ID",
    "area_name": "Benewah County"
  },
  {
    "fips": 16011,
    "state": "ID",
    "area_name": "Bingham County"
  },
  {
    "fips": 16013,
    "state": "ID",
    "area_name": "Blaine County"
  },
  {
    "fips": 16015,
    "state": "ID",
    "area_name": "Boise County"
  },
  {
    "fips": 16017,
    "state": "ID",
    "area_name": "Bonner County"
  },
  {
    "fips": 16019,
    "state": "ID",
    "area_name": "Bonneville County"
  },
  {
    "fips": 16021,
    "state": "ID",
    "area_name": "Boundary County"
  },
  {
    "fips": 16023,
    "state": "ID",
    "area_name": "Butte County"
  },
  {
    "fips": 16025,
    "state": "ID",
    "area_name": "Camas County"
  },
  {
    "fips": 16027,
    "state": "ID",
    "area_name": "Canyon County"
  },
  {
    "fips": 16029,
    "state": "ID",
    "area_name": "Caribou County"
  },
  {
    "fips": 16031,
    "state": "ID",
    "area_name": "Cassia County"
  },
  {
    "fips": 16033,
    "state": "ID",
    "area_name": "Clark County"
  },
  {
    "fips": 16035,
    "state": "ID",
    "area_name": "Clearwater County"
  },
  {
    "fips": 16037,
    "state": "ID",
    "area_name": "Custer County"
  },
  {
    "fips": 16039,
    "state": "ID",
    "area_name": "Elmore County"
  },
  {
    "fips": 16041,
    "state": "ID",
    "area_name": "Franklin County"
  },
  {
    "fips": 16043,
    "state": "ID",
    "area_name": "Fremont County"
  },
  {
    "fips": 16045,
    "state": "ID",
    "area_name": "Gem County"
  },
  {
    "fips": 16047,
    "state": "ID",
    "area_name": "Gooding County"
  },
  {
    "fips": 16049,
    "state": "ID",
    "area_name": "Idaho County"
  },
  {
    "fips": 16051,
    "state": "ID",
    "area_name": "Jefferson County"
  },
  {
    "fips": 16053,
    "state": "ID",
    "area_name": "Jerome County"
  },
  {
    "fips": 16055,
    "state": "ID",
    "area_name": "Kootenai County"
  },
  {
    "fips": 16057,
    "state": "ID",
    "area_name": "Latah County"
  },
  {
    "fips": 16059,
    "state": "ID",
    "area_name": "Lemhi County"
  },
  {
    "fips": 16061,
    "state": "ID",
    "area_name": "Lewis County"
  },
  {
    "fips": 16063,
    "state": "ID",
    "area_name": "Lincoln County"
  },
  {
    "fips": 16065,
    "state": "ID",
    "area_name": "Madison County"
  },
  {
    "fips": 16067,
    "state": "ID",
    "area_name": "Minidoka County"
  },
  {
    "fips": 16069,
    "state": "ID",
    "area_name": "Nez Perce County"
  },
  {
    "fips": 16071,
    "state": "ID",
    "area_name": "Oneida County"
  },
  {
    "fips": 16073,
    "state": "ID",
    "area_name": "Owyhee County"
  },
  {
    "fips": 16075,
    "state": "ID",
    "area_name": "Payette County"
  },
  {
    "fips": 16077,
    "state": "ID",
    "area_name": "Power County"
  },
  {
    "fips": 16079,
    "state": "ID",
    "area_name": "Shoshone County"
  },
  {
    "fips": 16081,
    "state": "ID",
    "area_name": "Teton County"
  },
  {
    "fips": 16083,
    "state": "ID",
    "area_name": "Twin Falls County"
  },
  {
    "fips": 16085,
    "state": "ID",
    "area_name": "Valley County"
  },
  {
    "fips": 16087,
    "state": "ID",
    "area_name": "Washington County"
  },
  {
    "fips": 17001,
    "state": "IL",
    "area_name": "Adams County"
  },
  {
    "fips": 17003,
    "state": "IL",
    "area_name": "Alexander County"
  },
  {
    "fips": 17005,
    "state": "IL",
    "area_name": "Bond County"
  },
  {
    "fips": 17007,
    "state": "IL",
    "area_name": "Boone County"
  },
  {
    "fips": 17009,
    "state": "IL",
    "area_name": "Brown County"
  },
  {
    "fips": 17011,
    "state": "IL",
    "area_name": "Bureau County"
  },
  {
    "fips": 17013,
    "state": "IL",
    "area_name": "Calhoun County"
  },
  {
    "fips": 17015,
    "state": "IL",
    "area_name": "Carroll County"
  },
  {
    "fips": 17017,
    "state": "IL",
    "area_name": "Cass County"
  },
  {
    "fips": 17019,
    "state": "IL",
    "area_name": "Champaign County"
  },
  {
    "fips": 17021,
    "state": "IL",
    "area_name": "Christian County"
  },
  {
    "fips": 17023,
    "state": "IL",
    "area_name": "Clark County"
  },
  {
    "fips": 17025,
    "state": "IL",
    "area_name": "Clay County"
  },
  {
    "fips": 17027,
    "state": "IL",
    "area_name": "Clinton County"
  },
  {
    "fips": 17029,
    "state": "IL",
    "area_name": "Coles County"
  },
  {
    "fips": 17031,
    "state": "IL",
    "area_name": "Cook County"
  },
  {
    "fips": 17033,
    "state": "IL",
    "area_name": "Crawford County"
  },
  {
    "fips": 17035,
    "state": "IL",
    "area_name": "Cumberland County"
  },
  {
    "fips": 17037,
    "state": "IL",
    "area_name": "DeKalb County"
  },
  {
    "fips": 17039,
    "state": "IL",
    "area_name": "De Witt County"
  },
  {
    "fips": 17041,
    "state": "IL",
    "area_name": "Douglas County"
  },
  {
    "fips": 17043,
    "state": "IL",
    "area_name": "DuPage County"
  },
  {
    "fips": 17045,
    "state": "IL",
    "area_name": "Edgar County"
  },
  {
    "fips": 17047,
    "state": "IL",
    "area_name": "Edwards County"
  },
  {
    "fips": 17049,
    "state": "IL",
    "area_name": "Effingham County"
  },
  {
    "fips": 17051,
    "state": "IL",
    "area_name": "Fayette County"
  },
  {
    "fips": 17053,
    "state": "IL",
    "area_name": "Ford County"
  },
  {
    "fips": 17055,
    "state": "IL",
    "area_name": "Franklin County"
  },
  {
    "fips": 17057,
    "state": "IL",
    "area_name": "Fulton County"
  },
  {
    "fips": 17059,
    "state": "IL",
    "area_name": "Gallatin County"
  },
  {
    "fips": 17061,
    "state": "IL",
    "area_name": "Greene County"
  },
  {
    "fips": 17063,
    "state": "IL",
    "area_name": "Grundy County"
  },
  {
    "fips": 17065,
    "state": "IL",
    "area_name": "Hamilton County"
  },
  {
    "fips": 17067,
    "state": "IL",
    "area_name": "Hancock County"
  },
  {
    "fips": 17069,
    "state": "IL",
    "area_name": "Hardin County"
  },
  {
    "fips": 17071,
    "state": "IL",
    "area_name": "Henderson County"
  },
  {
    "fips": 17073,
    "state": "IL",
    "area_name": "Henry County"
  },
  {
    "fips": 17075,
    "state": "IL",
    "area_name": "Iroquois County"
  },
  {
    "fips": 17077,
    "state": "IL",
    "area_name": "Jackson County"
  },
  {
    "fips": 17079,
    "state": "IL",
    "area_name": "Jasper County"
  },
  {
    "fips": 17081,
    "state": "IL",
    "area_name": "Jefferson County"
  },
  {
    "fips": 17083,
    "state": "IL",
    "area_name": "Jersey County"
  },
  {
    "fips": 17085,
    "state": "IL",
    "area_name": "Jo Daviess County"
  },
  {
    "fips": 17087,
    "state": "IL",
    "area_name": "Johnson County"
  },
  {
    "fips": 17089,
    "state": "IL",
    "area_name": "Kane County"
  },
  {
    "fips": 17091,
    "state": "IL",
    "area_name": "Kankakee County"
  },
  {
    "fips": 17093,
    "state": "IL",
    "area_name": "Kendall County"
  },
  {
    "fips": 17095,
    "state": "IL",
    "area_name": "Knox County"
  },
  {
    "fips": 17097,
    "state": "IL",
    "area_name": "Lake County"
  },
  {
    "fips": 17099,
    "state": "IL",
    "area_name": "La Salle County"
  },
  {
    "fips": 17101,
    "state": "IL",
    "area_name": "Lawrence County"
  },
  {
    "fips": 17103,
    "state": "IL",
    "area_name": "Lee County"
  },
  {
    "fips": 17105,
    "state": "IL",
    "area_name": "Livingston County"
  },
  {
    "fips": 17107,
    "state": "IL",
    "area_name": "Logan County"
  },
  {
    "fips": 17109,
    "state": "IL",
    "area_name": "McDonough County"
  },
  {
    "fips": 17111,
    "state": "IL",
    "area_name": "McHenry County"
  },
  {
    "fips": 17113,
    "state": "IL",
    "area_name": "McLean County"
  },
  {
    "fips": 17115,
    "state": "IL",
    "area_name": "Macon County"
  },
  {
    "fips": 17117,
    "state": "IL",
    "area_name": "Macoupin County"
  },
  {
    "fips": 17119,
    "state": "IL",
    "area_name": "Madison County"
  },
  {
    "fips": 17121,
    "state": "IL",
    "area_name": "Marion County"
  },
  {
    "fips": 17123,
    "state": "IL",
    "area_name": "Marshall County"
  },
  {
    "fips": 17125,
    "state": "IL",
    "area_name": "Mason County"
  },
  {
    "fips": 17127,
    "state": "IL",
    "area_name": "Massac County"
  },
  {
    "fips": 17129,
    "state": "IL",
    "area_name": "Menard County"
  },
  {
    "fips": 17131,
    "state": "IL",
    "area_name": "Mercer County"
  },
  {
    "fips": 17133,
    "state": "IL",
    "area_name": "Monroe County"
  },
  {
    "fips": 17135,
    "state": "IL",
    "area_name": "Montgomery County"
  },
  {
    "fips": 17137,
    "state": "IL",
    "area_name": "Morgan County"
  },
  {
    "fips": 17139,
    "state": "IL",
    "area_name": "Moultrie County"
  },
  {
    "fips": 17141,
    "state": "IL",
    "area_name": "Ogle County"
  },
  {
    "fips": 17143,
    "state": "IL",
    "area_name": "Peoria County"
  },
  {
    "fips": 17145,
    "state": "IL",
    "area_name": "Perry County"
  },
  {
    "fips": 17147,
    "state": "IL",
    "area_name": "Piatt County"
  },
  {
    "fips": 17149,
    "state": "IL",
    "area_name": "Pike County"
  },
  {
    "fips": 17151,
    "state": "IL",
    "area_name": "Pope County"
  },
  {
    "fips": 17153,
    "state": "IL",
    "area_name": "Pulaski County"
  },
  {
    "fips": 17155,
    "state": "IL",
    "area_name": "Putnam County"
  },
  {
    "fips": 17157,
    "state": "IL",
    "area_name": "Randolph County"
  },
  {
    "fips": 17159,
    "state": "IL",
    "area_name": "Richland County"
  },
  {
    "fips": 17161,
    "state": "IL",
    "area_name": "Rock Island County"
  },
  {
    "fips": 17163,
    "state": "IL",
    "area_name": "St. Clair County"
  },
  {
    "fips": 17165,
    "state": "IL",
    "area_name": "Saline County"
  },
  {
    "fips": 17167,
    "state": "IL",
    "area_name": "Sangamon County"
  },
  {
    "fips": 17169,
    "state": "IL",
    "area_name": "Schuyler County"
  },
  {
    "fips": 17171,
    "state": "IL",
    "area_name": "Scott County"
  },
  {
    "fips": 17173,
    "state": "IL",
    "area_name": "Shelby County"
  },
  {
    "fips": 17175,
    "state": "IL",
    "area_name": "Stark County"
  },
  {
    "fips": 17177,
    "state": "IL",
    "area_name": "Stephenson County"
  },
  {
    "fips": 17179,
    "state": "IL",
    "area_name": "Tazewell County"
  },
  {
    "fips": 17181,
    "state": "IL",
    "area_name": "Union County"
  },
  {
    "fips": 17183,
    "state": "IL",
    "area_name": "Vermilion County"
  },
  {
    "fips": 17185,
    "state": "IL",
    "area_name": "Wabash County"
  },
  {
    "fips": 17187,
    "state": "IL",
    "area_name": "Warren County"
  },
  {
    "fips": 17189,
    "state": "IL",
    "area_name": "Washington County"
  },
  {
    "fips": 17191,
    "state": "IL",
    "area_name": "Wayne County"
  },
  {
    "fips": 17193,
    "state": "IL",
    "area_name": "White County"
  },
  {
    "fips": 17195,
    "state": "IL",
    "area_name": "Whiteside County"
  },
  {
    "fips": 17197,
    "state": "IL",
    "area_name": "Will County"
  },
  {
    "fips": 17199,
    "state": "IL",
    "area_name": "Williamson County"
  },
  {
    "fips": 17201,
    "state": "IL",
    "area_name": "Winnebago County"
  },
  {
    "fips": 17203,
    "state": "IL",
    "area_name": "Woodford County"
  },
  {
    "fips": 18001,
    "state": "IN",
    "area_name": "Adams County"
  },
  {
    "fips": 18003,
    "state": "IN",
    "area_name": "Allen County"
  },
  {
    "fips": 18005,
    "state": "IN",
    "area_name": "Bartholomew County"
  },
  {
    "fips": 18007,
    "state": "IN",
    "area_name": "Benton County"
  },
  {
    "fips": 18009,
    "state": "IN",
    "area_name": "Blackford County"
  },
  {
    "fips": 18011,
    "state": "IN",
    "area_name": "Boone County"
  },
  {
    "fips": 18013,
    "state": "IN",
    "area_name": "Brown County"
  },
  {
    "fips": 18015,
    "state": "IN",
    "area_name": "Carroll County"
  },
  {
    "fips": 18017,
    "state": "IN",
    "area_name": "Cass County"
  },
  {
    "fips": 18019,
    "state": "IN",
    "area_name": "Clark County"
  },
  {
    "fips": 18021,
    "state": "IN",
    "area_name": "Clay County"
  },
  {
    "fips": 18023,
    "state": "IN",
    "area_name": "Clinton County"
  },
  {
    "fips": 18025,
    "state": "IN",
    "area_name": "Crawford County"
  },
  {
    "fips": 18027,
    "state": "IN",
    "area_name": "Daviess County"
  },
  {
    "fips": 18029,
    "state": "IN",
    "area_name": "Dearborn County"
  },
  {
    "fips": 18031,
    "state": "IN",
    "area_name": "Decatur County"
  },
  {
    "fips": 18033,
    "state": "IN",
    "area_name": "DeKalb County"
  },
  {
    "fips": 18035,
    "state": "IN",
    "area_name": "Delaware County"
  },
  {
    "fips": 18037,
    "state": "IN",
    "area_name": "Dubois County"
  },
  {
    "fips": 18039,
    "state": "IN",
    "area_name": "Elkhart County"
  },
  {
    "fips": 18041,
    "state": "IN",
    "area_name": "Fayette County"
  },
  {
    "fips": 18043,
    "state": "IN",
    "area_name": "Floyd County"
  },
  {
    "fips": 18045,
    "state": "IN",
    "area_name": "Fountain County"
  },
  {
    "fips": 18047,
    "state": "IN",
    "area_name": "Franklin County"
  },
  {
    "fips": 18049,
    "state": "IN",
    "area_name": "Fulton County"
  },
  {
    "fips": 18051,
    "state": "IN",
    "area_name": "Gibson County"
  },
  {
    "fips": 18053,
    "state": "IN",
    "area_name": "Grant County"
  },
  {
    "fips": 18055,
    "state": "IN",
    "area_name": "Greene County"
  },
  {
    "fips": 18057,
    "state": "IN",
    "area_name": "Hamilton County"
  },
  {
    "fips": 18059,
    "state": "IN",
    "area_name": "Hancock County"
  },
  {
    "fips": 18061,
    "state": "IN",
    "area_name": "Harrison County"
  },
  {
    "fips": 18063,
    "state": "IN",
    "area_name": "Hendricks County"
  },
  {
    "fips": 18065,
    "state": "IN",
    "area_name": "Henry County"
  },
  {
    "fips": 18067,
    "state": "IN",
    "area_name": "Howard County"
  },
  {
    "fips": 18069,
    "state": "IN",
    "area_name": "Huntington County"
  },
  {
    "fips": 18071,
    "state": "IN",
    "area_name": "Jackson County"
  },
  {
    "fips": 18073,
    "state": "IN",
    "area_name": "Jasper County"
  },
  {
    "fips": 18075,
    "state": "IN",
    "area_name": "Jay County"
  },
  {
    "fips": 18077,
    "state": "IN",
    "area_name": "Jefferson County"
  },
  {
    "fips": 18079,
    "state": "IN",
    "area_name": "Jennings County"
  },
  {
    "fips": 18081,
    "state": "IN",
    "area_name": "Johnson County"
  },
  {
    "fips": 18083,
    "state": "IN",
    "area_name": "Knox County"
  },
  {
    "fips": 18085,
    "state": "IN",
    "area_name": "Kosciusko County"
  },
  {
    "fips": 18087,
    "state": "IN",
    "area_name": "LaGrange County"
  },
  {
    "fips": 18089,
    "state": "IN",
    "area_name": "Lake County"
  },
  {
    "fips": 18091,
    "state": "IN",
    "area_name": "LaPorte County"
  },
  {
    "fips": 18093,
    "state": "IN",
    "area_name": "Lawrence County"
  },
  {
    "fips": 18095,
    "state": "IN",
    "area_name": "Madison County"
  },
  {
    "fips": 18097,
    "state": "IN",
    "area_name": "Marion County"
  },
  {
    "fips": 18099,
    "state": "IN",
    "area_name": "Marshall County"
  },
  {
    "fips": 18101,
    "state": "IN",
    "area_name": "Martin County"
  },
  {
    "fips": 18103,
    "state": "IN",
    "area_name": "Miami County"
  },
  {
    "fips": 18105,
    "state": "IN",
    "area_name": "Monroe County"
  },
  {
    "fips": 18107,
    "state": "IN",
    "area_name": "Montgomery County"
  },
  {
    "fips": 18109,
    "state": "IN",
    "area_name": "Morgan County"
  },
  {
    "fips": 18111,
    "state": "IN",
    "area_name": "Newton County"
  },
  {
    "fips": 18113,
    "state": "IN",
    "area_name": "Noble County"
  },
  {
    "fips": 18115,
    "state": "IN",
    "area_name": "Ohio County"
  },
  {
    "fips": 18117,
    "state": "IN",
    "area_name": "Orange County"
  },
  {
    "fips": 18119,
    "state": "IN",
    "area_name": "Owen County"
  },
  {
    "fips": 18121,
    "state": "IN",
    "area_name": "Parke County"
  },
  {
    "fips": 18123,
    "state": "IN",
    "area_name": "Perry County"
  },
  {
    "fips": 18125,
    "state": "IN",
    "area_name": "Pike County"
  },
  {
    "fips": 18127,
    "state": "IN",
    "area_name": "Porter County"
  },
  {
    "fips": 18129,
    "state": "IN",
    "area_name": "Posey County"
  },
  {
    "fips": 18131,
    "state": "IN",
    "area_name": "Pulaski County"
  },
  {
    "fips": 18133,
    "state": "IN",
    "area_name": "Putnam County"
  },
  {
    "fips": 18135,
    "state": "IN",
    "area_name": "Randolph County"
  },
  {
    "fips": 18137,
    "state": "IN",
    "area_name": "Ripley County"
  },
  {
    "fips": 18139,
    "state": "IN",
    "area_name": "Rush County"
  },
  {
    "fips": 18141,
    "state": "IN",
    "area_name": "St. Joseph County"
  },
  {
    "fips": 18143,
    "state": "IN",
    "area_name": "Scott County"
  },
  {
    "fips": 18145,
    "state": "IN",
    "area_name": "Shelby County"
  },
  {
    "fips": 18147,
    "state": "IN",
    "area_name": "Spencer County"
  },
  {
    "fips": 18149,
    "state": "IN",
    "area_name": "Starke County"
  },
  {
    "fips": 18151,
    "state": "IN",
    "area_name": "Steuben County"
  },
  {
    "fips": 18153,
    "state": "IN",
    "area_name": "Sullivan County"
  },
  {
    "fips": 18155,
    "state": "IN",
    "area_name": "Switzerland County"
  },
  {
    "fips": 18157,
    "state": "IN",
    "area_name": "Tippecanoe County"
  },
  {
    "fips": 18159,
    "state": "IN",
    "area_name": "Tipton County"
  },
  {
    "fips": 18161,
    "state": "IN",
    "area_name": "Union County"
  },
  {
    "fips": 18163,
    "state": "IN",
    "area_name": "Vanderburgh County"
  },
  {
    "fips": 18165,
    "state": "IN",
    "area_name": "Vermillion County"
  },
  {
    "fips": 18167,
    "state": "IN",
    "area_name": "Vigo County"
  },
  {
    "fips": 18169,
    "state": "IN",
    "area_name": "Wabash County"
  },
  {
    "fips": 18171,
    "state": "IN",
    "area_name": "Warren County"
  },
  {
    "fips": 18173,
    "state": "IN",
    "area_name": "Warrick County"
  },
  {
    "fips": 18175,
    "state": "IN",
    "area_name": "Washington County"
  },
  {
    "fips": 18177,
    "state": "IN",
    "area_name": "Wayne County"
  },
  {
    "fips": 18179,
    "state": "IN",
    "area_name": "Wells County"
  },
  {
    "fips": 18181,
    "state": "IN",
    "area_name": "White County"
  },
  {
    "fips": 18183,
    "state": "IN",
    "area_name": "Whitley County"
  },
  {
    "fips": 19001,
    "state": "IA",
    "area_name": "Adair County"
  },
  {
    "fips": 19003,
    "state": "IA",
    "area_name": "Adams County"
  },
  {
    "fips": 19005,
    "state": "IA",
    "area_name": "Allamakee County"
  },
  {
    "fips": 19007,
    "state": "IA",
    "area_name": "Appanoose County"
  },
  {
    "fips": 19009,
    "state": "IA",
    "area_name": "Audubon County"
  },
  {
    "fips": 19011,
    "state": "IA",
    "area_name": "Benton County"
  },
  {
    "fips": 19013,
    "state": "IA",
    "area_name": "Black Hawk County"
  },
  {
    "fips": 19015,
    "state": "IA",
    "area_name": "Boone County"
  },
  {
    "fips": 19017,
    "state": "IA",
    "area_name": "Bremer County"
  },
  {
    "fips": 19019,
    "state": "IA",
    "area_name": "Buchanan County"
  },
  {
    "fips": 19021,
    "state": "IA",
    "area_name": "Buena Vista County"
  },
  {
    "fips": 19023,
    "state": "IA",
    "area_name": "Butler County"
  },
  {
    "fips": 19025,
    "state": "IA",
    "area_name": "Calhoun County"
  },
  {
    "fips": 19027,
    "state": "IA",
    "area_name": "Carroll County"
  },
  {
    "fips": 19029,
    "state": "IA",
    "area_name": "Cass County"
  },
  {
    "fips": 19031,
    "state": "IA",
    "area_name": "Cedar County"
  },
  {
    "fips": 19033,
    "state": "IA",
    "area_name": "Cerro Gordo County"
  },
  {
    "fips": 19035,
    "state": "IA",
    "area_name": "Cherokee County"
  },
  {
    "fips": 19037,
    "state": "IA",
    "area_name": "Chickasaw County"
  },
  {
    "fips": 19039,
    "state": "IA",
    "area_name": "Clarke County"
  },
  {
    "fips": 19041,
    "state": "IA",
    "area_name": "Clay County"
  },
  {
    "fips": 19043,
    "state": "IA",
    "area_name": "Clayton County"
  },
  {
    "fips": 19045,
    "state": "IA",
    "area_name": "Clinton County"
  },
  {
    "fips": 19047,
    "state": "IA",
    "area_name": "Crawford County"
  },
  {
    "fips": 19049,
    "state": "IA",
    "area_name": "Dallas County"
  },
  {
    "fips": 19051,
    "state": "IA",
    "area_name": "Davis County"
  },
  {
    "fips": 19053,
    "state": "IA",
    "area_name": "Decatur County"
  },
  {
    "fips": 19055,
    "state": "IA",
    "area_name": "Delaware County"
  },
  {
    "fips": 19057,
    "state": "IA",
    "area_name": "Des Moines County"
  },
  {
    "fips": 19059,
    "state": "IA",
    "area_name": "Dickinson County"
  },
  {
    "fips": 19061,
    "state": "IA",
    "area_name": "Dubuque County"
  },
  {
    "fips": 19063,
    "state": "IA",
    "area_name": "Emmet County"
  },
  {
    "fips": 19065,
    "state": "IA",
    "area_name": "Fayette County"
  },
  {
    "fips": 19067,
    "state": "IA",
    "area_name": "Floyd County"
  },
  {
    "fips": 19069,
    "state": "IA",
    "area_name": "Franklin County"
  },
  {
    "fips": 19071,
    "state": "IA",
    "area_name": "Fremont County"
  },
  {
    "fips": 19073,
    "state": "IA",
    "area_name": "Greene County"
  },
  {
    "fips": 19075,
    "state": "IA",
    "area_name": "Grundy County"
  },
  {
    "fips": 19077,
    "state": "IA",
    "area_name": "Guthrie County"
  },
  {
    "fips": 19079,
    "state": "IA",
    "area_name": "Hamilton County"
  },
  {
    "fips": 19081,
    "state": "IA",
    "area_name": "Hancock County"
  },
  {
    "fips": 19083,
    "state": "IA",
    "area_name": "Hardin County"
  },
  {
    "fips": 19085,
    "state": "IA",
    "area_name": "Harrison County"
  },
  {
    "fips": 19087,
    "state": "IA",
    "area_name": "Henry County"
  },
  {
    "fips": 19089,
    "state": "IA",
    "area_name": "Howard County"
  },
  {
    "fips": 19091,
    "state": "IA",
    "area_name": "Humboldt County"
  },
  {
    "fips": 19093,
    "state": "IA",
    "area_name": "Ida County"
  },
  {
    "fips": 19095,
    "state": "IA",
    "area_name": "Iowa County"
  },
  {
    "fips": 19097,
    "state": "IA",
    "area_name": "Jackson County"
  },
  {
    "fips": 19099,
    "state": "IA",
    "area_name": "Jasper County"
  },
  {
    "fips": 19101,
    "state": "IA",
    "area_name": "Jefferson County"
  },
  {
    "fips": 19103,
    "state": "IA",
    "area_name": "Johnson County"
  },
  {
    "fips": 19105,
    "state": "IA",
    "area_name": "Jones County"
  },
  {
    "fips": 19107,
    "state": "IA",
    "area_name": "Keokuk County"
  },
  {
    "fips": 19109,
    "state": "IA",
    "area_name": "Kossuth County"
  },
  {
    "fips": 19111,
    "state": "IA",
    "area_name": "Lee County"
  },
  {
    "fips": 19113,
    "state": "IA",
    "area_name": "Linn County"
  },
  {
    "fips": 19115,
    "state": "IA",
    "area_name": "Louisa County"
  },
  {
    "fips": 19117,
    "state": "IA",
    "area_name": "Lucas County"
  },
  {
    "fips": 19119,
    "state": "IA",
    "area_name": "Lyon County"
  },
  {
    "fips": 19121,
    "state": "IA",
    "area_name": "Madison County"
  },
  {
    "fips": 19123,
    "state": "IA",
    "area_name": "Mahaska County"
  },
  {
    "fips": 19125,
    "state": "IA",
    "area_name": "Marion County"
  },
  {
    "fips": 19127,
    "state": "IA",
    "area_name": "Marshall County"
  },
  {
    "fips": 19129,
    "state": "IA",
    "area_name": "Mills County"
  },
  {
    "fips": 19131,
    "state": "IA",
    "area_name": "Mitchell County"
  },
  {
    "fips": 19133,
    "state": "IA",
    "area_name": "Monona County"
  },
  {
    "fips": 19135,
    "state": "IA",
    "area_name": "Monroe County"
  },
  {
    "fips": 19137,
    "state": "IA",
    "area_name": "Montgomery County"
  },
  {
    "fips": 19139,
    "state": "IA",
    "area_name": "Muscatine County"
  },
  {
    "fips": 19141,
    "state": "IA",
    "area_name": "O'Brien County"
  },
  {
    "fips": 19143,
    "state": "IA",
    "area_name": "Osceola County"
  },
  {
    "fips": 19145,
    "state": "IA",
    "area_name": "Page County"
  },
  {
    "fips": 19147,
    "state": "IA",
    "area_name": "Palo Alto County"
  },
  {
    "fips": 19149,
    "state": "IA",
    "area_name": "Plymouth County"
  },
  {
    "fips": 19151,
    "state": "IA",
    "area_name": "Pocahontas County"
  },
  {
    "fips": 19153,
    "state": "IA",
    "area_name": "Polk County"
  },
  {
    "fips": 19155,
    "state": "IA",
    "area_name": "Pottawattamie County"
  },
  {
    "fips": 19157,
    "state": "IA",
    "area_name": "Poweshiek County"
  },
  {
    "fips": 19159,
    "state": "IA",
    "area_name": "Ringgold County"
  },
  {
    "fips": 19161,
    "state": "IA",
    "area_name": "Sac County"
  },
  {
    "fips": 19163,
    "state": "IA",
    "area_name": "Scott County"
  },
  {
    "fips": 19165,
    "state": "IA",
    "area_name": "Shelby County"
  },
  {
    "fips": 19167,
    "state": "IA",
    "area_name": "Sioux County"
  },
  {
    "fips": 19169,
    "state": "IA",
    "area_name": "Story County"
  },
  {
    "fips": 19171,
    "state": "IA",
    "area_name": "Tama County"
  },
  {
    "fips": 19173,
    "state": "IA",
    "area_name": "Taylor County"
  },
  {
    "fips": 19175,
    "state": "IA",
    "area_name": "Union County"
  },
  {
    "fips": 19177,
    "state": "IA",
    "area_name": "Van Buren County"
  },
  {
    "fips": 19179,
    "state": "IA",
    "area_name": "Wapello County"
  },
  {
    "fips": 19181,
    "state": "IA",
    "area_name": "Warren County"
  },
  {
    "fips": 19183,
    "state": "IA",
    "area_name": "Washington County"
  },
  {
    "fips": 19185,
    "state": "IA",
    "area_name": "Wayne County"
  },
  {
    "fips": 19187,
    "state": "IA",
    "area_name": "Webster County"
  },
  {
    "fips": 19189,
    "state": "IA",
    "area_name": "Winnebago County"
  },
  {
    "fips": 19191,
    "state": "IA",
    "area_name": "Winneshiek County"
  },
  {
    "fips": 19193,
    "state": "IA",
    "area_name": "Woodbury County"
  },
  {
    "fips": 19195,
    "state": "IA",
    "area_name": "Worth County"
  },
  {
    "fips": 19197,
    "state": "IA",
    "area_name": "Wright County"
  },
  {
    "fips": 20001,
    "state": "KS",
    "area_name": "Allen County"
  },
  {
    "fips": 20003,
    "state": "KS",
    "area_name": "Anderson County"
  },
  {
    "fips": 20005,
    "state": "KS",
    "area_name": "Atchison County"
  },
  {
    "fips": 20007,
    "state": "KS",
    "area_name": "Barber County"
  },
  {
    "fips": 20009,
    "state": "KS",
    "area_name": "Barton County"
  },
  {
    "fips": 20011,
    "state": "KS",
    "area_name": "Bourbon County"
  },
  {
    "fips": 20013,
    "state": "KS",
    "area_name": "Brown County"
  },
  {
    "fips": 20015,
    "state": "KS",
    "area_name": "Butler County"
  },
  {
    "fips": 20017,
    "state": "KS",
    "area_name": "Chase County"
  },
  {
    "fips": 20019,
    "state": "KS",
    "area_name": "Chautauqua County"
  },
  {
    "fips": 20021,
    "state": "KS",
    "area_name": "Cherokee County"
  },
  {
    "fips": 20023,
    "state": "KS",
    "area_name": "Cheyenne County"
  },
  {
    "fips": 20025,
    "state": "KS",
    "area_name": "Clark County"
  },
  {
    "fips": 20027,
    "state": "KS",
    "area_name": "Clay County"
  },
  {
    "fips": 20029,
    "state": "KS",
    "area_name": "Cloud County"
  },
  {
    "fips": 20031,
    "state": "KS",
    "area_name": "Coffey County"
  },
  {
    "fips": 20033,
    "state": "KS",
    "area_name": "Comanche County"
  },
  {
    "fips": 20035,
    "state": "KS",
    "area_name": "Cowley County"
  },
  {
    "fips": 20037,
    "state": "KS",
    "area_name": "Crawford County"
  },
  {
    "fips": 20039,
    "state": "KS",
    "area_name": "Decatur County"
  },
  {
    "fips": 20041,
    "state": "KS",
    "area_name": "Dickinson County"
  },
  {
    "fips": 20043,
    "state": "KS",
    "area_name": "Doniphan County"
  },
  {
    "fips": 20045,
    "state": "KS",
    "area_name": "Douglas County"
  },
  {
    "fips": 20047,
    "state": "KS",
    "area_name": "Edwards County"
  },
  {
    "fips": 20049,
    "state": "KS",
    "area_name": "Elk County"
  },
  {
    "fips": 20051,
    "state": "KS",
    "area_name": "Ellis County"
  },
  {
    "fips": 20053,
    "state": "KS",
    "area_name": "Ellsworth County"
  },
  {
    "fips": 20055,
    "state": "KS",
    "area_name": "Finney County"
  },
  {
    "fips": 20057,
    "state": "KS",
    "area_name": "Ford County"
  },
  {
    "fips": 20059,
    "state": "KS",
    "area_name": "Franklin County"
  },
  {
    "fips": 20061,
    "state": "KS",
    "area_name": "Geary County"
  },
  {
    "fips": 20063,
    "state": "KS",
    "area_name": "Gove County"
  },
  {
    "fips": 20065,
    "state": "KS",
    "area_name": "Graham County"
  },
  {
    "fips": 20067,
    "state": "KS",
    "area_name": "Grant County"
  },
  {
    "fips": 20069,
    "state": "KS",
    "area_name": "Gray County"
  },
  {
    "fips": 20071,
    "state": "KS",
    "area_name": "Greeley County"
  },
  {
    "fips": 20073,
    "state": "KS",
    "area_name": "Greenwood County"
  },
  {
    "fips": 20075,
    "state": "KS",
    "area_name": "Hamilton County"
  },
  {
    "fips": 20077,
    "state": "KS",
    "area_name": "Harper County"
  },
  {
    "fips": 20079,
    "state": "KS",
    "area_name": "Harvey County"
  },
  {
    "fips": 20081,
    "state": "KS",
    "area_name": "Haskell County"
  },
  {
    "fips": 20083,
    "state": "KS",
    "area_name": "Hodgeman County"
  },
  {
    "fips": 20085,
    "state": "KS",
    "area_name": "Jackson County"
  },
  {
    "fips": 20087,
    "state": "KS",
    "area_name": "Jefferson County"
  },
  {
    "fips": 20089,
    "state": "KS",
    "area_name": "Jewell County"
  },
  {
    "fips": 20091,
    "state": "KS",
    "area_name": "Johnson County"
  },
  {
    "fips": 20093,
    "state": "KS",
    "area_name": "Kearny County"
  },
  {
    "fips": 20095,
    "state": "KS",
    "area_name": "Kingman County"
  },
  {
    "fips": 20097,
    "state": "KS",
    "area_name": "Kiowa County"
  },
  {
    "fips": 20099,
    "state": "KS",
    "area_name": "Labette County"
  },
  {
    "fips": 20101,
    "state": "KS",
    "area_name": "Lane County"
  },
  {
    "fips": 20103,
    "state": "KS",
    "area_name": "Leavenworth County"
  },
  {
    "fips": 20105,
    "state": "KS",
    "area_name": "Lincoln County"
  },
  {
    "fips": 20107,
    "state": "KS",
    "area_name": "Linn County"
  },
  {
    "fips": 20109,
    "state": "KS",
    "area_name": "Logan County"
  },
  {
    "fips": 20111,
    "state": "KS",
    "area_name": "Lyon County"
  },
  {
    "fips": 20113,
    "state": "KS",
    "area_name": "McPherson County"
  },
  {
    "fips": 20115,
    "state": "KS",
    "area_name": "Marion County"
  },
  {
    "fips": 20117,
    "state": "KS",
    "area_name": "Marshall County"
  },
  {
    "fips": 20119,
    "state": "KS",
    "area_name": "Meade County"
  },
  {
    "fips": 20121,
    "state": "KS",
    "area_name": "Miami County"
  },
  {
    "fips": 20123,
    "state": "KS",
    "area_name": "Mitchell County"
  },
  {
    "fips": 20125,
    "state": "KS",
    "area_name": "Montgomery County"
  },
  {
    "fips": 20127,
    "state": "KS",
    "area_name": "Morris County"
  },
  {
    "fips": 20129,
    "state": "KS",
    "area_name": "Morton County"
  },
  {
    "fips": 20131,
    "state": "KS",
    "area_name": "Nemaha County"
  },
  {
    "fips": 20133,
    "state": "KS",
    "area_name": "Neosho County"
  },
  {
    "fips": 20135,
    "state": "KS",
    "area_name": "Ness County"
  },
  {
    "fips": 20137,
    "state": "KS",
    "area_name": "Norton County"
  },
  {
    "fips": 20139,
    "state": "KS",
    "area_name": "Osage County"
  },
  {
    "fips": 20141,
    "state": "KS",
    "area_name": "Osborne County"
  },
  {
    "fips": 20143,
    "state": "KS",
    "area_name": "Ottawa County"
  },
  {
    "fips": 20145,
    "state": "KS",
    "area_name": "Pawnee County"
  },
  {
    "fips": 20147,
    "state": "KS",
    "area_name": "Phillips County"
  },
  {
    "fips": 20149,
    "state": "KS",
    "area_name": "Pottawatomie County"
  },
  {
    "fips": 20151,
    "state": "KS",
    "area_name": "Pratt County"
  },
  {
    "fips": 20153,
    "state": "KS",
    "area_name": "Rawlins County"
  },
  {
    "fips": 20155,
    "state": "KS",
    "area_name": "Reno County"
  },
  {
    "fips": 20157,
    "state": "KS",
    "area_name": "Republic County"
  },
  {
    "fips": 20159,
    "state": "KS",
    "area_name": "Rice County"
  },
  {
    "fips": 20161,
    "state": "KS",
    "area_name": "Riley County"
  },
  {
    "fips": 20163,
    "state": "KS",
    "area_name": "Rooks County"
  },
  {
    "fips": 20165,
    "state": "KS",
    "area_name": "Rush County"
  },
  {
    "fips": 20167,
    "state": "KS",
    "area_name": "Russell County"
  },
  {
    "fips": 20169,
    "state": "KS",
    "area_name": "Saline County"
  },
  {
    "fips": 20171,
    "state": "KS",
    "area_name": "Scott County"
  },
  {
    "fips": 20173,
    "state": "KS",
    "area_name": "Sedgwick County"
  },
  {
    "fips": 20175,
    "state": "KS",
    "area_name": "Seward County"
  },
  {
    "fips": 20177,
    "state": "KS",
    "area_name": "Shawnee County"
  },
  {
    "fips": 20179,
    "state": "KS",
    "area_name": "Sheridan County"
  },
  {
    "fips": 20181,
    "state": "KS",
    "area_name": "Sherman County"
  },
  {
    "fips": 20183,
    "state": "KS",
    "area_name": "Smith County"
  },
  {
    "fips": 20185,
    "state": "KS",
    "area_name": "Stafford County"
  },
  {
    "fips": 20187,
    "state": "KS",
    "area_name": "Stanton County"
  },
  {
    "fips": 20189,
    "state": "KS",
    "area_name": "Stevens County"
  },
  {
    "fips": 20191,
    "state": "KS",
    "area_name": "Sumner County"
  },
  {
    "fips": 20193,
    "state": "KS",
    "area_name": "Thomas County"
  },
  {
    "fips": 20195,
    "state": "KS",
    "area_name": "Trego County"
  },
  {
    "fips": 20197,
    "state": "KS",
    "area_name": "Wabaunsee County"
  },
  {
    "fips": 20199,
    "state": "KS",
    "area_name": "Wallace County"
  },
  {
    "fips": 20201,
    "state": "KS",
    "area_name": "Washington County"
  },
  {
    "fips": 20203,
    "state": "KS",
    "area_name": "Wichita County"
  },
  {
    "fips": 20205,
    "state": "KS",
    "area_name": "Wilson County"
  },
  {
    "fips": 20207,
    "state": "KS",
    "area_name": "Woodson County"
  },
  {
    "fips": 20209,
    "state": "KS",
    "area_name": "Wyandotte County"
  },
  {
    "fips": 21001,
    "state": "KY",
    "area_name": "Adair County"
  },
  {
    "fips": 21003,
    "state": "KY",
    "area_name": "Allen County"
  },
  {
    "fips": 21005,
    "state": "KY",
    "area_name": "Anderson County"
  },
  {
    "fips": 21007,
    "state": "KY",
    "area_name": "Ballard County"
  },
  {
    "fips": 21009,
    "state": "KY",
    "area_name": "Barren County"
  },
  {
    "fips": 21011,
    "state": "KY",
    "area_name": "Bath County"
  },
  {
    "fips": 21013,
    "state": "KY",
    "area_name": "Bell County"
  },
  {
    "fips": 21015,
    "state": "KY",
    "area_name": "Boone County"
  },
  {
    "fips": 21017,
    "state": "KY",
    "area_name": "Bourbon County"
  },
  {
    "fips": 21019,
    "state": "KY",
    "area_name": "Boyd County"
  },
  {
    "fips": 21021,
    "state": "KY",
    "area_name": "Boyle County"
  },
  {
    "fips": 21023,
    "state": "KY",
    "area_name": "Bracken County"
  },
  {
    "fips": 21025,
    "state": "KY",
    "area_name": "Breathitt County"
  },
  {
    "fips": 21027,
    "state": "KY",
    "area_name": "Breckinridge County"
  },
  {
    "fips": 21029,
    "state": "KY",
    "area_name": "Bullitt County"
  },
  {
    "fips": 21031,
    "state": "KY",
    "area_name": "Butler County"
  },
  {
    "fips": 21033,
    "state": "KY",
    "area_name": "Caldwell County"
  },
  {
    "fips": 21035,
    "state": "KY",
    "area_name": "Calloway County"
  },
  {
    "fips": 21037,
    "state": "KY",
    "area_name": "Campbell County"
  },
  {
    "fips": 21039,
    "state": "KY",
    "area_name": "Carlisle County"
  },
  {
    "fips": 21041,
    "state": "KY",
    "area_name": "Carroll County"
  },
  {
    "fips": 21043,
    "state": "KY",
    "area_name": "Carter County"
  },
  {
    "fips": 21045,
    "state": "KY",
    "area_name": "Casey County"
  },
  {
    "fips": 21047,
    "state": "KY",
    "area_name": "Christian County"
  },
  {
    "fips": 21049,
    "state": "KY",
    "area_name": "Clark County"
  },
  {
    "fips": 21051,
    "state": "KY",
    "area_name": "Clay County"
  },
  {
    "fips": 21053,
    "state": "KY",
    "area_name": "Clinton County"
  },
  {
    "fips": 21055,
    "state": "KY",
    "area_name": "Crittenden County"
  },
  {
    "fips": 21057,
    "state": "KY",
    "area_name": "Cumberland County"
  },
  {
    "fips": 21059,
    "state": "KY",
    "area_name": "Daviess County"
  },
  {
    "fips": 21061,
    "state": "KY",
    "area_name": "Edmonson County"
  },
  {
    "fips": 21063,
    "state": "KY",
    "area_name": "Elliott County"
  },
  {
    "fips": 21065,
    "state": "KY",
    "area_name": "Estill County"
  },
  {
    "fips": 21067,
    "state": "KY",
    "area_name": "Fayette County"
  },
  {
    "fips": 21069,
    "state": "KY",
    "area_name": "Fleming County"
  },
  {
    "fips": 21071,
    "state": "KY",
    "area_name": "Floyd County"
  },
  {
    "fips": 21073,
    "state": "KY",
    "area_name": "Franklin County"
  },
  {
    "fips": 21075,
    "state": "KY",
    "area_name": "Fulton County"
  },
  {
    "fips": 21077,
    "state": "KY",
    "area_name": "Gallatin County"
  },
  {
    "fips": 21079,
    "state": "KY",
    "area_name": "Garrard County"
  },
  {
    "fips": 21081,
    "state": "KY",
    "area_name": "Grant County"
  },
  {
    "fips": 21083,
    "state": "KY",
    "area_name": "Graves County"
  },
  {
    "fips": 21085,
    "state": "KY",
    "area_name": "Grayson County"
  },
  {
    "fips": 21087,
    "state": "KY",
    "area_name": "Green County"
  },
  {
    "fips": 21089,
    "state": "KY",
    "area_name": "Greenup County"
  },
  {
    "fips": 21091,
    "state": "KY",
    "area_name": "Hancock County"
  },
  {
    "fips": 21093,
    "state": "KY",
    "area_name": "Hardin County"
  },
  {
    "fips": 21095,
    "state": "KY",
    "area_name": "Harlan County"
  },
  {
    "fips": 21097,
    "state": "KY",
    "area_name": "Harrison County"
  },
  {
    "fips": 21099,
    "state": "KY",
    "area_name": "Hart County"
  },
  {
    "fips": 21101,
    "state": "KY",
    "area_name": "Henderson County"
  },
  {
    "fips": 21103,
    "state": "KY",
    "area_name": "Henry County"
  },
  {
    "fips": 21105,
    "state": "KY",
    "area_name": "Hickman County"
  },
  {
    "fips": 21107,
    "state": "KY",
    "area_name": "Hopkins County"
  },
  {
    "fips": 21109,
    "state": "KY",
    "area_name": "Jackson County"
  },
  {
    "fips": 21111,
    "state": "KY",
    "area_name": "Jefferson County"
  },
  {
    "fips": 21113,
    "state": "KY",
    "area_name": "Jessamine County"
  },
  {
    "fips": 21115,
    "state": "KY",
    "area_name": "Johnson County"
  },
  {
    "fips": 21117,
    "state": "KY",
    "area_name": "Kenton County"
  },
  {
    "fips": 21119,
    "state": "KY",
    "area_name": "Knott County"
  },
  {
    "fips": 21121,
    "state": "KY",
    "area_name": "Knox County"
  },
  {
    "fips": 21123,
    "state": "KY",
    "area_name": "Larue County"
  },
  {
    "fips": 21125,
    "state": "KY",
    "area_name": "Laurel County"
  },
  {
    "fips": 21127,
    "state": "KY",
    "area_name": "Lawrence County"
  },
  {
    "fips": 21129,
    "state": "KY",
    "area_name": "Lee County"
  },
  {
    "fips": 21131,
    "state": "KY",
    "area_name": "Leslie County"
  },
  {
    "fips": 21133,
    "state": "KY",
    "area_name": "Letcher County"
  },
  {
    "fips": 21135,
    "state": "KY",
    "area_name": "Lewis County"
  },
  {
    "fips": 21137,
    "state": "KY",
    "area_name": "Lincoln County"
  },
  {
    "fips": 21139,
    "state": "KY",
    "area_name": "Livingston County"
  },
  {
    "fips": 21141,
    "state": "KY",
    "area_name": "Logan County"
  },
  {
    "fips": 21143,
    "state": "KY",
    "area_name": "Lyon County"
  },
  {
    "fips": 21145,
    "state": "KY",
    "area_name": "McCracken County"
  },
  {
    "fips": 21147,
    "state": "KY",
    "area_name": "McCreary County"
  },
  {
    "fips": 21149,
    "state": "KY",
    "area_name": "McLean County"
  },
  {
    "fips": 21151,
    "state": "KY",
    "area_name": "Madison County"
  },
  {
    "fips": 21153,
    "state": "KY",
    "area_name": "Magoffin County"
  },
  {
    "fips": 21155,
    "state": "KY",
    "area_name": "Marion County"
  },
  {
    "fips": 21157,
    "state": "KY",
    "area_name": "Marshall County"
  },
  {
    "fips": 21159,
    "state": "KY",
    "area_name": "Martin County"
  },
  {
    "fips": 21161,
    "state": "KY",
    "area_name": "Mason County"
  },
  {
    "fips": 21163,
    "state": "KY",
    "area_name": "Meade County"
  },
  {
    "fips": 21165,
    "state": "KY",
    "area_name": "Menifee County"
  },
  {
    "fips": 21167,
    "state": "KY",
    "area_name": "Mercer County"
  },
  {
    "fips": 21169,
    "state": "KY",
    "area_name": "Metcalfe County"
  },
  {
    "fips": 21171,
    "state": "KY",
    "area_name": "Monroe County"
  },
  {
    "fips": 21173,
    "state": "KY",
    "area_name": "Montgomery County"
  },
  {
    "fips": 21175,
    "state": "KY",
    "area_name": "Morgan County"
  },
  {
    "fips": 21177,
    "state": "KY",
    "area_name": "Muhlenberg County"
  },
  {
    "fips": 21179,
    "state": "KY",
    "area_name": "Nelson County"
  },
  {
    "fips": 21181,
    "state": "KY",
    "area_name": "Nicholas County"
  },
  {
    "fips": 21183,
    "state": "KY",
    "area_name": "Ohio County"
  },
  {
    "fips": 21185,
    "state": "KY",
    "area_name": "Oldham County"
  },
  {
    "fips": 21187,
    "state": "KY",
    "area_name": "Owen County"
  },
  {
    "fips": 21189,
    "state": "KY",
    "area_name": "Owsley County"
  },
  {
    "fips": 21191,
    "state": "KY",
    "area_name": "Pendleton County"
  },
  {
    "fips": 21193,
    "state": "KY",
    "area_name": "Perry County"
  },
  {
    "fips": 21195,
    "state": "KY",
    "area_name": "Pike County"
  },
  {
    "fips": 21197,
    "state": "KY",
    "area_name": "Powell County"
  },
  {
    "fips": 21199,
    "state": "KY",
    "area_name": "Pulaski County"
  },
  {
    "fips": 21201,
    "state": "KY",
    "area_name": "Robertson County"
  },
  {
    "fips": 21203,
    "state": "KY",
    "area_name": "Rockcastle County"
  },
  {
    "fips": 21205,
    "state": "KY",
    "area_name": "Rowan County"
  },
  {
    "fips": 21207,
    "state": "KY",
    "area_name": "Russell County"
  },
  {
    "fips": 21209,
    "state": "KY",
    "area_name": "Scott County"
  },
  {
    "fips": 21211,
    "state": "KY",
    "area_name": "Shelby County"
  },
  {
    "fips": 21213,
    "state": "KY",
    "area_name": "Simpson County"
  },
  {
    "fips": 21215,
    "state": "KY",
    "area_name": "Spencer County"
  },
  {
    "fips": 21217,
    "state": "KY",
    "area_name": "Taylor County"
  },
  {
    "fips": 21219,
    "state": "KY",
    "area_name": "Todd County"
  },
  {
    "fips": 21221,
    "state": "KY",
    "area_name": "Trigg County"
  },
  {
    "fips": 21223,
    "state": "KY",
    "area_name": "Trimble County"
  },
  {
    "fips": 21225,
    "state": "KY",
    "area_name": "Union County"
  },
  {
    "fips": 21227,
    "state": "KY",
    "area_name": "Warren County"
  },
  {
    "fips": 21229,
    "state": "KY",
    "area_name": "Washington County"
  },
  {
    "fips": 21231,
    "state": "KY",
    "area_name": "Wayne County"
  },
  {
    "fips": 21233,
    "state": "KY",
    "area_name": "Webster County"
  },
  {
    "fips": 21235,
    "state": "KY",
    "area_name": "Whitley County"
  },
  {
    "fips": 21237,
    "state": "KY",
    "area_name": "Wolfe County"
  },
  {
    "fips": 21239,
    "state": "KY",
    "area_name": "Woodford County"
  },
  {
    "fips": 22001,
    "state": "LA",
    "area_name": "Acadia Parish"
  },
  {
    "fips": 22003,
    "state": "LA",
    "area_name": "Allen Parish"
  },
  {
    "fips": 22005,
    "state": "LA",
    "area_name": "Ascension Parish"
  },
  {
    "fips": 22007,
    "state": "LA",
    "area_name": "Assumption Parish"
  },
  {
    "fips": 22009,
    "state": "LA",
    "area_name": "Avoyelles Parish"
  },
  {
    "fips": 22011,
    "state": "LA",
    "area_name": "Beauregard Parish"
  },
  {
    "fips": 22013,
    "state": "LA",
    "area_name": "Bienville Parish"
  },
  {
    "fips": 22015,
    "state": "LA",
    "area_name": "Bossier Parish"
  },
  {
    "fips": 22017,
    "state": "LA",
    "area_name": "Caddo Parish"
  },
  {
    "fips": 22019,
    "state": "LA",
    "area_name": "Calcasieu Parish"
  },
  {
    "fips": 22021,
    "state": "LA",
    "area_name": "Caldwell Parish"
  },
  {
    "fips": 22023,
    "state": "LA",
    "area_name": "Cameron Parish"
  },
  {
    "fips": 22025,
    "state": "LA",
    "area_name": "Catahoula Parish"
  },
  {
    "fips": 22027,
    "state": "LA",
    "area_name": "Claiborne Parish"
  },
  {
    "fips": 22029,
    "state": "LA",
    "area_name": "Concordia Parish"
  },
  {
    "fips": 22031,
    "state": "LA",
    "area_name": "De Soto Parish"
  },
  {
    "fips": 22033,
    "state": "LA",
    "area_name": "East Baton Rouge Parish"
  },
  {
    "fips": 22035,
    "state": "LA",
    "area_name": "East Carroll Parish"
  },
  {
    "fips": 22037,
    "state": "LA",
    "area_name": "East Feliciana Parish"
  },
  {
    "fips": 22039,
    "state": "LA",
    "area_name": "Evangeline Parish"
  },
  {
    "fips": 22041,
    "state": "LA",
    "area_name": "Franklin Parish"
  },
  {
    "fips": 22043,
    "state": "LA",
    "area_name": "Grant Parish"
  },
  {
    "fips": 22045,
    "state": "LA",
    "area_name": "Iberia Parish"
  },
  {
    "fips": 22047,
    "state": "LA",
    "area_name": "Iberville Parish"
  },
  {
    "fips": 22049,
    "state": "LA",
    "area_name": "Jackson Parish"
  },
  {
    "fips": 22051,
    "state": "LA",
    "area_name": "Jefferson Parish"
  },
  {
    "fips": 22053,
    "state": "LA",
    "area_name": "Jefferson Davis Parish"
  },
  {
    "fips": 22055,
    "state": "LA",
    "area_name": "Lafayette Parish"
  },
  {
    "fips": 22057,
    "state": "LA",
    "area_name": "Lafourche Parish"
  },
  {
    "fips": 22059,
    "state": "LA",
    "area_name": "La Salle Parish"
  },
  {
    "fips": 22061,
    "state": "LA",
    "area_name": "Lincoln Parish"
  },
  {
    "fips": 22063,
    "state": "LA",
    "area_name": "Livingston Parish"
  },
  {
    "fips": 22065,
    "state": "LA",
    "area_name": "Madison Parish"
  },
  {
    "fips": 22067,
    "state": "LA",
    "area_name": "Morehouse Parish"
  },
  {
    "fips": 22069,
    "state": "LA",
    "area_name": "Natchitoches Parish"
  },
  {
    "fips": 22071,
    "state": "LA",
    "area_name": "Orleans Parish"
  },
  {
    "fips": 22073,
    "state": "LA",
    "area_name": "Ouachita Parish"
  },
  {
    "fips": 22075,
    "state": "LA",
    "area_name": "Plaquemines Parish"
  },
  {
    "fips": 22077,
    "state": "LA",
    "area_name": "Pointe Coupee Parish"
  },
  {
    "fips": 22079,
    "state": "LA",
    "area_name": "Rapides Parish"
  },
  {
    "fips": 22081,
    "state": "LA",
    "area_name": "Red River Parish"
  },
  {
    "fips": 22083,
    "state": "LA",
    "area_name": "Richland Parish"
  },
  {
    "fips": 22085,
    "state": "LA",
    "area_name": "Sabine Parish"
  },
  {
    "fips": 22087,
    "state": "LA",
    "area_name": "St. Bernard Parish"
  },
  {
    "fips": 22089,
    "state": "LA",
    "area_name": "St. Charles Parish"
  },
  {
    "fips": 22091,
    "state": "LA",
    "area_name": "St. Helena Parish"
  },
  {
    "fips": 22093,
    "state": "LA",
    "area_name": "St. James Parish"
  },
  {
    "fips": 22095,
    "state": "LA",
    "area_name": "St. John the Baptist Parish"
  },
  {
    "fips": 22097,
    "state": "LA",
    "area_name": "St. Landry Parish"
  },
  {
    "fips": 22099,
    "state": "LA",
    "area_name": "St. Martin Parish"
  },
  {
    "fips": 22101,
    "state": "LA",
    "area_name": "St. Mary Parish"
  },
  {
    "fips": 22103,
    "state": "LA",
    "area_name": "St. Tammany Parish"
  },
  {
    "fips": 22105,
    "state": "LA",
    "area_name": "Tangipahoa Parish"
  },
  {
    "fips": 22107,
    "state": "LA",
    "area_name": "Tensas Parish"
  },
  {
    "fips": 22109,
    "state": "LA",
    "area_name": "Terrebonne Parish"
  },
  {
    "fips": 22111,
    "state": "LA",
    "area_name": "Union Parish"
  },
  {
    "fips": 22113,
    "state": "LA",
    "area_name": "Vermilion Parish"
  },
  {
    "fips": 22115,
    "state": "LA",
    "area_name": "Vernon Parish"
  },
  {
    "fips": 22117,
    "state": "LA",
    "area_name": "Washington Parish"
  },
  {
    "fips": 22119,
    "state": "LA",
    "area_name": "Webster Parish"
  },
  {
    "fips": 22121,
    "state": "LA",
    "area_name": "West Baton Rouge Parish"
  },
  {
    "fips": 22123,
    "state": "LA",
    "area_name": "West Carroll Parish"
  },
  {
    "fips": 22125,
    "state": "LA",
    "area_name": "West Feliciana Parish"
  },
  {
    "fips": 22127,
    "state": "LA",
    "area_name": "Winn Parish"
  },
  {
    "fips": 23001,
    "state": "ME",
    "area_name": "Androscoggin County"
  },
  {
    "fips": 23003,
    "state": "ME",
    "area_name": "Aroostook County"
  },
  {
    "fips": 23005,
    "state": "ME",
    "area_name": "Cumberland County"
  },
  {
    "fips": 23007,
    "state": "ME",
    "area_name": "Franklin County"
  },
  {
    "fips": 23009,
    "state": "ME",
    "area_name": "Hancock County"
  },
  {
    "fips": 23011,
    "state": "ME",
    "area_name": "Kennebec County"
  },
  {
    "fips": 23013,
    "state": "ME",
    "area_name": "Knox County"
  },
  {
    "fips": 23015,
    "state": "ME",
    "area_name": "Lincoln County"
  },
  {
    "fips": 23017,
    "state": "ME",
    "area_name": "Oxford County"
  },
  {
    "fips": 23019,
    "state": "ME",
    "area_name": "Penobscot County"
  },
  {
    "fips": 23021,
    "state": "ME",
    "area_name": "Piscataquis County"
  },
  {
    "fips": 23023,
    "state": "ME",
    "area_name": "Sagadahoc County"
  },
  {
    "fips": 23025,
    "state": "ME",
    "area_name": "Somerset County"
  },
  {
    "fips": 23027,
    "state": "ME",
    "area_name": "Waldo County"
  },
  {
    "fips": 23029,
    "state": "ME",
    "area_name": "Washington County"
  },
  {
    "fips": 23031,
    "state": "ME",
    "area_name": "York County"
  },
  {
    "fips": 24001,
    "state": "MD",
    "area_name": "Allegany County"
  },
  {
    "fips": 24003,
    "state": "MD",
    "area_name": "Anne Arundel County"
  },
  {
    "fips": 24005,
    "state": "MD",
    "area_name": "Baltimore County"
  },
  {
    "fips": 24009,
    "state": "MD",
    "area_name": "Calvert County"
  },
  {
    "fips": 24011,
    "state": "MD",
    "area_name": "Caroline County"
  },
  {
    "fips": 24013,
    "state": "MD",
    "area_name": "Carroll County"
  },
  {
    "fips": 24015,
    "state": "MD",
    "area_name": "Cecil County"
  },
  {
    "fips": 24017,
    "state": "MD",
    "area_name": "Charles County"
  },
  {
    "fips": 24019,
    "state": "MD",
    "area_name": "Dorchester County"
  },
  {
    "fips": 24021,
    "state": "MD",
    "area_name": "Frederick County"
  },
  {
    "fips": 24023,
    "state": "MD",
    "area_name": "Garrett County"
  },
  {
    "fips": 24025,
    "state": "MD",
    "area_name": "Harford County"
  },
  {
    "fips": 24027,
    "state": "MD",
    "area_name": "Howard County"
  },
  {
    "fips": 24029,
    "state": "MD",
    "area_name": "Kent County"
  },
  {
    "fips": 24031,
    "state": "MD",
    "area_name": "Montgomery County"
  },
  {
    "fips": 24033,
    "state": "MD",
    "area_name": "Prince George's County"
  },
  {
    "fips": 24035,
    "state": "MD",
    "area_name": "Queen Anne's County"
  },
  {
    "fips": 24037,
    "state": "MD",
    "area_name": "St. Mary's County"
  },
  {
    "fips": 24039,
    "state": "MD",
    "area_name": "Somerset County"
  },
  {
    "fips": 24041,
    "state": "MD",
    "area_name": "Talbot County"
  },
  {
    "fips": 24043,
    "state": "MD",
    "area_name": "Washington County"
  },
  {
    "fips": 24045,
    "state": "MD",
    "area_name": "Wicomico County"
  },
  {
    "fips": 24047,
    "state": "MD",
    "area_name": "Worcester County"
  },
  {
    "fips": 24510,
    "state": "MD",
    "area_name": "Baltimore city"
  },
  {
    "fips": 25001,
    "state": "MA",
    "area_name": "Barnstable County"
  },
  {
    "fips": 25003,
    "state": "MA",
    "area_name": "Berkshire County"
  },
  {
    "fips": 25005,
    "state": "MA",
    "area_name": "Bristol County"
  },
  {
    "fips": 25007,
    "state": "MA",
    "area_name": "Dukes County"
  },
  {
    "fips": 25009,
    "state": "MA",
    "area_name": "Essex County"
  },
  {
    "fips": 25011,
    "state": "MA",
    "area_name": "Franklin County"
  },
  {
    "fips": 25013,
    "state": "MA",
    "area_name": "Hampden County"
  },
  {
    "fips": 25015,
    "state": "MA",
    "area_name": "Hampshire County"
  },
  {
    "fips": 25017,
    "state": "MA",
    "area_name": "Middlesex County"
  },
  {
    "fips": 25019,
    "state": "MA",
    "area_name": "Nantucket County"
  },
  {
    "fips": 25021,
    "state": "MA",
    "area_name": "Norfolk County"
  },
  {
    "fips": 25023,
    "state": "MA",
    "area_name": "Plymouth County"
  },
  {
    "fips": 25025,
    "state": "MA",
    "area_name": "Suffolk County"
  },
  {
    "fips": 25027,
    "state": "MA",
    "area_name": "Worcester County"
  },
  {
    "fips": 26001,
    "state": "MI",
    "area_name": "Alcona County"
  },
  {
    "fips": 26003,
    "state": "MI",
    "area_name": "Alger County"
  },
  {
    "fips": 26005,
    "state": "MI",
    "area_name": "Allegan County"
  },
  {
    "fips": 26007,
    "state": "MI",
    "area_name": "Alpena County"
  },
  {
    "fips": 26009,
    "state": "MI",
    "area_name": "Antrim County"
  },
  {
    "fips": 26011,
    "state": "MI",
    "area_name": "Arenac County"
  },
  {
    "fips": 26013,
    "state": "MI",
    "area_name": "Baraga County"
  },
  {
    "fips": 26015,
    "state": "MI",
    "area_name": "Barry County"
  },
  {
    "fips": 26017,
    "state": "MI",
    "area_name": "Bay County"
  },
  {
    "fips": 26019,
    "state": "MI",
    "area_name": "Benzie County"
  },
  {
    "fips": 26021,
    "state": "MI",
    "area_name": "Berrien County"
  },
  {
    "fips": 26023,
    "state": "MI",
    "area_name": "Branch County"
  },
  {
    "fips": 26025,
    "state": "MI",
    "area_name": "Calhoun County"
  },
  {
    "fips": 26027,
    "state": "MI",
    "area_name": "Cass County"
  },
  {
    "fips": 26029,
    "state": "MI",
    "area_name": "Charlevoix County"
  },
  {
    "fips": 26031,
    "state": "MI",
    "area_name": "Cheboygan County"
  },
  {
    "fips": 26033,
    "state": "MI",
    "area_name": "Chippewa County"
  },
  {
    "fips": 26035,
    "state": "MI",
    "area_name": "Clare County"
  },
  {
    "fips": 26037,
    "state": "MI",
    "area_name": "Clinton County"
  },
  {
    "fips": 26039,
    "state": "MI",
    "area_name": "Crawford County"
  },
  {
    "fips": 26041,
    "state": "MI",
    "area_name": "Delta County"
  },
  {
    "fips": 26043,
    "state": "MI",
    "area_name": "Dickinson County"
  },
  {
    "fips": 26045,
    "state": "MI",
    "area_name": "Eaton County"
  },
  {
    "fips": 26047,
    "state": "MI",
    "area_name": "Emmet County"
  },
  {
    "fips": 26049,
    "state": "MI",
    "area_name": "Genesee County"
  },
  {
    "fips": 26051,
    "state": "MI",
    "area_name": "Gladwin County"
  },
  {
    "fips": 26053,
    "state": "MI",
    "area_name": "Gogebic County"
  },
  {
    "fips": 26055,
    "state": "MI",
    "area_name": "Grand Traverse County"
  },
  {
    "fips": 26057,
    "state": "MI",
    "area_name": "Gratiot County"
  },
  {
    "fips": 26059,
    "state": "MI",
    "area_name": "Hillsdale County"
  },
  {
    "fips": 26061,
    "state": "MI",
    "area_name": "Houghton County"
  },
  {
    "fips": 26063,
    "state": "MI",
    "area_name": "Huron County"
  },
  {
    "fips": 26065,
    "state": "MI",
    "area_name": "Ingham County"
  },
  {
    "fips": 26067,
    "state": "MI",
    "area_name": "Ionia County"
  },
  {
    "fips": 26069,
    "state": "MI",
    "area_name": "Iosco County"
  },
  {
    "fips": 26071,
    "state": "MI",
    "area_name": "Iron County"
  },
  {
    "fips": 26073,
    "state": "MI",
    "area_name": "Isabella County"
  },
  {
    "fips": 26075,
    "state": "MI",
    "area_name": "Jackson County"
  },
  {
    "fips": 26077,
    "state": "MI",
    "area_name": "Kalamazoo County"
  },
  {
    "fips": 26079,
    "state": "MI",
    "area_name": "Kalkaska County"
  },
  {
    "fips": 26081,
    "state": "MI",
    "area_name": "Kent County"
  },
  {
    "fips": 26083,
    "state": "MI",
    "area_name": "Keweenaw County"
  },
  {
    "fips": 26085,
    "state": "MI",
    "area_name": "Lake County"
  },
  {
    "fips": 26087,
    "state": "MI",
    "area_name": "Lapeer County"
  },
  {
    "fips": 26089,
    "state": "MI",
    "area_name": "Leelanau County"
  },
  {
    "fips": 26091,
    "state": "MI",
    "area_name": "Lenawee County"
  },
  {
    "fips": 26093,
    "state": "MI",
    "area_name": "Livingston County"
  },
  {
    "fips": 26095,
    "state": "MI",
    "area_name": "Luce County"
  },
  {
    "fips": 26097,
    "state": "MI",
    "area_name": "Mackinac County"
  },
  {
    "fips": 26099,
    "state": "MI",
    "area_name": "Macomb County"
  },
  {
    "fips": 26101,
    "state": "MI",
    "area_name": "Manistee County"
  },
  {
    "fips": 26103,
    "state": "MI",
    "area_name": "Marquette County"
  },
  {
    "fips": 26105,
    "state": "MI",
    "area_name": "Mason County"
  },
  {
    "fips": 26107,
    "state": "MI",
    "area_name": "Mecosta County"
  },
  {
    "fips": 26109,
    "state": "MI",
    "area_name": "Menominee County"
  },
  {
    "fips": 26111,
    "state": "MI",
    "area_name": "Midland County"
  },
  {
    "fips": 26113,
    "state": "MI",
    "area_name": "Missaukee County"
  },
  {
    "fips": 26115,
    "state": "MI",
    "area_name": "Monroe County"
  },
  {
    "fips": 26117,
    "state": "MI",
    "area_name": "Montcalm County"
  },
  {
    "fips": 26119,
    "state": "MI",
    "area_name": "Montmorency County"
  },
  {
    "fips": 26121,
    "state": "MI",
    "area_name": "Muskegon County"
  },
  {
    "fips": 26123,
    "state": "MI",
    "area_name": "Newaygo County"
  },
  {
    "fips": 26125,
    "state": "MI",
    "area_name": "Oakland County"
  },
  {
    "fips": 26127,
    "state": "MI",
    "area_name": "Oceana County"
  },
  {
    "fips": 26129,
    "state": "MI",
    "area_name": "Ogemaw County"
  },
  {
    "fips": 26131,
    "state": "MI",
    "area_name": "Ontonagon County"
  },
  {
    "fips": 26133,
    "state": "MI",
    "area_name": "Osceola County"
  },
  {
    "fips": 26135,
    "state": "MI",
    "area_name": "Oscoda County"
  },
  {
    "fips": 26137,
    "state": "MI",
    "area_name": "Otsego County"
  },
  {
    "fips": 26139,
    "state": "MI",
    "area_name": "Ottawa County"
  },
  {
    "fips": 26141,
    "state": "MI",
    "area_name": "Presque Isle County"
  },
  {
    "fips": 26143,
    "state": "MI",
    "area_name": "Roscommon County"
  },
  {
    "fips": 26145,
    "state": "MI",
    "area_name": "Saginaw County"
  },
  {
    "fips": 26147,
    "state": "MI",
    "area_name": "St. Clair County"
  },
  {
    "fips": 26149,
    "state": "MI",
    "area_name": "St. Joseph County"
  },
  {
    "fips": 26151,
    "state": "MI",
    "area_name": "Sanilac County"
  },
  {
    "fips": 26153,
    "state": "MI",
    "area_name": "Schoolcraft County"
  },
  {
    "fips": 26155,
    "state": "MI",
    "area_name": "Shiawassee County"
  },
  {
    "fips": 26157,
    "state": "MI",
    "area_name": "Tuscola County"
  },
  {
    "fips": 26159,
    "state": "MI",
    "area_name": "Van Buren County"
  },
  {
    "fips": 26161,
    "state": "MI",
    "area_name": "Washtenaw County"
  },
  {
    "fips": 26163,
    "state": "MI",
    "area_name": "Wayne County"
  },
  {
    "fips": 26165,
    "state": "MI",
    "area_name": "Wexford County"
  },
  {
    "fips": 27001,
    "state": "MN",
    "area_name": "Aitkin County"
  },
  {
    "fips": 27003,
    "state": "MN",
    "area_name": "Anoka County"
  },
  {
    "fips": 27005,
    "state": "MN",
    "area_name": "Becker County"
  },
  {
    "fips": 27007,
    "state": "MN",
    "area_name": "Beltrami County"
  },
  {
    "fips": 27009,
    "state": "MN",
    "area_name": "Benton County"
  },
  {
    "fips": 27011,
    "state": "MN",
    "area_name": "Big Stone County"
  },
  {
    "fips": 27013,
    "state": "MN",
    "area_name": "Blue Earth County"
  },
  {
    "fips": 27015,
    "state": "MN",
    "area_name": "Brown County"
  },
  {
    "fips": 27017,
    "state": "MN",
    "area_name": "Carlton County"
  },
  {
    "fips": 27019,
    "state": "MN",
    "area_name": "Carver County"
  },
  {
    "fips": 27021,
    "state": "MN",
    "area_name": "Cass County"
  },
  {
    "fips": 27023,
    "state": "MN",
    "area_name": "Chippewa County"
  },
  {
    "fips": 27025,
    "state": "MN",
    "area_name": "Chisago County"
  },
  {
    "fips": 27027,
    "state": "MN",
    "area_name": "Clay County"
  },
  {
    "fips": 27029,
    "state": "MN",
    "area_name": "Clearwater County"
  },
  {
    "fips": 27031,
    "state": "MN",
    "area_name": "Cook County"
  },
  {
    "fips": 27033,
    "state": "MN",
    "area_name": "Cottonwood County"
  },
  {
    "fips": 27035,
    "state": "MN",
    "area_name": "Crow Wing County"
  },
  {
    "fips": 27037,
    "state": "MN",
    "area_name": "Dakota County"
  },
  {
    "fips": 27039,
    "state": "MN",
    "area_name": "Dodge County"
  },
  {
    "fips": 27041,
    "state": "MN",
    "area_name": "Douglas County"
  },
  {
    "fips": 27043,
    "state": "MN",
    "area_name": "Faribault County"
  },
  {
    "fips": 27045,
    "state": "MN",
    "area_name": "Fillmore County"
  },
  {
    "fips": 27047,
    "state": "MN",
    "area_name": "Freeborn County"
  },
  {
    "fips": 27049,
    "state": "MN",
    "area_name": "Goodhue County"
  },
  {
    "fips": 27051,
    "state": "MN",
    "area_name": "Grant County"
  },
  {
    "fips": 27053,
    "state": "MN",
    "area_name": "Hennepin County"
  },
  {
    "fips": 27055,
    "state": "MN",
    "area_name": "Houston County"
  },
  {
    "fips": 27057,
    "state": "MN",
    "area_name": "Hubbard County"
  },
  {
    "fips": 27059,
    "state": "MN",
    "area_name": "Isanti County"
  },
  {
    "fips": 27061,
    "state": "MN",
    "area_name": "Itasca County"
  },
  {
    "fips": 27063,
    "state": "MN",
    "area_name": "Jackson County"
  },
  {
    "fips": 27065,
    "state": "MN",
    "area_name": "Kanabec County"
  },
  {
    "fips": 27067,
    "state": "MN",
    "area_name": "Kandiyohi County"
  },
  {
    "fips": 27069,
    "state": "MN",
    "area_name": "Kittson County"
  },
  {
    "fips": 27071,
    "state": "MN",
    "area_name": "Koochiching County"
  },
  {
    "fips": 27073,
    "state": "MN",
    "area_name": "Lac qui Parle County"
  },
  {
    "fips": 27075,
    "state": "MN",
    "area_name": "Lake County"
  },
  {
    "fips": 27077,
    "state": "MN",
    "area_name": "Lake of the Woods County"
  },
  {
    "fips": 27079,
    "state": "MN",
    "area_name": "Le Sueur County"
  },
  {
    "fips": 27081,
    "state": "MN",
    "area_name": "Lincoln County"
  },
  {
    "fips": 27083,
    "state": "MN",
    "area_name": "Lyon County"
  },
  {
    "fips": 27085,
    "state": "MN",
    "area_name": "McLeod County"
  },
  {
    "fips": 27087,
    "state": "MN",
    "area_name": "Mahnomen County"
  },
  {
    "fips": 27089,
    "state": "MN",
    "area_name": "Marshall County"
  },
  {
    "fips": 27091,
    "state": "MN",
    "area_name": "Martin County"
  },
  {
    "fips": 27093,
    "state": "MN",
    "area_name": "Meeker County"
  },
  {
    "fips": 27095,
    "state": "MN",
    "area_name": "Mille Lacs County"
  },
  {
    "fips": 27097,
    "state": "MN",
    "area_name": "Morrison County"
  },
  {
    "fips": 27099,
    "state": "MN",
    "area_name": "Mower County"
  },
  {
    "fips": 27101,
    "state": "MN",
    "area_name": "Murray County"
  },
  {
    "fips": 27103,
    "state": "MN",
    "area_name": "Nicollet County"
  },
  {
    "fips": 27105,
    "state": "MN",
    "area_name": "Nobles County"
  },
  {
    "fips": 27107,
    "state": "MN",
    "area_name": "Norman County"
  },
  {
    "fips": 27109,
    "state": "MN",
    "area_name": "Olmsted County"
  },
  {
    "fips": 27111,
    "state": "MN",
    "area_name": "Otter Tail County"
  },
  {
    "fips": 27113,
    "state": "MN",
    "area_name": "Pennington County"
  },
  {
    "fips": 27115,
    "state": "MN",
    "area_name": "Pine County"
  },
  {
    "fips": 27117,
    "state": "MN",
    "area_name": "Pipestone County"
  },
  {
    "fips": 27119,
    "state": "MN",
    "area_name": "Polk County"
  },
  {
    "fips": 27121,
    "state": "MN",
    "area_name": "Pope County"
  },
  {
    "fips": 27123,
    "state": "MN",
    "area_name": "Ramsey County"
  },
  {
    "fips": 27125,
    "state": "MN",
    "area_name": "Red Lake County"
  },
  {
    "fips": 27127,
    "state": "MN",
    "area_name": "Redwood County"
  },
  {
    "fips": 27129,
    "state": "MN",
    "area_name": "Renville County"
  },
  {
    "fips": 27131,
    "state": "MN",
    "area_name": "Rice County"
  },
  {
    "fips": 27133,
    "state": "MN",
    "area_name": "Rock County"
  },
  {
    "fips": 27135,
    "state": "MN",
    "area_name": "Roseau County"
  },
  {
    "fips": 27137,
    "state": "MN",
    "area_name": "St. Louis County"
  },
  {
    "fips": 27139,
    "state": "MN",
    "area_name": "Scott County"
  },
  {
    "fips": 27141,
    "state": "MN",
    "area_name": "Sherburne County"
  },
  {
    "fips": 27143,
    "state": "MN",
    "area_name": "Sibley County"
  },
  {
    "fips": 27145,
    "state": "MN",
    "area_name": "Stearns County"
  },
  {
    "fips": 27147,
    "state": "MN",
    "area_name": "Steele County"
  },
  {
    "fips": 27149,
    "state": "MN",
    "area_name": "Stevens County"
  },
  {
    "fips": 27151,
    "state": "MN",
    "area_name": "Swift County"
  },
  {
    "fips": 27153,
    "state": "MN",
    "area_name": "Todd County"
  },
  {
    "fips": 27155,
    "state": "MN",
    "area_name": "Traverse County"
  },
  {
    "fips": 27157,
    "state": "MN",
    "area_name": "Wabasha County"
  },
  {
    "fips": 27159,
    "state": "MN",
    "area_name": "Wadena County"
  },
  {
    "fips": 27161,
    "state": "MN",
    "area_name": "Waseca County"
  },
  {
    "fips": 27163,
    "state": "MN",
    "area_name": "Washington County"
  },
  {
    "fips": 27165,
    "state": "MN",
    "area_name": "Watonwan County"
  },
  {
    "fips": 27167,
    "state": "MN",
    "area_name": "Wilkin County"
  },
  {
    "fips": 27169,
    "state": "MN",
    "area_name": "Winona County"
  },
  {
    "fips": 27171,
    "state": "MN",
    "area_name": "Wright County"
  },
  {
    "fips": 27173,
    "state": "MN",
    "area_name": "Yellow Medicine County"
  },
  {
    "fips": 28001,
    "state": "MS",
    "area_name": "Adams County"
  },
  {
    "fips": 28003,
    "state": "MS",
    "area_name": "Alcorn County"
  },
  {
    "fips": 28005,
    "state": "MS",
    "area_name": "Amite County"
  },
  {
    "fips": 28007,
    "state": "MS",
    "area_name": "Attala County"
  },
  {
    "fips": 28009,
    "state": "MS",
    "area_name": "Benton County"
  },
  {
    "fips": 28011,
    "state": "MS",
    "area_name": "Bolivar County"
  },
  {
    "fips": 28013,
    "state": "MS",
    "area_name": "Calhoun County"
  },
  {
    "fips": 28015,
    "state": "MS",
    "area_name": "Carroll County"
  },
  {
    "fips": 28017,
    "state": "MS",
    "area_name": "Chickasaw County"
  },
  {
    "fips": 28019,
    "state": "MS",
    "area_name": "Choctaw County"
  },
  {
    "fips": 28021,
    "state": "MS",
    "area_name": "Claiborne County"
  },
  {
    "fips": 28023,
    "state": "MS",
    "area_name": "Clarke County"
  },
  {
    "fips": 28025,
    "state": "MS",
    "area_name": "Clay County"
  },
  {
    "fips": 28027,
    "state": "MS",
    "area_name": "Coahoma County"
  },
  {
    "fips": 28029,
    "state": "MS",
    "area_name": "Copiah County"
  },
  {
    "fips": 28031,
    "state": "MS",
    "area_name": "Covington County"
  },
  {
    "fips": 28033,
    "state": "MS",
    "area_name": "DeSoto County"
  },
  {
    "fips": 28035,
    "state": "MS",
    "area_name": "Forrest County"
  },
  {
    "fips": 28037,
    "state": "MS",
    "area_name": "Franklin County"
  },
  {
    "fips": 28039,
    "state": "MS",
    "area_name": "George County"
  },
  {
    "fips": 28041,
    "state": "MS",
    "area_name": "Greene County"
  },
  {
    "fips": 28043,
    "state": "MS",
    "area_name": "Grenada County"
  },
  {
    "fips": 28045,
    "state": "MS",
    "area_name": "Hancock County"
  },
  {
    "fips": 28047,
    "state": "MS",
    "area_name": "Harrison County"
  },
  {
    "fips": 28049,
    "state": "MS",
    "area_name": "Hinds County"
  },
  {
    "fips": 28051,
    "state": "MS",
    "area_name": "Holmes County"
  },
  {
    "fips": 28053,
    "state": "MS",
    "area_name": "Humphreys County"
  },
  {
    "fips": 28055,
    "state": "MS",
    "area_name": "Issaquena County"
  },
  {
    "fips": 28057,
    "state": "MS",
    "area_name": "Itawamba County"
  },
  {
    "fips": 28059,
    "state": "MS",
    "area_name": "Jackson County"
  },
  {
    "fips": 28061,
    "state": "MS",
    "area_name": "Jasper County"
  },
  {
    "fips": 28063,
    "state": "MS",
    "area_name": "Jefferson County"
  },
  {
    "fips": 28065,
    "state": "MS",
    "area_name": "Jefferson Davis County"
  },
  {
    "fips": 28067,
    "state": "MS",
    "area_name": "Jones County"
  },
  {
    "fips": 28069,
    "state": "MS",
    "area_name": "Kemper County"
  },
  {
    "fips": 28071,
    "state": "MS",
    "area_name": "Lafayette County"
  },
  {
    "fips": 28073,
    "state": "MS",
    "area_name": "Lamar County"
  },
  {
    "fips": 28075,
    "state": "MS",
    "area_name": "Lauderdale County"
  },
  {
    "fips": 28077,
    "state": "MS",
    "area_name": "Lawrence County"
  },
  {
    "fips": 28079,
    "state": "MS",
    "area_name": "Leake County"
  },
  {
    "fips": 28081,
    "state": "MS",
    "area_name": "Lee County"
  },
  {
    "fips": 28083,
    "state": "MS",
    "area_name": "Leflore County"
  },
  {
    "fips": 28085,
    "state": "MS",
    "area_name": "Lincoln County"
  },
  {
    "fips": 28087,
    "state": "MS",
    "area_name": "Lowndes County"
  },
  {
    "fips": 28089,
    "state": "MS",
    "area_name": "Madison County"
  },
  {
    "fips": 28091,
    "state": "MS",
    "area_name": "Marion County"
  },
  {
    "fips": 28093,
    "state": "MS",
    "area_name": "Marshall County"
  },
  {
    "fips": 28095,
    "state": "MS",
    "area_name": "Monroe County"
  },
  {
    "fips": 28097,
    "state": "MS",
    "area_name": "Montgomery County"
  },
  {
    "fips": 28099,
    "state": "MS",
    "area_name": "Neshoba County"
  },
  {
    "fips": 28101,
    "state": "MS",
    "area_name": "Newton County"
  },
  {
    "fips": 28103,
    "state": "MS",
    "area_name": "Noxubee County"
  },
  {
    "fips": 28105,
    "state": "MS",
    "area_name": "Oktibbeha County"
  },
  {
    "fips": 28107,
    "state": "MS",
    "area_name": "Panola County"
  },
  {
    "fips": 28109,
    "state": "MS",
    "area_name": "Pearl River County"
  },
  {
    "fips": 28111,
    "state": "MS",
    "area_name": "Perry County"
  },
  {
    "fips": 28113,
    "state": "MS",
    "area_name": "Pike County"
  },
  {
    "fips": 28115,
    "state": "MS",
    "area_name": "Pontotoc County"
  },
  {
    "fips": 28117,
    "state": "MS",
    "area_name": "Prentiss County"
  },
  {
    "fips": 28119,
    "state": "MS",
    "area_name": "Quitman County"
  },
  {
    "fips": 28121,
    "state": "MS",
    "area_name": "Rankin County"
  },
  {
    "fips": 28123,
    "state": "MS",
    "area_name": "Scott County"
  },
  {
    "fips": 28125,
    "state": "MS",
    "area_name": "Sharkey County"
  },
  {
    "fips": 28127,
    "state": "MS",
    "area_name": "Simpson County"
  },
  {
    "fips": 28129,
    "state": "MS",
    "area_name": "Smith County"
  },
  {
    "fips": 28131,
    "state": "MS",
    "area_name": "Stone County"
  },
  {
    "fips": 28133,
    "state": "MS",
    "area_name": "Sunflower County"
  },
  {
    "fips": 28135,
    "state": "MS",
    "area_name": "Tallahatchie County"
  },
  {
    "fips": 28137,
    "state": "MS",
    "area_name": "Tate County"
  },
  {
    "fips": 28139,
    "state": "MS",
    "area_name": "Tippah County"
  },
  {
    "fips": 28141,
    "state": "MS",
    "area_name": "Tishomingo County"
  },
  {
    "fips": 28143,
    "state": "MS",
    "area_name": "Tunica County"
  },
  {
    "fips": 28145,
    "state": "MS",
    "area_name": "Union County"
  },
  {
    "fips": 28147,
    "state": "MS",
    "area_name": "Walthall County"
  },
  {
    "fips": 28149,
    "state": "MS",
    "area_name": "Warren County"
  },
  {
    "fips": 28151,
    "state": "MS",
    "area_name": "Washington County"
  },
  {
    "fips": 28153,
    "state": "MS",
    "area_name": "Wayne County"
  },
  {
    "fips": 28155,
    "state": "MS",
    "area_name": "Webster County"
  },
  {
    "fips": 28157,
    "state": "MS",
    "area_name": "Wilkinson County"
  },
  {
    "fips": 28159,
    "state": "MS",
    "area_name": "Winston County"
  },
  {
    "fips": 28161,
    "state": "MS",
    "area_name": "Yalobusha County"
  },
  {
    "fips": 28163,
    "state": "MS",
    "area_name": "Yazoo County"
  },
  {
    "fips": 29001,
    "state": "MO",
    "area_name": "Adair County"
  },
  {
    "fips": 29003,
    "state": "MO",
    "area_name": "Andrew County"
  },
  {
    "fips": 29005,
    "state": "MO",
    "area_name": "Atchison County"
  },
  {
    "fips": 29007,
    "state": "MO",
    "area_name": "Audrain County"
  },
  {
    "fips": 29009,
    "state": "MO",
    "area_name": "Barry County"
  },
  {
    "fips": 29011,
    "state": "MO",
    "area_name": "Barton County"
  },
  {
    "fips": 29013,
    "state": "MO",
    "area_name": "Bates County"
  },
  {
    "fips": 29015,
    "state": "MO",
    "area_name": "Benton County"
  },
  {
    "fips": 29017,
    "state": "MO",
    "area_name": "Bollinger County"
  },
  {
    "fips": 29019,
    "state": "MO",
    "area_name": "Boone County"
  },
  {
    "fips": 29021,
    "state": "MO",
    "area_name": "Buchanan County"
  },
  {
    "fips": 29023,
    "state": "MO",
    "area_name": "Butler County"
  },
  {
    "fips": 29025,
    "state": "MO",
    "area_name": "Caldwell County"
  },
  {
    "fips": 29027,
    "state": "MO",
    "area_name": "Callaway County"
  },
  {
    "fips": 29029,
    "state": "MO",
    "area_name": "Camden County"
  },
  {
    "fips": 29031,
    "state": "MO",
    "area_name": "Cape Girardeau County"
  },
  {
    "fips": 29033,
    "state": "MO",
    "area_name": "Carroll County"
  },
  {
    "fips": 29035,
    "state": "MO",
    "area_name": "Carter County"
  },
  {
    "fips": 29037,
    "state": "MO",
    "area_name": "Cass County"
  },
  {
    "fips": 29039,
    "state": "MO",
    "area_name": "Cedar County"
  },
  {
    "fips": 29041,
    "state": "MO",
    "area_name": "Chariton County"
  },
  {
    "fips": 29043,
    "state": "MO",
    "area_name": "Christian County"
  },
  {
    "fips": 29045,
    "state": "MO",
    "area_name": "Clark County"
  },
  {
    "fips": 29047,
    "state": "MO",
    "area_name": "Clay County"
  },
  {
    "fips": 29049,
    "state": "MO",
    "area_name": "Clinton County"
  },
  {
    "fips": 29051,
    "state": "MO",
    "area_name": "Cole County"
  },
  {
    "fips": 29053,
    "state": "MO",
    "area_name": "Cooper County"
  },
  {
    "fips": 29055,
    "state": "MO",
    "area_name": "Crawford County"
  },
  {
    "fips": 29057,
    "state": "MO",
    "area_name": "Dade County"
  },
  {
    "fips": 29059,
    "state": "MO",
    "area_name": "Dallas County"
  },
  {
    "fips": 29061,
    "state": "MO",
    "area_name": "Daviess County"
  },
  {
    "fips": 29063,
    "state": "MO",
    "area_name": "DeKalb County"
  },
  {
    "fips": 29065,
    "state": "MO",
    "area_name": "Dent County"
  },
  {
    "fips": 29067,
    "state": "MO",
    "area_name": "Douglas County"
  },
  {
    "fips": 29069,
    "state": "MO",
    "area_name": "Dunklin County"
  },
  {
    "fips": 29071,
    "state": "MO",
    "area_name": "Franklin County"
  },
  {
    "fips": 29073,
    "state": "MO",
    "area_name": "Gasconade County"
  },
  {
    "fips": 29075,
    "state": "MO",
    "area_name": "Gentry County"
  },
  {
    "fips": 29077,
    "state": "MO",
    "area_name": "Greene County"
  },
  {
    "fips": 29079,
    "state": "MO",
    "area_name": "Grundy County"
  },
  {
    "fips": 29081,
    "state": "MO",
    "area_name": "Harrison County"
  },
  {
    "fips": 29083,
    "state": "MO",
    "area_name": "Henry County"
  },
  {
    "fips": 29085,
    "state": "MO",
    "area_name": "Hickory County"
  },
  {
    "fips": 29087,
    "state": "MO",
    "area_name": "Holt County"
  },
  {
    "fips": 29089,
    "state": "MO",
    "area_name": "Howard County"
  },
  {
    "fips": 29091,
    "state": "MO",
    "area_name": "Howell County"
  },
  {
    "fips": 29093,
    "state": "MO",
    "area_name": "Iron County"
  },
  {
    "fips": 29095,
    "state": "MO",
    "area_name": "Jackson County"
  },
  {
    "fips": 29097,
    "state": "MO",
    "area_name": "Jasper County"
  },
  {
    "fips": 29099,
    "state": "MO",
    "area_name": "Jefferson County"
  },
  {
    "fips": 29101,
    "state": "MO",
    "area_name": "Johnson County"
  },
  {
    "fips": 29103,
    "state": "MO",
    "area_name": "Knox County"
  },
  {
    "fips": 29105,
    "state": "MO",
    "area_name": "Laclede County"
  },
  {
    "fips": 29107,
    "state": "MO",
    "area_name": "Lafayette County"
  },
  {
    "fips": 29109,
    "state": "MO",
    "area_name": "Lawrence County"
  },
  {
    "fips": 29111,
    "state": "MO",
    "area_name": "Lewis County"
  },
  {
    "fips": 29113,
    "state": "MO",
    "area_name": "Lincoln County"
  },
  {
    "fips": 29115,
    "state": "MO",
    "area_name": "Linn County"
  },
  {
    "fips": 29117,
    "state": "MO",
    "area_name": "Livingston County"
  },
  {
    "fips": 29119,
    "state": "MO",
    "area_name": "McDonald County"
  },
  {
    "fips": 29121,
    "state": "MO",
    "area_name": "Macon County"
  },
  {
    "fips": 29123,
    "state": "MO",
    "area_name": "Madison County"
  },
  {
    "fips": 29125,
    "state": "MO",
    "area_name": "Maries County"
  },
  {
    "fips": 29127,
    "state": "MO",
    "area_name": "Marion County"
  },
  {
    "fips": 29129,
    "state": "MO",
    "area_name": "Mercer County"
  },
  {
    "fips": 29131,
    "state": "MO",
    "area_name": "Miller County"
  },
  {
    "fips": 29133,
    "state": "MO",
    "area_name": "Mississippi County"
  },
  {
    "fips": 29135,
    "state": "MO",
    "area_name": "Moniteau County"
  },
  {
    "fips": 29137,
    "state": "MO",
    "area_name": "Monroe County"
  },
  {
    "fips": 29139,
    "state": "MO",
    "area_name": "Montgomery County"
  },
  {
    "fips": 29141,
    "state": "MO",
    "area_name": "Morgan County"
  },
  {
    "fips": 29143,
    "state": "MO",
    "area_name": "New Madrid County"
  },
  {
    "fips": 29145,
    "state": "MO",
    "area_name": "Newton County"
  },
  {
    "fips": 29147,
    "state": "MO",
    "area_name": "Nodaway County"
  },
  {
    "fips": 29149,
    "state": "MO",
    "area_name": "Oregon County"
  },
  {
    "fips": 29151,
    "state": "MO",
    "area_name": "Osage County"
  },
  {
    "fips": 29153,
    "state": "MO",
    "area_name": "Ozark County"
  },
  {
    "fips": 29155,
    "state": "MO",
    "area_name": "Pemiscot County"
  },
  {
    "fips": 29157,
    "state": "MO",
    "area_name": "Perry County"
  },
  {
    "fips": 29159,
    "state": "MO",
    "area_name": "Pettis County"
  },
  {
    "fips": 29161,
    "state": "MO",
    "area_name": "Phelps County"
  },
  {
    "fips": 29163,
    "state": "MO",
    "area_name": "Pike County"
  },
  {
    "fips": 29165,
    "state": "MO",
    "area_name": "Platte County"
  },
  {
    "fips": 29167,
    "state": "MO",
    "area_name": "Polk County"
  },
  {
    "fips": 29169,
    "state": "MO",
    "area_name": "Pulaski County"
  },
  {
    "fips": 29171,
    "state": "MO",
    "area_name": "Putnam County"
  },
  {
    "fips": 29173,
    "state": "MO",
    "area_name": "Ralls County"
  },
  {
    "fips": 29175,
    "state": "MO",
    "area_name": "Randolph County"
  },
  {
    "fips": 29177,
    "state": "MO",
    "area_name": "Ray County"
  },
  {
    "fips": 29179,
    "state": "MO",
    "area_name": "Reynolds County"
  },
  {
    "fips": 29181,
    "state": "MO",
    "area_name": "Ripley County"
  },
  {
    "fips": 29183,
    "state": "MO",
    "area_name": "St. Charles County"
  },
  {
    "fips": 29185,
    "state": "MO",
    "area_name": "St. Clair County"
  },
  {
    "fips": 29186,
    "state": "MO",
    "area_name": "Ste. Genevieve County"
  },
  {
    "fips": 29187,
    "state": "MO",
    "area_name": "St. Francois County"
  },
  {
    "fips": 29189,
    "state": "MO",
    "area_name": "St. Louis County"
  },
  {
    "fips": 29195,
    "state": "MO",
    "area_name": "Saline County"
  },
  {
    "fips": 29197,
    "state": "MO",
    "area_name": "Schuyler County"
  },
  {
    "fips": 29199,
    "state": "MO",
    "area_name": "Scotland County"
  },
  {
    "fips": 29201,
    "state": "MO",
    "area_name": "Scott County"
  },
  {
    "fips": 29203,
    "state": "MO",
    "area_name": "Shannon County"
  },
  {
    "fips": 29205,
    "state": "MO",
    "area_name": "Shelby County"
  },
  {
    "fips": 29207,
    "state": "MO",
    "area_name": "Stoddard County"
  },
  {
    "fips": 29209,
    "state": "MO",
    "area_name": "Stone County"
  },
  {
    "fips": 29211,
    "state": "MO",
    "area_name": "Sullivan County"
  },
  {
    "fips": 29213,
    "state": "MO",
    "area_name": "Taney County"
  },
  {
    "fips": 29215,
    "state": "MO",
    "area_name": "Texas County"
  },
  {
    "fips": 29217,
    "state": "MO",
    "area_name": "Vernon County"
  },
  {
    "fips": 29219,
    "state": "MO",
    "area_name": "Warren County"
  },
  {
    "fips": 29221,
    "state": "MO",
    "area_name": "Washington County"
  },
  {
    "fips": 29223,
    "state": "MO",
    "area_name": "Wayne County"
  },
  {
    "fips": 29225,
    "state": "MO",
    "area_name": "Webster County"
  },
  {
    "fips": 29227,
    "state": "MO",
    "area_name": "Worth County"
  },
  {
    "fips": 29229,
    "state": "MO",
    "area_name": "Wright County"
  },
  {
    "fips": 29510,
    "state": "MO",
    "area_name": "St. Louis city"
  },
  {
    "fips": 30001,
    "state": "MT",
    "area_name": "Beaverhead County"
  },
  {
    "fips": 30003,
    "state": "MT",
    "area_name": "Big Horn County"
  },
  {
    "fips": 30005,
    "state": "MT",
    "area_name": "Blaine County"
  },
  {
    "fips": 30007,
    "state": "MT",
    "area_name": "Broadwater County"
  },
  {
    "fips": 30009,
    "state": "MT",
    "area_name": "Carbon County"
  },
  {
    "fips": 30011,
    "state": "MT",
    "area_name": "Carter County"
  },
  {
    "fips": 30013,
    "state": "MT",
    "area_name": "Cascade County"
  },
  {
    "fips": 30015,
    "state": "MT",
    "area_name": "Chouteau County"
  },
  {
    "fips": 30017,
    "state": "MT",
    "area_name": "Custer County"
  },
  {
    "fips": 30019,
    "state": "MT",
    "area_name": "Daniels County"
  },
  {
    "fips": 30021,
    "state": "MT",
    "area_name": "Dawson County"
  },
  {
    "fips": 30023,
    "state": "MT",
    "area_name": "Deer Lodge County"
  },
  {
    "fips": 30025,
    "state": "MT",
    "area_name": "Fallon County"
  },
  {
    "fips": 30027,
    "state": "MT",
    "area_name": "Fergus County"
  },
  {
    "fips": 30029,
    "state": "MT",
    "area_name": "Flathead County"
  },
  {
    "fips": 30031,
    "state": "MT",
    "area_name": "Gallatin County"
  },
  {
    "fips": 30033,
    "state": "MT",
    "area_name": "Garfield County"
  },
  {
    "fips": 30035,
    "state": "MT",
    "area_name": "Glacier County"
  },
  {
    "fips": 30037,
    "state": "MT",
    "area_name": "Golden Valley County"
  },
  {
    "fips": 30039,
    "state": "MT",
    "area_name": "Granite County"
  },
  {
    "fips": 30041,
    "state": "MT",
    "area_name": "Hill County"
  },
  {
    "fips": 30043,
    "state": "MT",
    "area_name": "Jefferson County"
  },
  {
    "fips": 30045,
    "state": "MT",
    "area_name": "Judith Basin County"
  },
  {
    "fips": 30047,
    "state": "MT",
    "area_name": "Lake County"
  },
  {
    "fips": 30049,
    "state": "MT",
    "area_name": "Lewis and Clark County"
  },
  {
    "fips": 30051,
    "state": "MT",
    "area_name": "Liberty County"
  },
  {
    "fips": 30053,
    "state": "MT",
    "area_name": "Lincoln County"
  },
  {
    "fips": 30055,
    "state": "MT",
    "area_name": "McCone County"
  },
  {
    "fips": 30057,
    "state": "MT",
    "area_name": "Madison County"
  },
  {
    "fips": 30059,
    "state": "MT",
    "area_name": "Meagher County"
  },
  {
    "fips": 30061,
    "state": "MT",
    "area_name": "Mineral County"
  },
  {
    "fips": 30063,
    "state": "MT",
    "area_name": "Missoula County"
  },
  {
    "fips": 30065,
    "state": "MT",
    "area_name": "Musselshell County"
  },
  {
    "fips": 30067,
    "state": "MT",
    "area_name": "Park County"
  },
  {
    "fips": 30069,
    "state": "MT",
    "area_name": "Petroleum County"
  },
  {
    "fips": 30071,
    "state": "MT",
    "area_name": "Phillips County"
  },
  {
    "fips": 30073,
    "state": "MT",
    "area_name": "Pondera County"
  },
  {
    "fips": 30075,
    "state": "MT",
    "area_name": "Powder River County"
  },
  {
    "fips": 30077,
    "state": "MT",
    "area_name": "Powell County"
  },
  {
    "fips": 30079,
    "state": "MT",
    "area_name": "Prairie County"
  },
  {
    "fips": 30081,
    "state": "MT",
    "area_name": "Ravalli County"
  },
  {
    "fips": 30083,
    "state": "MT",
    "area_name": "Richland County"
  },
  {
    "fips": 30085,
    "state": "MT",
    "area_name": "Roosevelt County"
  },
  {
    "fips": 30087,
    "state": "MT",
    "area_name": "Rosebud County"
  },
  {
    "fips": 30089,
    "state": "MT",
    "area_name": "Sanders County"
  },
  {
    "fips": 30091,
    "state": "MT",
    "area_name": "Sheridan County"
  },
  {
    "fips": 30093,
    "state": "MT",
    "area_name": "Silver Bow County"
  },
  {
    "fips": 30095,
    "state": "MT",
    "area_name": "Stillwater County"
  },
  {
    "fips": 30097,
    "state": "MT",
    "area_name": "Sweet Grass County"
  },
  {
    "fips": 30099,
    "state": "MT",
    "area_name": "Teton County"
  },
  {
    "fips": 30101,
    "state": "MT",
    "area_name": "Toole County"
  },
  {
    "fips": 30103,
    "state": "MT",
    "area_name": "Treasure County"
  },
  {
    "fips": 30105,
    "state": "MT",
    "area_name": "Valley County"
  },
  {
    "fips": 30107,
    "state": "MT",
    "area_name": "Wheatland County"
  },
  {
    "fips": 30109,
    "state": "MT",
    "area_name": "Wibaux County"
  },
  {
    "fips": 30111,
    "state": "MT",
    "area_name": "Yellowstone County"
  },
  {
    "fips": 31001,
    "state": "NE",
    "area_name": "Adams County"
  },
  {
    "fips": 31003,
    "state": "NE",
    "area_name": "Antelope County"
  },
  {
    "fips": 31005,
    "state": "NE",
    "area_name": "Arthur County"
  },
  {
    "fips": 31007,
    "state": "NE",
    "area_name": "Banner County"
  },
  {
    "fips": 31009,
    "state": "NE",
    "area_name": "Blaine County"
  },
  {
    "fips": 31011,
    "state": "NE",
    "area_name": "Boone County"
  },
  {
    "fips": 31013,
    "state": "NE",
    "area_name": "Box Butte County"
  },
  {
    "fips": 31015,
    "state": "NE",
    "area_name": "Boyd County"
  },
  {
    "fips": 31017,
    "state": "NE",
    "area_name": "Brown County"
  },
  {
    "fips": 31019,
    "state": "NE",
    "area_name": "Buffalo County"
  },
  {
    "fips": 31021,
    "state": "NE",
    "area_name": "Burt County"
  },
  {
    "fips": 31023,
    "state": "NE",
    "area_name": "Butler County"
  },
  {
    "fips": 31025,
    "state": "NE",
    "area_name": "Cass County"
  },
  {
    "fips": 31027,
    "state": "NE",
    "area_name": "Cedar County"
  },
  {
    "fips": 31029,
    "state": "NE",
    "area_name": "Chase County"
  },
  {
    "fips": 31031,
    "state": "NE",
    "area_name": "Cherry County"
  },
  {
    "fips": 31033,
    "state": "NE",
    "area_name": "Cheyenne County"
  },
  {
    "fips": 31035,
    "state": "NE",
    "area_name": "Clay County"
  },
  {
    "fips": 31037,
    "state": "NE",
    "area_name": "Colfax County"
  },
  {
    "fips": 31039,
    "state": "NE",
    "area_name": "Cuming County"
  },
  {
    "fips": 31041,
    "state": "NE",
    "area_name": "Custer County"
  },
  {
    "fips": 31043,
    "state": "NE",
    "area_name": "Dakota County"
  },
  {
    "fips": 31045,
    "state": "NE",
    "area_name": "Dawes County"
  },
  {
    "fips": 31047,
    "state": "NE",
    "area_name": "Dawson County"
  },
  {
    "fips": 31049,
    "state": "NE",
    "area_name": "Deuel County"
  },
  {
    "fips": 31051,
    "state": "NE",
    "area_name": "Dixon County"
  },
  {
    "fips": 31053,
    "state": "NE",
    "area_name": "Dodge County"
  },
  {
    "fips": 31055,
    "state": "NE",
    "area_name": "Douglas County"
  },
  {
    "fips": 31057,
    "state": "NE",
    "area_name": "Dundy County"
  },
  {
    "fips": 31059,
    "state": "NE",
    "area_name": "Fillmore County"
  },
  {
    "fips": 31061,
    "state": "NE",
    "area_name": "Franklin County"
  },
  {
    "fips": 31063,
    "state": "NE",
    "area_name": "Frontier County"
  },
  {
    "fips": 31065,
    "state": "NE",
    "area_name": "Furnas County"
  },
  {
    "fips": 31067,
    "state": "NE",
    "area_name": "Gage County"
  },
  {
    "fips": 31069,
    "state": "NE",
    "area_name": "Garden County"
  },
  {
    "fips": 31071,
    "state": "NE",
    "area_name": "Garfield County"
  },
  {
    "fips": 31073,
    "state": "NE",
    "area_name": "Gosper County"
  },
  {
    "fips": 31075,
    "state": "NE",
    "area_name": "Grant County"
  },
  {
    "fips": 31077,
    "state": "NE",
    "area_name": "Greeley County"
  },
  {
    "fips": 31079,
    "state": "NE",
    "area_name": "Hall County"
  },
  {
    "fips": 31081,
    "state": "NE",
    "area_name": "Hamilton County"
  },
  {
    "fips": 31083,
    "state": "NE",
    "area_name": "Harlan County"
  },
  {
    "fips": 31085,
    "state": "NE",
    "area_name": "Hayes County"
  },
  {
    "fips": 31087,
    "state": "NE",
    "area_name": "Hitchcock County"
  },
  {
    "fips": 31089,
    "state": "NE",
    "area_name": "Holt County"
  },
  {
    "fips": 31091,
    "state": "NE",
    "area_name": "Hooker County"
  },
  {
    "fips": 31093,
    "state": "NE",
    "area_name": "Howard County"
  },
  {
    "fips": 31095,
    "state": "NE",
    "area_name": "Jefferson County"
  },
  {
    "fips": 31097,
    "state": "NE",
    "area_name": "Johnson County"
  },
  {
    "fips": 31099,
    "state": "NE",
    "area_name": "Kearney County"
  },
  {
    "fips": 31101,
    "state": "NE",
    "area_name": "Keith County"
  },
  {
    "fips": 31103,
    "state": "NE",
    "area_name": "Keya Paha County"
  },
  {
    "fips": 31105,
    "state": "NE",
    "area_name": "Kimball County"
  },
  {
    "fips": 31107,
    "state": "NE",
    "area_name": "Knox County"
  },
  {
    "fips": 31109,
    "state": "NE",
    "area_name": "Lancaster County"
  },
  {
    "fips": 31111,
    "state": "NE",
    "area_name": "Lincoln County"
  },
  {
    "fips": 31113,
    "state": "NE",
    "area_name": "Logan County"
  },
  {
    "fips": 31115,
    "state": "NE",
    "area_name": "Loup County"
  },
  {
    "fips": 31117,
    "state": "NE",
    "area_name": "McPherson County"
  },
  {
    "fips": 31119,
    "state": "NE",
    "area_name": "Madison County"
  },
  {
    "fips": 31121,
    "state": "NE",
    "area_name": "Merrick County"
  },
  {
    "fips": 31123,
    "state": "NE",
    "area_name": "Morrill County"
  },
  {
    "fips": 31125,
    "state": "NE",
    "area_name": "Nance County"
  },
  {
    "fips": 31127,
    "state": "NE",
    "area_name": "Nemaha County"
  },
  {
    "fips": 31129,
    "state": "NE",
    "area_name": "Nuckolls County"
  },
  {
    "fips": 31131,
    "state": "NE",
    "area_name": "Otoe County"
  },
  {
    "fips": 31133,
    "state": "NE",
    "area_name": "Pawnee County"
  },
  {
    "fips": 31135,
    "state": "NE",
    "area_name": "Perkins County"
  },
  {
    "fips": 31137,
    "state": "NE",
    "area_name": "Phelps County"
  },
  {
    "fips": 31139,
    "state": "NE",
    "area_name": "Pierce County"
  },
  {
    "fips": 31141,
    "state": "NE",
    "area_name": "Platte County"
  },
  {
    "fips": 31143,
    "state": "NE",
    "area_name": "Polk County"
  },
  {
    "fips": 31145,
    "state": "NE",
    "area_name": "Red Willow County"
  },
  {
    "fips": 31147,
    "state": "NE",
    "area_name": "Richardson County"
  },
  {
    "fips": 31149,
    "state": "NE",
    "area_name": "Rock County"
  },
  {
    "fips": 31151,
    "state": "NE",
    "area_name": "Saline County"
  },
  {
    "fips": 31153,
    "state": "NE",
    "area_name": "Sarpy County"
  },
  {
    "fips": 31155,
    "state": "NE",
    "area_name": "Saunders County"
  },
  {
    "fips": 31157,
    "state": "NE",
    "area_name": "Scotts Bluff County"
  },
  {
    "fips": 31159,
    "state": "NE",
    "area_name": "Seward County"
  },
  {
    "fips": 31161,
    "state": "NE",
    "area_name": "Sheridan County"
  },
  {
    "fips": 31163,
    "state": "NE",
    "area_name": "Sherman County"
  },
  {
    "fips": 31165,
    "state": "NE",
    "area_name": "Sioux County"
  },
  {
    "fips": 31167,
    "state": "NE",
    "area_name": "Stanton County"
  },
  {
    "fips": 31169,
    "state": "NE",
    "area_name": "Thayer County"
  },
  {
    "fips": 31171,
    "state": "NE",
    "area_name": "Thomas County"
  },
  {
    "fips": 31173,
    "state": "NE",
    "area_name": "Thurston County"
  },
  {
    "fips": 31175,
    "state": "NE",
    "area_name": "Valley County"
  },
  {
    "fips": 31177,
    "state": "NE",
    "area_name": "Washington County"
  },
  {
    "fips": 31179,
    "state": "NE",
    "area_name": "Wayne County"
  },
  {
    "fips": 31181,
    "state": "NE",
    "area_name": "Webster County"
  },
  {
    "fips": 31183,
    "state": "NE",
    "area_name": "Wheeler County"
  },
  {
    "fips": 31185,
    "state": "NE",
    "area_name": "York County"
  },
  {
    "fips": 32001,
    "state": "NV",
    "area_name": "Churchill County"
  },
  {
    "fips": 32003,
    "state": "NV",
    "area_name": "Clark County"
  },
  {
    "fips": 32005,
    "state": "NV",
    "area_name": "Douglas County"
  },
  {
    "fips": 32007,
    "state": "NV",
    "area_name": "Elko County"
  },
  {
    "fips": 32009,
    "state": "NV",
    "area_name": "Esmeralda County"
  },
  {
    "fips": 32011,
    "state": "NV",
    "area_name": "Eureka County"
  },
  {
    "fips": 32013,
    "state": "NV",
    "area_name": "Humboldt County"
  },
  {
    "fips": 32015,
    "state": "NV",
    "area_name": "Lander County"
  },
  {
    "fips": 32017,
    "state": "NV",
    "area_name": "Lincoln County"
  },
  {
    "fips": 32019,
    "state": "NV",
    "area_name": "Lyon County"
  },
  {
    "fips": 32021,
    "state": "NV",
    "area_name": "Mineral County"
  },
  {
    "fips": 32023,
    "state": "NV",
    "area_name": "Nye County"
  },
  {
    "fips": 32027,
    "state": "NV",
    "area_name": "Pershing County"
  },
  {
    "fips": 32029,
    "state": "NV",
    "area_name": "Storey County"
  },
  {
    "fips": 32031,
    "state": "NV",
    "area_name": "Washoe County"
  },
  {
    "fips": 32033,
    "state": "NV",
    "area_name": "White Pine County"
  },
  {
    "fips": 32510,
    "state": "NV",
    "area_name": "Carson City"
  },
  {
    "fips": 33001,
    "state": "NH",
    "area_name": "Belknap County"
  },
  {
    "fips": 33003,
    "state": "NH",
    "area_name": "Carroll County"
  },
  {
    "fips": 33005,
    "state": "NH",
    "area_name": "Cheshire County"
  },
  {
    "fips": 33007,
    "state": "NH",
    "area_name": "Coos County"
  },
  {
    "fips": 33009,
    "state": "NH",
    "area_name": "Grafton County"
  },
  {
    "fips": 33011,
    "state": "NH",
    "area_name": "Hillsborough County"
  },
  {
    "fips": 33013,
    "state": "NH",
    "area_name": "Merrimack County"
  },
  {
    "fips": 33015,
    "state": "NH",
    "area_name": "Rockingham County"
  },
  {
    "fips": 33017,
    "state": "NH",
    "area_name": "Strafford County"
  },
  {
    "fips": 33019,
    "state": "NH",
    "area_name": "Sullivan County"
  },
  {
    "fips": 34001,
    "state": "NJ",
    "area_name": "Atlantic County"
  },
  {
    "fips": 34003,
    "state": "NJ",
    "area_name": "Bergen County"
  },
  {
    "fips": 34005,
    "state": "NJ",
    "area_name": "Burlington County"
  },
  {
    "fips": 34007,
    "state": "NJ",
    "area_name": "Camden County"
  },
  {
    "fips": 34009,
    "state": "NJ",
    "area_name": "Cape May County"
  },
  {
    "fips": 34011,
    "state": "NJ",
    "area_name": "Cumberland County"
  },
  {
    "fips": 34013,
    "state": "NJ",
    "area_name": "Essex County"
  },
  {
    "fips": 34015,
    "state": "NJ",
    "area_name": "Gloucester County"
  },
  {
    "fips": 34017,
    "state": "NJ",
    "area_name": "Hudson County"
  },
  {
    "fips": 34019,
    "state": "NJ",
    "area_name": "Hunterdon County"
  },
  {
    "fips": 34021,
    "state": "NJ",
    "area_name": "Mercer County"
  },
  {
    "fips": 34023,
    "state": "NJ",
    "area_name": "Middlesex County"
  },
  {
    "fips": 34025,
    "state": "NJ",
    "area_name": "Monmouth County"
  },
  {
    "fips": 34027,
    "state": "NJ",
    "area_name": "Morris County"
  },
  {
    "fips": 34029,
    "state": "NJ",
    "area_name": "Ocean County"
  },
  {
    "fips": 34031,
    "state": "NJ",
    "area_name": "Passaic County"
  },
  {
    "fips": 34033,
    "state": "NJ",
    "area_name": "Salem County"
  },
  {
    "fips": 34035,
    "state": "NJ",
    "area_name": "Somerset County"
  },
  {
    "fips": 34037,
    "state": "NJ",
    "area_name": "Sussex County"
  },
  {
    "fips": 34039,
    "state": "NJ",
    "area_name": "Union County"
  },
  {
    "fips": 34041,
    "state": "NJ",
    "area_name": "Warren County"
  },
  {
    "fips": 35001,
    "state": "NM",
    "area_name": "Bernalillo County"
  },
  {
    "fips": 35003,
    "state": "NM",
    "area_name": "Catron County"
  },
  {
    "fips": 35005,
    "state": "NM",
    "area_name": "Chaves County"
  },
  {
    "fips": 35006,
    "state": "NM",
    "area_name": "Cibola County"
  },
  {
    "fips": 35007,
    "state": "NM",
    "area_name": "Colfax County"
  },
  {
    "fips": 35009,
    "state": "NM",
    "area_name": "Curry County"
  },
  {
    "fips": 35011,
    "state": "NM",
    "area_name": "De Baca County"
  },
  {
    "fips": 35013,
    "state": "NM",
    "area_name": "Dona Ana County"
  },
  {
    "fips": 35015,
    "state": "NM",
    "area_name": "Eddy County"
  },
  {
    "fips": 35017,
    "state": "NM",
    "area_name": "Grant County"
  },
  {
    "fips": 35019,
    "state": "NM",
    "area_name": "Guadalupe County"
  },
  {
    "fips": 35021,
    "state": "NM",
    "area_name": "Harding County"
  },
  {
    "fips": 35023,
    "state": "NM",
    "area_name": "Hidalgo County"
  },
  {
    "fips": 35025,
    "state": "NM",
    "area_name": "Lea County"
  },
  {
    "fips": 35027,
    "state": "NM",
    "area_name": "Lincoln County"
  },
  {
    "fips": 35028,
    "state": "NM",
    "area_name": "Los Alamos County"
  },
  {
    "fips": 35029,
    "state": "NM",
    "area_name": "Luna County"
  },
  {
    "fips": 35031,
    "state": "NM",
    "area_name": "McKinley County"
  },
  {
    "fips": 35033,
    "state": "NM",
    "area_name": "Mora County"
  },
  {
    "fips": 35035,
    "state": "NM",
    "area_name": "Otero County"
  },
  {
    "fips": 35037,
    "state": "NM",
    "area_name": "Quay County"
  },
  {
    "fips": 35039,
    "state": "NM",
    "area_name": "Rio Arriba County"
  },
  {
    "fips": 35041,
    "state": "NM",
    "area_name": "Roosevelt County"
  },
  {
    "fips": 35043,
    "state": "NM",
    "area_name": "Sandoval County"
  },
  {
    "fips": 35045,
    "state": "NM",
    "area_name": "San Juan County"
  },
  {
    "fips": 35047,
    "state": "NM",
    "area_name": "San Miguel County"
  },
  {
    "fips": 35049,
    "state": "NM",
    "area_name": "Santa Fe County"
  },
  {
    "fips": 35051,
    "state": "NM",
    "area_name": "Sierra County"
  },
  {
    "fips": 35053,
    "state": "NM",
    "area_name": "Socorro County"
  },
  {
    "fips": 35055,
    "state": "NM",
    "area_name": "Taos County"
  },
  {
    "fips": 35057,
    "state": "NM",
    "area_name": "Torrance County"
  },
  {
    "fips": 35059,
    "state": "NM",
    "area_name": "Union County"
  },
  {
    "fips": 35061,
    "state": "NM",
    "area_name": "Valencia County"
  },
  {
    "fips": 36001,
    "state": "NY",
    "area_name": "Albany County"
  },
  {
    "fips": 36003,
    "state": "NY",
    "area_name": "Allegany County"
  },
  {
    "fips": 36005,
    "state": "NY",
    "area_name": "Bronx County"
  },
  {
    "fips": 36007,
    "state": "NY",
    "area_name": "Broome County"
  },
  {
    "fips": 36009,
    "state": "NY",
    "area_name": "Cattaraugus County"
  },
  {
    "fips": 36011,
    "state": "NY",
    "area_name": "Cayuga County"
  },
  {
    "fips": 36013,
    "state": "NY",
    "area_name": "Chautauqua County"
  },
  {
    "fips": 36015,
    "state": "NY",
    "area_name": "Chemung County"
  },
  {
    "fips": 36017,
    "state": "NY",
    "area_name": "Chenango County"
  },
  {
    "fips": 36019,
    "state": "NY",
    "area_name": "Clinton County"
  },
  {
    "fips": 36021,
    "state": "NY",
    "area_name": "Columbia County"
  },
  {
    "fips": 36023,
    "state": "NY",
    "area_name": "Cortland County"
  },
  {
    "fips": 36025,
    "state": "NY",
    "area_name": "Delaware County"
  },
  {
    "fips": 36027,
    "state": "NY",
    "area_name": "Dutchess County"
  },
  {
    "fips": 36029,
    "state": "NY",
    "area_name": "Erie County"
  },
  {
    "fips": 36031,
    "state": "NY",
    "area_name": "Essex County"
  },
  {
    "fips": 36033,
    "state": "NY",
    "area_name": "Franklin County"
  },
  {
    "fips": 36035,
    "state": "NY",
    "area_name": "Fulton County"
  },
  {
    "fips": 36037,
    "state": "NY",
    "area_name": "Genesee County"
  },
  {
    "fips": 36039,
    "state": "NY",
    "area_name": "Greene County"
  },
  {
    "fips": 36041,
    "state": "NY",
    "area_name": "Hamilton County"
  },
  {
    "fips": 36043,
    "state": "NY",
    "area_name": "Herkimer County"
  },
  {
    "fips": 36045,
    "state": "NY",
    "area_name": "Jefferson County"
  },
  {
    "fips": 36047,
    "state": "NY",
    "area_name": "Kings County"
  },
  {
    "fips": 36049,
    "state": "NY",
    "area_name": "Lewis County"
  },
  {
    "fips": 36051,
    "state": "NY",
    "area_name": "Livingston County"
  },
  {
    "fips": 36053,
    "state": "NY",
    "area_name": "Madison County"
  },
  {
    "fips": 36055,
    "state": "NY",
    "area_name": "Monroe County"
  },
  {
    "fips": 36057,
    "state": "NY",
    "area_name": "Montgomery County"
  },
  {
    "fips": 36059,
    "state": "NY",
    "area_name": "Nassau County"
  },
  {
    "fips": 36061,
    "state": "NY",
    "area_name": "New York County"
  },
  {
    "fips": 36063,
    "state": "NY",
    "area_name": "Niagara County"
  },
  {
    "fips": 36065,
    "state": "NY",
    "area_name": "Oneida County"
  },
  {
    "fips": 36067,
    "state": "NY",
    "area_name": "Onondaga County"
  },
  {
    "fips": 36069,
    "state": "NY",
    "area_name": "Ontario County"
  },
  {
    "fips": 36071,
    "state": "NY",
    "area_name": "Orange County"
  },
  {
    "fips": 36073,
    "state": "NY",
    "area_name": "Orleans County"
  },
  {
    "fips": 36075,
    "state": "NY",
    "area_name": "Oswego County"
  },
  {
    "fips": 36077,
    "state": "NY",
    "area_name": "Otsego County"
  },
  {
    "fips": 36079,
    "state": "NY",
    "area_name": "Putnam County"
  },
  {
    "fips": 36081,
    "state": "NY",
    "area_name": "Queens County"
  },
  {
    "fips": 36083,
    "state": "NY",
    "area_name": "Rensselaer County"
  },
  {
    "fips": 36085,
    "state": "NY",
    "area_name": "Richmond County"
  },
  {
    "fips": 36087,
    "state": "NY",
    "area_name": "Rockland County"
  },
  {
    "fips": 36089,
    "state": "NY",
    "area_name": "St. Lawrence County"
  },
  {
    "fips": 36091,
    "state": "NY",
    "area_name": "Saratoga County"
  },
  {
    "fips": 36093,
    "state": "NY",
    "area_name": "Schenectady County"
  },
  {
    "fips": 36095,
    "state": "NY",
    "area_name": "Schoharie County"
  },
  {
    "fips": 36097,
    "state": "NY",
    "area_name": "Schuyler County"
  },
  {
    "fips": 36099,
    "state": "NY",
    "area_name": "Seneca County"
  },
  {
    "fips": 36101,
    "state": "NY",
    "area_name": "Steuben County"
  },
  {
    "fips": 36103,
    "state": "NY",
    "area_name": "Suffolk County"
  },
  {
    "fips": 36105,
    "state": "NY",
    "area_name": "Sullivan County"
  },
  {
    "fips": 36107,
    "state": "NY",
    "area_name": "Tioga County"
  },
  {
    "fips": 36109,
    "state": "NY",
    "area_name": "Tompkins County"
  },
  {
    "fips": 36111,
    "state": "NY",
    "area_name": "Ulster County"
  },
  {
    "fips": 36113,
    "state": "NY",
    "area_name": "Warren County"
  },
  {
    "fips": 36115,
    "state": "NY",
    "area_name": "Washington County"
  },
  {
    "fips": 36117,
    "state": "NY",
    "area_name": "Wayne County"
  },
  {
    "fips": 36119,
    "state": "NY",
    "area_name": "Westchester County"
  },
  {
    "fips": 36121,
    "state": "NY",
    "area_name": "Wyoming County"
  },
  {
    "fips": 36123,
    "state": "NY",
    "area_name": "Yates County"
  },
  {
    "fips": 37001,
    "state": "NC",
    "area_name": "Alamance County"
  },
  {
    "fips": 37003,
    "state": "NC",
    "area_name": "Alexander County"
  },
  {
    "fips": 37005,
    "state": "NC",
    "area_name": "Alleghany County"
  },
  {
    "fips": 37007,
    "state": "NC",
    "area_name": "Anson County"
  },
  {
    "fips": 37009,
    "state": "NC",
    "area_name": "Ashe County"
  },
  {
    "fips": 37011,
    "state": "NC",
    "area_name": "Avery County"
  },
  {
    "fips": 37013,
    "state": "NC",
    "area_name": "Beaufort County"
  },
  {
    "fips": 37015,
    "state": "NC",
    "area_name": "Bertie County"
  },
  {
    "fips": 37017,
    "state": "NC",
    "area_name": "Bladen County"
  },
  {
    "fips": 37019,
    "state": "NC",
    "area_name": "Brunswick County"
  },
  {
    "fips": 37021,
    "state": "NC",
    "area_name": "Buncombe County"
  },
  {
    "fips": 37023,
    "state": "NC",
    "area_name": "Burke County"
  },
  {
    "fips": 37025,
    "state": "NC",
    "area_name": "Cabarrus County"
  },
  {
    "fips": 37027,
    "state": "NC",
    "area_name": "Caldwell County"
  },
  {
    "fips": 37029,
    "state": "NC",
    "area_name": "Camden County"
  },
  {
    "fips": 37031,
    "state": "NC",
    "area_name": "Carteret County"
  },
  {
    "fips": 37033,
    "state": "NC",
    "area_name": "Caswell County"
  },
  {
    "fips": 37035,
    "state": "NC",
    "area_name": "Catawba County"
  },
  {
    "fips": 37037,
    "state": "NC",
    "area_name": "Chatham County"
  },
  {
    "fips": 37039,
    "state": "NC",
    "area_name": "Cherokee County"
  },
  {
    "fips": 37041,
    "state": "NC",
    "area_name": "Chowan County"
  },
  {
    "fips": 37043,
    "state": "NC",
    "area_name": "Clay County"
  },
  {
    "fips": 37045,
    "state": "NC",
    "area_name": "Cleveland County"
  },
  {
    "fips": 37047,
    "state": "NC",
    "area_name": "Columbus County"
  },
  {
    "fips": 37049,
    "state": "NC",
    "area_name": "Craven County"
  },
  {
    "fips": 37051,
    "state": "NC",
    "area_name": "Cumberland County"
  },
  {
    "fips": 37053,
    "state": "NC",
    "area_name": "Currituck County"
  },
  {
    "fips": 37055,
    "state": "NC",
    "area_name": "Dare County"
  },
  {
    "fips": 37057,
    "state": "NC",
    "area_name": "Davidson County"
  },
  {
    "fips": 37059,
    "state": "NC",
    "area_name": "Davie County"
  },
  {
    "fips": 37061,
    "state": "NC",
    "area_name": "Duplin County"
  },
  {
    "fips": 37063,
    "state": "NC",
    "area_name": "Durham County"
  },
  {
    "fips": 37065,
    "state": "NC",
    "area_name": "Edgecombe County"
  },
  {
    "fips": 37067,
    "state": "NC",
    "area_name": "Forsyth County"
  },
  {
    "fips": 37069,
    "state": "NC",
    "area_name": "Franklin County"
  },
  {
    "fips": 37071,
    "state": "NC",
    "area_name": "Gaston County"
  },
  {
    "fips": 37073,
    "state": "NC",
    "area_name": "Gates County"
  },
  {
    "fips": 37075,
    "state": "NC",
    "area_name": "Graham County"
  },
  {
    "fips": 37077,
    "state": "NC",
    "area_name": "Granville County"
  },
  {
    "fips": 37079,
    "state": "NC",
    "area_name": "Greene County"
  },
  {
    "fips": 37081,
    "state": "NC",
    "area_name": "Guilford County"
  },
  {
    "fips": 37083,
    "state": "NC",
    "area_name": "Halifax County"
  },
  {
    "fips": 37085,
    "state": "NC",
    "area_name": "Harnett County"
  },
  {
    "fips": 37087,
    "state": "NC",
    "area_name": "Haywood County"
  },
  {
    "fips": 37089,
    "state": "NC",
    "area_name": "Henderson County"
  },
  {
    "fips": 37091,
    "state": "NC",
    "area_name": "Hertford County"
  },
  {
    "fips": 37093,
    "state": "NC",
    "area_name": "Hoke County"
  },
  {
    "fips": 37095,
    "state": "NC",
    "area_name": "Hyde County"
  },
  {
    "fips": 37097,
    "state": "NC",
    "area_name": "Iredell County"
  },
  {
    "fips": 37099,
    "state": "NC",
    "area_name": "Jackson County"
  },
  {
    "fips": 37101,
    "state": "NC",
    "area_name": "Johnston County"
  },
  {
    "fips": 37103,
    "state": "NC",
    "area_name": "Jones County"
  },
  {
    "fips": 37105,
    "state": "NC",
    "area_name": "Lee County"
  },
  {
    "fips": 37107,
    "state": "NC",
    "area_name": "Lenoir County"
  },
  {
    "fips": 37109,
    "state": "NC",
    "area_name": "Lincoln County"
  },
  {
    "fips": 37111,
    "state": "NC",
    "area_name": "McDowell County"
  },
  {
    "fips": 37113,
    "state": "NC",
    "area_name": "Macon County"
  },
  {
    "fips": 37115,
    "state": "NC",
    "area_name": "Madison County"
  },
  {
    "fips": 37117,
    "state": "NC",
    "area_name": "Martin County"
  },
  {
    "fips": 37119,
    "state": "NC",
    "area_name": "Mecklenburg County"
  },
  {
    "fips": 37121,
    "state": "NC",
    "area_name": "Mitchell County"
  },
  {
    "fips": 37123,
    "state": "NC",
    "area_name": "Montgomery County"
  },
  {
    "fips": 37125,
    "state": "NC",
    "area_name": "Moore County"
  },
  {
    "fips": 37127,
    "state": "NC",
    "area_name": "Nash County"
  },
  {
    "fips": 37129,
    "state": "NC",
    "area_name": "New Hanover County"
  },
  {
    "fips": 37131,
    "state": "NC",
    "area_name": "Northampton County"
  },
  {
    "fips": 37133,
    "state": "NC",
    "area_name": "Onslow County"
  },
  {
    "fips": 37135,
    "state": "NC",
    "area_name": "Orange County"
  },
  {
    "fips": 37137,
    "state": "NC",
    "area_name": "Pamlico County"
  },
  {
    "fips": 37139,
    "state": "NC",
    "area_name": "Pasquotank County"
  },
  {
    "fips": 37141,
    "state": "NC",
    "area_name": "Pender County"
  },
  {
    "fips": 37143,
    "state": "NC",
    "area_name": "Perquimans County"
  },
  {
    "fips": 37145,
    "state": "NC",
    "area_name": "Person County"
  },
  {
    "fips": 37147,
    "state": "NC",
    "area_name": "Pitt County"
  },
  {
    "fips": 37149,
    "state": "NC",
    "area_name": "Polk County"
  },
  {
    "fips": 37151,
    "state": "NC",
    "area_name": "Randolph County"
  },
  {
    "fips": 37153,
    "state": "NC",
    "area_name": "Richmond County"
  },
  {
    "fips": 37155,
    "state": "NC",
    "area_name": "Robeson County"
  },
  {
    "fips": 37157,
    "state": "NC",
    "area_name": "Rockingham County"
  },
  {
    "fips": 37159,
    "state": "NC",
    "area_name": "Rowan County"
  },
  {
    "fips": 37161,
    "state": "NC",
    "area_name": "Rutherford County"
  },
  {
    "fips": 37163,
    "state": "NC",
    "area_name": "Sampson County"
  },
  {
    "fips": 37165,
    "state": "NC",
    "area_name": "Scotland County"
  },
  {
    "fips": 37167,
    "state": "NC",
    "area_name": "Stanly County"
  },
  {
    "fips": 37169,
    "state": "NC",
    "area_name": "Stokes County"
  },
  {
    "fips": 37171,
    "state": "NC",
    "area_name": "Surry County"
  },
  {
    "fips": 37173,
    "state": "NC",
    "area_name": "Swain County"
  },
  {
    "fips": 37175,
    "state": "NC",
    "area_name": "Transylvania County"
  },
  {
    "fips": 37177,
    "state": "NC",
    "area_name": "Tyrrell County"
  },
  {
    "fips": 37179,
    "state": "NC",
    "area_name": "Union County"
  },
  {
    "fips": 37181,
    "state": "NC",
    "area_name": "Vance County"
  },
  {
    "fips": 37183,
    "state": "NC",
    "area_name": "Wake County"
  },
  {
    "fips": 37185,
    "state": "NC",
    "area_name": "Warren County"
  },
  {
    "fips": 37187,
    "state": "NC",
    "area_name": "Washington County"
  },
  {
    "fips": 37189,
    "state": "NC",
    "area_name": "Watauga County"
  },
  {
    "fips": 37191,
    "state": "NC",
    "area_name": "Wayne County"
  },
  {
    "fips": 37193,
    "state": "NC",
    "area_name": "Wilkes County"
  },
  {
    "fips": 37195,
    "state": "NC",
    "area_name": "Wilson County"
  },
  {
    "fips": 37197,
    "state": "NC",
    "area_name": "Yadkin County"
  },
  {
    "fips": 37199,
    "state": "NC",
    "area_name": "Yancey County"
  },
  {
    "fips": 38001,
    "state": "ND",
    "area_name": "Adams County"
  },
  {
    "fips": 38003,
    "state": "ND",
    "area_name": "Barnes County"
  },
  {
    "fips": 38005,
    "state": "ND",
    "area_name": "Benson County"
  },
  {
    "fips": 38007,
    "state": "ND",
    "area_name": "Billings County"
  },
  {
    "fips": 38009,
    "state": "ND",
    "area_name": "Bottineau County"
  },
  {
    "fips": 38011,
    "state": "ND",
    "area_name": "Bowman County"
  },
  {
    "fips": 38013,
    "state": "ND",
    "area_name": "Burke County"
  },
  {
    "fips": 38015,
    "state": "ND",
    "area_name": "Burleigh County"
  },
  {
    "fips": 38017,
    "state": "ND",
    "area_name": "Cass County"
  },
  {
    "fips": 38019,
    "state": "ND",
    "area_name": "Cavalier County"
  },
  {
    "fips": 38021,
    "state": "ND",
    "area_name": "Dickey County"
  },
  {
    "fips": 38023,
    "state": "ND",
    "area_name": "Divide County"
  },
  {
    "fips": 38025,
    "state": "ND",
    "area_name": "Dunn County"
  },
  {
    "fips": 38027,
    "state": "ND",
    "area_name": "Eddy County"
  },
  {
    "fips": 38029,
    "state": "ND",
    "area_name": "Emmons County"
  },
  {
    "fips": 38031,
    "state": "ND",
    "area_name": "Foster County"
  },
  {
    "fips": 38033,
    "state": "ND",
    "area_name": "Golden Valley County"
  },
  {
    "fips": 38035,
    "state": "ND",
    "area_name": "Grand Forks County"
  },
  {
    "fips": 38037,
    "state": "ND",
    "area_name": "Grant County"
  },
  {
    "fips": 38039,
    "state": "ND",
    "area_name": "Griggs County"
  },
  {
    "fips": 38041,
    "state": "ND",
    "area_name": "Hettinger County"
  },
  {
    "fips": 38043,
    "state": "ND",
    "area_name": "Kidder County"
  },
  {
    "fips": 38045,
    "state": "ND",
    "area_name": "LaMoure County"
  },
  {
    "fips": 38047,
    "state": "ND",
    "area_name": "Logan County"
  },
  {
    "fips": 38049,
    "state": "ND",
    "area_name": "McHenry County"
  },
  {
    "fips": 38051,
    "state": "ND",
    "area_name": "McIntosh County"
  },
  {
    "fips": 38053,
    "state": "ND",
    "area_name": "McKenzie County"
  },
  {
    "fips": 38055,
    "state": "ND",
    "area_name": "McLean County"
  },
  {
    "fips": 38057,
    "state": "ND",
    "area_name": "Mercer County"
  },
  {
    "fips": 38059,
    "state": "ND",
    "area_name": "Morton County"
  },
  {
    "fips": 38061,
    "state": "ND",
    "area_name": "Mountrail County"
  },
  {
    "fips": 38063,
    "state": "ND",
    "area_name": "Nelson County"
  },
  {
    "fips": 38065,
    "state": "ND",
    "area_name": "Oliver County"
  },
  {
    "fips": 38067,
    "state": "ND",
    "area_name": "Pembina County"
  },
  {
    "fips": 38069,
    "state": "ND",
    "area_name": "Pierce County"
  },
  {
    "fips": 38071,
    "state": "ND",
    "area_name": "Ramsey County"
  },
  {
    "fips": 38073,
    "state": "ND",
    "area_name": "Ransom County"
  },
  {
    "fips": 38075,
    "state": "ND",
    "area_name": "Renville County"
  },
  {
    "fips": 38077,
    "state": "ND",
    "area_name": "Richland County"
  },
  {
    "fips": 38079,
    "state": "ND",
    "area_name": "Rolette County"
  },
  {
    "fips": 38081,
    "state": "ND",
    "area_name": "Sargent County"
  },
  {
    "fips": 38083,
    "state": "ND",
    "area_name": "Sheridan County"
  },
  {
    "fips": 38085,
    "state": "ND",
    "area_name": "Sioux County"
  },
  {
    "fips": 38087,
    "state": "ND",
    "area_name": "Slope County"
  },
  {
    "fips": 38089,
    "state": "ND",
    "area_name": "Stark County"
  },
  {
    "fips": 38091,
    "state": "ND",
    "area_name": "Steele County"
  },
  {
    "fips": 38093,
    "state": "ND",
    "area_name": "Stutsman County"
  },
  {
    "fips": 38095,
    "state": "ND",
    "area_name": "Towner County"
  },
  {
    "fips": 38097,
    "state": "ND",
    "area_name": "Traill County"
  },
  {
    "fips": 38099,
    "state": "ND",
    "area_name": "Walsh County"
  },
  {
    "fips": 38101,
    "state": "ND",
    "area_name": "Ward County"
  },
  {
    "fips": 38103,
    "state": "ND",
    "area_name": "Wells County"
  },
  {
    "fips": 38105,
    "state": "ND",
    "area_name": "Williams County"
  },
  {
    "fips": 39001,
    "state": "OH",
    "area_name": "Adams County"
  },
  {
    "fips": 39003,
    "state": "OH",
    "area_name": "Allen County"
  },
  {
    "fips": 39005,
    "state": "OH",
    "area_name": "Ashland County"
  },
  {
    "fips": 39007,
    "state": "OH",
    "area_name": "Ashtabula County"
  },
  {
    "fips": 39009,
    "state": "OH",
    "area_name": "Athens County"
  },
  {
    "fips": 39011,
    "state": "OH",
    "area_name": "Auglaize County"
  },
  {
    "fips": 39013,
    "state": "OH",
    "area_name": "Belmont County"
  },
  {
    "fips": 39015,
    "state": "OH",
    "area_name": "Brown County"
  },
  {
    "fips": 39017,
    "state": "OH",
    "area_name": "Butler County"
  },
  {
    "fips": 39019,
    "state": "OH",
    "area_name": "Carroll County"
  },
  {
    "fips": 39021,
    "state": "OH",
    "area_name": "Champaign County"
  },
  {
    "fips": 39023,
    "state": "OH",
    "area_name": "Clark County"
  },
  {
    "fips": 39025,
    "state": "OH",
    "area_name": "Clermont County"
  },
  {
    "fips": 39027,
    "state": "OH",
    "area_name": "Clinton County"
  },
  {
    "fips": 39029,
    "state": "OH",
    "area_name": "Columbiana County"
  },
  {
    "fips": 39031,
    "state": "OH",
    "area_name": "Coshocton County"
  },
  {
    "fips": 39033,
    "state": "OH",
    "area_name": "Crawford County"
  },
  {
    "fips": 39035,
    "state": "OH",
    "area_name": "Cuyahoga County"
  },
  {
    "fips": 39037,
    "state": "OH",
    "area_name": "Darke County"
  },
  {
    "fips": 39039,
    "state": "OH",
    "area_name": "Defiance County"
  },
  {
    "fips": 39041,
    "state": "OH",
    "area_name": "Delaware County"
  },
  {
    "fips": 39043,
    "state": "OH",
    "area_name": "Erie County"
  },
  {
    "fips": 39045,
    "state": "OH",
    "area_name": "Fairfield County"
  },
  {
    "fips": 39047,
    "state": "OH",
    "area_name": "Fayette County"
  },
  {
    "fips": 39049,
    "state": "OH",
    "area_name": "Franklin County"
  },
  {
    "fips": 39051,
    "state": "OH",
    "area_name": "Fulton County"
  },
  {
    "fips": 39053,
    "state": "OH",
    "area_name": "Gallia County"
  },
  {
    "fips": 39055,
    "state": "OH",
    "area_name": "Geauga County"
  },
  {
    "fips": 39057,
    "state": "OH",
    "area_name": "Greene County"
  },
  {
    "fips": 39059,
    "state": "OH",
    "area_name": "Guernsey County"
  },
  {
    "fips": 39061,
    "state": "OH",
    "area_name": "Hamilton County"
  },
  {
    "fips": 39063,
    "state": "OH",
    "area_name": "Hancock County"
  },
  {
    "fips": 39065,
    "state": "OH",
    "area_name": "Hardin County"
  },
  {
    "fips": 39067,
    "state": "OH",
    "area_name": "Harrison County"
  },
  {
    "fips": 39069,
    "state": "OH",
    "area_name": "Henry County"
  },
  {
    "fips": 39071,
    "state": "OH",
    "area_name": "Highland County"
  },
  {
    "fips": 39073,
    "state": "OH",
    "area_name": "Hocking County"
  },
  {
    "fips": 39075,
    "state": "OH",
    "area_name": "Holmes County"
  },
  {
    "fips": 39077,
    "state": "OH",
    "area_name": "Huron County"
  },
  {
    "fips": 39079,
    "state": "OH",
    "area_name": "Jackson County"
  },
  {
    "fips": 39081,
    "state": "OH",
    "area_name": "Jefferson County"
  },
  {
    "fips": 39083,
    "state": "OH",
    "area_name": "Knox County"
  },
  {
    "fips": 39085,
    "state": "OH",
    "area_name": "Lake County"
  },
  {
    "fips": 39087,
    "state": "OH",
    "area_name": "Lawrence County"
  },
  {
    "fips": 39089,
    "state": "OH",
    "area_name": "Licking County"
  },
  {
    "fips": 39091,
    "state": "OH",
    "area_name": "Logan County"
  },
  {
    "fips": 39093,
    "state": "OH",
    "area_name": "Lorain County"
  },
  {
    "fips": 39095,
    "state": "OH",
    "area_name": "Lucas County"
  },
  {
    "fips": 39097,
    "state": "OH",
    "area_name": "Madison County"
  },
  {
    "fips": 39099,
    "state": "OH",
    "area_name": "Mahoning County"
  },
  {
    "fips": 39101,
    "state": "OH",
    "area_name": "Marion County"
  },
  {
    "fips": 39103,
    "state": "OH",
    "area_name": "Medina County"
  },
  {
    "fips": 39105,
    "state": "OH",
    "area_name": "Meigs County"
  },
  {
    "fips": 39107,
    "state": "OH",
    "area_name": "Mercer County"
  },
  {
    "fips": 39109,
    "state": "OH",
    "area_name": "Miami County"
  },
  {
    "fips": 39111,
    "state": "OH",
    "area_name": "Monroe County"
  },
  {
    "fips": 39113,
    "state": "OH",
    "area_name": "Montgomery County"
  },
  {
    "fips": 39115,
    "state": "OH",
    "area_name": "Morgan County"
  },
  {
    "fips": 39117,
    "state": "OH",
    "area_name": "Morrow County"
  },
  {
    "fips": 39119,
    "state": "OH",
    "area_name": "Muskingum County"
  },
  {
    "fips": 39121,
    "state": "OH",
    "area_name": "Noble County"
  },
  {
    "fips": 39123,
    "state": "OH",
    "area_name": "Ottawa County"
  },
  {
    "fips": 39125,
    "state": "OH",
    "area_name": "Paulding County"
  },
  {
    "fips": 39127,
    "state": "OH",
    "area_name": "Perry County"
  },
  {
    "fips": 39129,
    "state": "OH",
    "area_name": "Pickaway County"
  },
  {
    "fips": 39131,
    "state": "OH",
    "area_name": "Pike County"
  },
  {
    "fips": 39133,
    "state": "OH",
    "area_name": "Portage County"
  },
  {
    "fips": 39135,
    "state": "OH",
    "area_name": "Preble County"
  },
  {
    "fips": 39137,
    "state": "OH",
    "area_name": "Putnam County"
  },
  {
    "fips": 39139,
    "state": "OH",
    "area_name": "Richland County"
  },
  {
    "fips": 39141,
    "state": "OH",
    "area_name": "Ross County"
  },
  {
    "fips": 39143,
    "state": "OH",
    "area_name": "Sandusky County"
  },
  {
    "fips": 39145,
    "state": "OH",
    "area_name": "Scioto County"
  },
  {
    "fips": 39147,
    "state": "OH",
    "area_name": "Seneca County"
  },
  {
    "fips": 39149,
    "state": "OH",
    "area_name": "Shelby County"
  },
  {
    "fips": 39151,
    "state": "OH",
    "area_name": "Stark County"
  },
  {
    "fips": 39153,
    "state": "OH",
    "area_name": "Summit County"
  },
  {
    "fips": 39155,
    "state": "OH",
    "area_name": "Trumbull County"
  },
  {
    "fips": 39157,
    "state": "OH",
    "area_name": "Tuscarawas County"
  },
  {
    "fips": 39159,
    "state": "OH",
    "area_name": "Union County"
  },
  {
    "fips": 39161,
    "state": "OH",
    "area_name": "Van Wert County"
  },
  {
    "fips": 39163,
    "state": "OH",
    "area_name": "Vinton County"
  },
  {
    "fips": 39165,
    "state": "OH",
    "area_name": "Warren County"
  },
  {
    "fips": 39167,
    "state": "OH",
    "area_name": "Washington County"
  },
  {
    "fips": 39169,
    "state": "OH",
    "area_name": "Wayne County"
  },
  {
    "fips": 39171,
    "state": "OH",
    "area_name": "Williams County"
  },
  {
    "fips": 39173,
    "state": "OH",
    "area_name": "Wood County"
  },
  {
    "fips": 39175,
    "state": "OH",
    "area_name": "Wyandot County"
  },
  {
    "fips": 40001,
    "state": "OK",
    "area_name": "Adair County"
  },
  {
    "fips": 40003,
    "state": "OK",
    "area_name": "Alfalfa County"
  },
  {
    "fips": 40005,
    "state": "OK",
    "area_name": "Atoka County"
  },
  {
    "fips": 40007,
    "state": "OK",
    "area_name": "Beaver County"
  },
  {
    "fips": 40009,
    "state": "OK",
    "area_name": "Beckham County"
  },
  {
    "fips": 40011,
    "state": "OK",
    "area_name": "Blaine County"
  },
  {
    "fips": 40013,
    "state": "OK",
    "area_name": "Bryan County"
  },
  {
    "fips": 40015,
    "state": "OK",
    "area_name": "Caddo County"
  },
  {
    "fips": 40017,
    "state": "OK",
    "area_name": "Canadian County"
  },
  {
    "fips": 40019,
    "state": "OK",
    "area_name": "Carter County"
  },
  {
    "fips": 40021,
    "state": "OK",
    "area_name": "Cherokee County"
  },
  {
    "fips": 40023,
    "state": "OK",
    "area_name": "Choctaw County"
  },
  {
    "fips": 40025,
    "state": "OK",
    "area_name": "Cimarron County"
  },
  {
    "fips": 40027,
    "state": "OK",
    "area_name": "Cleveland County"
  },
  {
    "fips": 40029,
    "state": "OK",
    "area_name": "Coal County"
  },
  {
    "fips": 40031,
    "state": "OK",
    "area_name": "Comanche County"
  },
  {
    "fips": 40033,
    "state": "OK",
    "area_name": "Cotton County"
  },
  {
    "fips": 40035,
    "state": "OK",
    "area_name": "Craig County"
  },
  {
    "fips": 40037,
    "state": "OK",
    "area_name": "Creek County"
  },
  {
    "fips": 40039,
    "state": "OK",
    "area_name": "Custer County"
  },
  {
    "fips": 40041,
    "state": "OK",
    "area_name": "Delaware County"
  },
  {
    "fips": 40043,
    "state": "OK",
    "area_name": "Dewey County"
  },
  {
    "fips": 40045,
    "state": "OK",
    "area_name": "Ellis County"
  },
  {
    "fips": 40047,
    "state": "OK",
    "area_name": "Garfield County"
  },
  {
    "fips": 40049,
    "state": "OK",
    "area_name": "Garvin County"
  },
  {
    "fips": 40051,
    "state": "OK",
    "area_name": "Grady County"
  },
  {
    "fips": 40053,
    "state": "OK",
    "area_name": "Grant County"
  },
  {
    "fips": 40055,
    "state": "OK",
    "area_name": "Greer County"
  },
  {
    "fips": 40057,
    "state": "OK",
    "area_name": "Harmon County"
  },
  {
    "fips": 40059,
    "state": "OK",
    "area_name": "Harper County"
  },
  {
    "fips": 40061,
    "state": "OK",
    "area_name": "Haskell County"
  },
  {
    "fips": 40063,
    "state": "OK",
    "area_name": "Hughes County"
  },
  {
    "fips": 40065,
    "state": "OK",
    "area_name": "Jackson County"
  },
  {
    "fips": 40067,
    "state": "OK",
    "area_name": "Jefferson County"
  },
  {
    "fips": 40069,
    "state": "OK",
    "area_name": "Johnston County"
  },
  {
    "fips": 40071,
    "state": "OK",
    "area_name": "Kay County"
  },
  {
    "fips": 40073,
    "state": "OK",
    "area_name": "Kingfisher County"
  },
  {
    "fips": 40075,
    "state": "OK",
    "area_name": "Kiowa County"
  },
  {
    "fips": 40077,
    "state": "OK",
    "area_name": "Latimer County"
  },
  {
    "fips": 40079,
    "state": "OK",
    "area_name": "Le Flore County"
  },
  {
    "fips": 40081,
    "state": "OK",
    "area_name": "Lincoln County"
  },
  {
    "fips": 40083,
    "state": "OK",
    "area_name": "Logan County"
  },
  {
    "fips": 40085,
    "state": "OK",
    "area_name": "Love County"
  },
  {
    "fips": 40087,
    "state": "OK",
    "area_name": "McClain County"
  },
  {
    "fips": 40089,
    "state": "OK",
    "area_name": "McCurtain County"
  },
  {
    "fips": 40091,
    "state": "OK",
    "area_name": "McIntosh County"
  },
  {
    "fips": 40093,
    "state": "OK",
    "area_name": "Major County"
  },
  {
    "fips": 40095,
    "state": "OK",
    "area_name": "Marshall County"
  },
  {
    "fips": 40097,
    "state": "OK",
    "area_name": "Mayes County"
  },
  {
    "fips": 40099,
    "state": "OK",
    "area_name": "Murray County"
  },
  {
    "fips": 40101,
    "state": "OK",
    "area_name": "Muskogee County"
  },
  {
    "fips": 40103,
    "state": "OK",
    "area_name": "Noble County"
  },
  {
    "fips": 40105,
    "state": "OK",
    "area_name": "Nowata County"
  },
  {
    "fips": 40107,
    "state": "OK",
    "area_name": "Okfuskee County"
  },
  {
    "fips": 40109,
    "state": "OK",
    "area_name": "Oklahoma County"
  },
  {
    "fips": 40111,
    "state": "OK",
    "area_name": "Okmulgee County"
  },
  {
    "fips": 40113,
    "state": "OK",
    "area_name": "Osage County"
  },
  {
    "fips": 40115,
    "state": "OK",
    "area_name": "Ottawa County"
  },
  {
    "fips": 40117,
    "state": "OK",
    "area_name": "Pawnee County"
  },
  {
    "fips": 40119,
    "state": "OK",
    "area_name": "Payne County"
  },
  {
    "fips": 40121,
    "state": "OK",
    "area_name": "Pittsburg County"
  },
  {
    "fips": 40123,
    "state": "OK",
    "area_name": "Pontotoc County"
  },
  {
    "fips": 40125,
    "state": "OK",
    "area_name": "Pottawatomie County"
  },
  {
    "fips": 40127,
    "state": "OK",
    "area_name": "Pushmataha County"
  },
  {
    "fips": 40129,
    "state": "OK",
    "area_name": "Roger Mills County"
  },
  {
    "fips": 40131,
    "state": "OK",
    "area_name": "Rogers County"
  },
  {
    "fips": 40133,
    "state": "OK",
    "area_name": "Seminole County"
  },
  {
    "fips": 40135,
    "state": "OK",
    "area_name": "Sequoyah County"
  },
  {
    "fips": 40137,
    "state": "OK",
    "area_name": "Stephens County"
  },
  {
    "fips": 40139,
    "state": "OK",
    "area_name": "Texas County"
  },
  {
    "fips": 40141,
    "state": "OK",
    "area_name": "Tillman County"
  },
  {
    "fips": 40143,
    "state": "OK",
    "area_name": "Tulsa County"
  },
  {
    "fips": 40145,
    "state": "OK",
    "area_name": "Wagoner County"
  },
  {
    "fips": 40147,
    "state": "OK",
    "area_name": "Washington County"
  },
  {
    "fips": 40149,
    "state": "OK",
    "area_name": "Washita County"
  },
  {
    "fips": 40151,
    "state": "OK",
    "area_name": "Woods County"
  },
  {
    "fips": 40153,
    "state": "OK",
    "area_name": "Woodward County"
  },
  {
    "fips": 41001,
    "state": "OR",
    "area_name": "Baker County"
  },
  {
    "fips": 41003,
    "state": "OR",
    "area_name": "Benton County"
  },
  {
    "fips": 41005,
    "state": "OR",
    "area_name": "Clackamas County"
  },
  {
    "fips": 41007,
    "state": "OR",
    "area_name": "Clatsop County"
  },
  {
    "fips": 41009,
    "state": "OR",
    "area_name": "Columbia County"
  },
  {
    "fips": 41011,
    "state": "OR",
    "area_name": "Coos County"
  },
  {
    "fips": 41013,
    "state": "OR",
    "area_name": "Crook County"
  },
  {
    "fips": 41015,
    "state": "OR",
    "area_name": "Curry County"
  },
  {
    "fips": 41017,
    "state": "OR",
    "area_name": "Deschutes County"
  },
  {
    "fips": 41019,
    "state": "OR",
    "area_name": "Douglas County"
  },
  {
    "fips": 41021,
    "state": "OR",
    "area_name": "Gilliam County"
  },
  {
    "fips": 41023,
    "state": "OR",
    "area_name": "Grant County"
  },
  {
    "fips": 41025,
    "state": "OR",
    "area_name": "Harney County"
  },
  {
    "fips": 41027,
    "state": "OR",
    "area_name": "Hood River County"
  },
  {
    "fips": 41029,
    "state": "OR",
    "area_name": "Jackson County"
  },
  {
    "fips": 41031,
    "state": "OR",
    "area_name": "Jefferson County"
  },
  {
    "fips": 41033,
    "state": "OR",
    "area_name": "Josephine County"
  },
  {
    "fips": 41035,
    "state": "OR",
    "area_name": "Klamath County"
  },
  {
    "fips": 41037,
    "state": "OR",
    "area_name": "Lake County"
  },
  {
    "fips": 41039,
    "state": "OR",
    "area_name": "Lane County"
  },
  {
    "fips": 41041,
    "state": "OR",
    "area_name": "Lincoln County"
  },
  {
    "fips": 41043,
    "state": "OR",
    "area_name": "Linn County"
  },
  {
    "fips": 41045,
    "state": "OR",
    "area_name": "Malheur County"
  },
  {
    "fips": 41047,
    "state": "OR",
    "area_name": "Marion County"
  },
  {
    "fips": 41049,
    "state": "OR",
    "area_name": "Morrow County"
  },
  {
    "fips": 41051,
    "state": "OR",
    "area_name": "Multnomah County"
  },
  {
    "fips": 41053,
    "state": "OR",
    "area_name": "Polk County"
  },
  {
    "fips": 41055,
    "state": "OR",
    "area_name": "Sherman County"
  },
  {
    "fips": 41057,
    "state": "OR",
    "area_name": "Tillamook County"
  },
  {
    "fips": 41059,
    "state": "OR",
    "area_name": "Umatilla County"
  },
  {
    "fips": 41061,
    "state": "OR",
    "area_name": "Union County"
  },
  {
    "fips": 41063,
    "state": "OR",
    "area_name": "Wallowa County"
  },
  {
    "fips": 41065,
    "state": "OR",
    "area_name": "Wasco County"
  },
  {
    "fips": 41067,
    "state": "OR",
    "area_name": "Washington County"
  },
  {
    "fips": 41069,
    "state": "OR",
    "area_name": "Wheeler County"
  },
  {
    "fips": 41071,
    "state": "OR",
    "area_name": "Yamhill County"
  },
  {
    "fips": 42001,
    "state": "PA",
    "area_name": "Adams County"
  },
  {
    "fips": 42003,
    "state": "PA",
    "area_name": "Allegheny County"
  },
  {
    "fips": 42005,
    "state": "PA",
    "area_name": "Armstrong County"
  },
  {
    "fips": 42007,
    "state": "PA",
    "area_name": "Beaver County"
  },
  {
    "fips": 42009,
    "state": "PA",
    "area_name": "Bedford County"
  },
  {
    "fips": 42011,
    "state": "PA",
    "area_name": "Berks County"
  },
  {
    "fips": 42013,
    "state": "PA",
    "area_name": "Blair County"
  },
  {
    "fips": 42015,
    "state": "PA",
    "area_name": "Bradford County"
  },
  {
    "fips": 42017,
    "state": "PA",
    "area_name": "Bucks County"
  },
  {
    "fips": 42019,
    "state": "PA",
    "area_name": "Butler County"
  },
  {
    "fips": 42021,
    "state": "PA",
    "area_name": "Cambria County"
  },
  {
    "fips": 42023,
    "state": "PA",
    "area_name": "Cameron County"
  },
  {
    "fips": 42025,
    "state": "PA",
    "area_name": "Carbon County"
  },
  {
    "fips": 42027,
    "state": "PA",
    "area_name": "Centre County"
  },
  {
    "fips": 42029,
    "state": "PA",
    "area_name": "Chester County"
  },
  {
    "fips": 42031,
    "state": "PA",
    "area_name": "Clarion County"
  },
  {
    "fips": 42033,
    "state": "PA",
    "area_name": "Clearfield County"
  },
  {
    "fips": 42035,
    "state": "PA",
    "area_name": "Clinton County"
  },
  {
    "fips": 42037,
    "state": "PA",
    "area_name": "Columbia County"
  },
  {
    "fips": 42039,
    "state": "PA",
    "area_name": "Crawford County"
  },
  {
    "fips": 42041,
    "state": "PA",
    "area_name": "Cumberland County"
  },
  {
    "fips": 42043,
    "state": "PA",
    "area_name": "Dauphin County"
  },
  {
    "fips": 42045,
    "state": "PA",
    "area_name": "Delaware County"
  },
  {
    "fips": 42047,
    "state": "PA",
    "area_name": "Elk County"
  },
  {
    "fips": 42049,
    "state": "PA",
    "area_name": "Erie County"
  },
  {
    "fips": 42051,
    "state": "PA",
    "area_name": "Fayette County"
  },
  {
    "fips": 42053,
    "state": "PA",
    "area_name": "Forest County"
  },
  {
    "fips": 42055,
    "state": "PA",
    "area_name": "Franklin County"
  },
  {
    "fips": 42057,
    "state": "PA",
    "area_name": "Fulton County"
  },
  {
    "fips": 42059,
    "state": "PA",
    "area_name": "Greene County"
  },
  {
    "fips": 42061,
    "state": "PA",
    "area_name": "Huntingdon County"
  },
  {
    "fips": 42063,
    "state": "PA",
    "area_name": "Indiana County"
  },
  {
    "fips": 42065,
    "state": "PA",
    "area_name": "Jefferson County"
  },
  {
    "fips": 42067,
    "state": "PA",
    "area_name": "Juniata County"
  },
  {
    "fips": 42069,
    "state": "PA",
    "area_name": "Lackawanna County"
  },
  {
    "fips": 42071,
    "state": "PA",
    "area_name": "Lancaster County"
  },
  {
    "fips": 42073,
    "state": "PA",
    "area_name": "Lawrence County"
  },
  {
    "fips": 42075,
    "state": "PA",
    "area_name": "Lebanon County"
  },
  {
    "fips": 42077,
    "state": "PA",
    "area_name": "Lehigh County"
  },
  {
    "fips": 42079,
    "state": "PA",
    "area_name": "Luzerne County"
  },
  {
    "fips": 42081,
    "state": "PA",
    "area_name": "Lycoming County"
  },
  {
    "fips": 42083,
    "state": "PA",
    "area_name": "McKean County"
  },
  {
    "fips": 42085,
    "state": "PA",
    "area_name": "Mercer County"
  },
  {
    "fips": 42087,
    "state": "PA",
    "area_name": "Mifflin County"
  },
  {
    "fips": 42089,
    "state": "PA",
    "area_name": "Monroe County"
  },
  {
    "fips": 42091,
    "state": "PA",
    "area_name": "Montgomery County"
  },
  {
    "fips": 42093,
    "state": "PA",
    "area_name": "Montour County"
  },
  {
    "fips": 42095,
    "state": "PA",
    "area_name": "Northampton County"
  },
  {
    "fips": 42097,
    "state": "PA",
    "area_name": "Northumberland County"
  },
  {
    "fips": 42099,
    "state": "PA",
    "area_name": "Perry County"
  },
  {
    "fips": 42101,
    "state": "PA",
    "area_name": "Philadelphia County"
  },
  {
    "fips": 42103,
    "state": "PA",
    "area_name": "Pike County"
  },
  {
    "fips": 42105,
    "state": "PA",
    "area_name": "Potter County"
  },
  {
    "fips": 42107,
    "state": "PA",
    "area_name": "Schuylkill County"
  },
  {
    "fips": 42109,
    "state": "PA",
    "area_name": "Snyder County"
  },
  {
    "fips": 42111,
    "state": "PA",
    "area_name": "Somerset County"
  },
  {
    "fips": 42113,
    "state": "PA",
    "area_name": "Sullivan County"
  },
  {
    "fips": 42115,
    "state": "PA",
    "area_name": "Susquehanna County"
  },
  {
    "fips": 42117,
    "state": "PA",
    "area_name": "Tioga County"
  },
  {
    "fips": 42119,
    "state": "PA",
    "area_name": "Union County"
  },
  {
    "fips": 42121,
    "state": "PA",
    "area_name": "Venango County"
  },
  {
    "fips": 42123,
    "state": "PA",
    "area_name": "Warren County"
  },
  {
    "fips": 42125,
    "state": "PA",
    "area_name": "Washington County"
  },
  {
    "fips": 42127,
    "state": "PA",
    "area_name": "Wayne County"
  },
  {
    "fips": 42129,
    "state": "PA",
    "area_name": "Westmoreland County"
  },
  {
    "fips": 42131,
    "state": "PA",
    "area_name": "Wyoming County"
  },
  {
    "fips": 42133,
    "state": "PA",
    "area_name": "York County"
  },
  {
    "fips": 44001,
    "state": "RI",
    "area_name": "Bristol County"
  },
  {
    "fips": 44003,
    "state": "RI",
    "area_name": "Kent County"
  },
  {
    "fips": 44005,
    "state": "RI",
    "area_name": "Newport County"
  },
  {
    "fips": 44007,
    "state": "RI",
    "area_name": "Providence County"
  },
  {
    "fips": 44009,
    "state": "RI",
    "area_name": "Washington County"
  },
  {
    "fips": 45001,
    "state": "SC",
    "area_name": "Abbeville County"
  },
  {
    "fips": 45003,
    "state": "SC",
    "area_name": "Aiken County"
  },
  {
    "fips": 45005,
    "state": "SC",
    "area_name": "Allendale County"
  },
  {
    "fips": 45007,
    "state": "SC",
    "area_name": "Anderson County"
  },
  {
    "fips": 45009,
    "state": "SC",
    "area_name": "Bamberg County"
  },
  {
    "fips": 45011,
    "state": "SC",
    "area_name": "Barnwell County"
  },
  {
    "fips": 45013,
    "state": "SC",
    "area_name": "Beaufort County"
  },
  {
    "fips": 45015,
    "state": "SC",
    "area_name": "Berkeley County"
  },
  {
    "fips": 45017,
    "state": "SC",
    "area_name": "Calhoun County"
  },
  {
    "fips": 45019,
    "state": "SC",
    "area_name": "Charleston County"
  },
  {
    "fips": 45021,
    "state": "SC",
    "area_name": "Cherokee County"
  },
  {
    "fips": 45023,
    "state": "SC",
    "area_name": "Chester County"
  },
  {
    "fips": 45025,
    "state": "SC",
    "area_name": "Chesterfield County"
  },
  {
    "fips": 45027,
    "state": "SC",
    "area_name": "Clarendon County"
  },
  {
    "fips": 45029,
    "state": "SC",
    "area_name": "Colleton County"
  },
  {
    "fips": 45031,
    "state": "SC",
    "area_name": "Darlington County"
  },
  {
    "fips": 45033,
    "state": "SC",
    "area_name": "Dillon County"
  },
  {
    "fips": 45035,
    "state": "SC",
    "area_name": "Dorchester County"
  },
  {
    "fips": 45037,
    "state": "SC",
    "area_name": "Edgefield County"
  },
  {
    "fips": 45039,
    "state": "SC",
    "area_name": "Fairfield County"
  },
  {
    "fips": 45041,
    "state": "SC",
    "area_name": "Florence County"
  },
  {
    "fips": 45043,
    "state": "SC",
    "area_name": "Georgetown County"
  },
  {
    "fips": 45045,
    "state": "SC",
    "area_name": "Greenville County"
  },
  {
    "fips": 45047,
    "state": "SC",
    "area_name": "Greenwood County"
  },
  {
    "fips": 45049,
    "state": "SC",
    "area_name": "Hampton County"
  },
  {
    "fips": 45051,
    "state": "SC",
    "area_name": "Horry County"
  },
  {
    "fips": 45053,
    "state": "SC",
    "area_name": "Jasper County"
  },
  {
    "fips": 45055,
    "state": "SC",
    "area_name": "Kershaw County"
  },
  {
    "fips": 45057,
    "state": "SC",
    "area_name": "Lancaster County"
  },
  {
    "fips": 45059,
    "state": "SC",
    "area_name": "Laurens County"
  },
  {
    "fips": 45061,
    "state": "SC",
    "area_name": "Lee County"
  },
  {
    "fips": 45063,
    "state": "SC",
    "area_name": "Lexington County"
  },
  {
    "fips": 45065,
    "state": "SC",
    "area_name": "McCormick County"
  },
  {
    "fips": 45067,
    "state": "SC",
    "area_name": "Marion County"
  },
  {
    "fips": 45069,
    "state": "SC",
    "area_name": "Marlboro County"
  },
  {
    "fips": 45071,
    "state": "SC",
    "area_name": "Newberry County"
  },
  {
    "fips": 45073,
    "state": "SC",
    "area_name": "Oconee County"
  },
  {
    "fips": 45075,
    "state": "SC",
    "area_name": "Orangeburg County"
  },
  {
    "fips": 45077,
    "state": "SC",
    "area_name": "Pickens County"
  },
  {
    "fips": 45079,
    "state": "SC",
    "area_name": "Richland County"
  },
  {
    "fips": 45081,
    "state": "SC",
    "area_name": "Saluda County"
  },
  {
    "fips": 45083,
    "state": "SC",
    "area_name": "Spartanburg County"
  },
  {
    "fips": 45085,
    "state": "SC",
    "area_name": "Sumter County"
  },
  {
    "fips": 45087,
    "state": "SC",
    "area_name": "Union County"
  },
  {
    "fips": 45089,
    "state": "SC",
    "area_name": "Williamsburg County"
  },
  {
    "fips": 45091,
    "state": "SC",
    "area_name": "York County"
  },
  {
    "fips": 46003,
    "state": "SD",
    "area_name": "Aurora County"
  },
  {
    "fips": 46005,
    "state": "SD",
    "area_name": "Beadle County"
  },
  {
    "fips": 46007,
    "state": "SD",
    "area_name": "Bennett County"
  },
  {
    "fips": 46009,
    "state": "SD",
    "area_name": "Bon Homme County"
  },
  {
    "fips": 46011,
    "state": "SD",
    "area_name": "Brookings County"
  },
  {
    "fips": 46013,
    "state": "SD",
    "area_name": "Brown County"
  },
  {
    "fips": 46015,
    "state": "SD",
    "area_name": "Brule County"
  },
  {
    "fips": 46017,
    "state": "SD",
    "area_name": "Buffalo County"
  },
  {
    "fips": 46019,
    "state": "SD",
    "area_name": "Butte County"
  },
  {
    "fips": 46021,
    "state": "SD",
    "area_name": "Campbell County"
  },
  {
    "fips": 46023,
    "state": "SD",
    "area_name": "Charles Mix County"
  },
  {
    "fips": 46025,
    "state": "SD",
    "area_name": "Clark County"
  },
  {
    "fips": 46027,
    "state": "SD",
    "area_name": "Clay County"
  },
  {
    "fips": 46029,
    "state": "SD",
    "area_name": "Codington County"
  },
  {
    "fips": 46031,
    "state": "SD",
    "area_name": "Corson County"
  },
  {
    "fips": 46033,
    "state": "SD",
    "area_name": "Custer County"
  },
  {
    "fips": 46035,
    "state": "SD",
    "area_name": "Davison County"
  },
  {
    "fips": 46037,
    "state": "SD",
    "area_name": "Day County"
  },
  {
    "fips": 46039,
    "state": "SD",
    "area_name": "Deuel County"
  },
  {
    "fips": 46041,
    "state": "SD",
    "area_name": "Dewey County"
  },
  {
    "fips": 46043,
    "state": "SD",
    "area_name": "Douglas County"
  },
  {
    "fips": 46045,
    "state": "SD",
    "area_name": "Edmunds County"
  },
  {
    "fips": 46047,
    "state": "SD",
    "area_name": "Fall River County"
  },
  {
    "fips": 46049,
    "state": "SD",
    "area_name": "Faulk County"
  },
  {
    "fips": 46051,
    "state": "SD",
    "area_name": "Grant County"
  },
  {
    "fips": 46053,
    "state": "SD",
    "area_name": "Gregory County"
  },
  {
    "fips": 46055,
    "state": "SD",
    "area_name": "Haakon County"
  },
  {
    "fips": 46057,
    "state": "SD",
    "area_name": "Hamlin County"
  },
  {
    "fips": 46059,
    "state": "SD",
    "area_name": "Hand County"
  },
  {
    "fips": 46061,
    "state": "SD",
    "area_name": "Hanson County"
  },
  {
    "fips": 46063,
    "state": "SD",
    "area_name": "Harding County"
  },
  {
    "fips": 46065,
    "state": "SD",
    "area_name": "Hughes County"
  },
  {
    "fips": 46067,
    "state": "SD",
    "area_name": "Hutchinson County"
  },
  {
    "fips": 46069,
    "state": "SD",
    "area_name": "Hyde County"
  },
  {
    "fips": 46071,
    "state": "SD",
    "area_name": "Jackson County"
  },
  {
    "fips": 46073,
    "state": "SD",
    "area_name": "Jerauld County"
  },
  {
    "fips": 46075,
    "state": "SD",
    "area_name": "Jones County"
  },
  {
    "fips": 46077,
    "state": "SD",
    "area_name": "Kingsbury County"
  },
  {
    "fips": 46079,
    "state": "SD",
    "area_name": "Lake County"
  },
  {
    "fips": 46081,
    "state": "SD",
    "area_name": "Lawrence County"
  },
  {
    "fips": 46083,
    "state": "SD",
    "area_name": "Lincoln County"
  },
  {
    "fips": 46085,
    "state": "SD",
    "area_name": "Lyman County"
  },
  {
    "fips": 46087,
    "state": "SD",
    "area_name": "McCook County"
  },
  {
    "fips": 46089,
    "state": "SD",
    "area_name": "McPherson County"
  },
  {
    "fips": 46091,
    "state": "SD",
    "area_name": "Marshall County"
  },
  {
    "fips": 46093,
    "state": "SD",
    "area_name": "Meade County"
  },
  {
    "fips": 46095,
    "state": "SD",
    "area_name": "Mellette County"
  },
  {
    "fips": 46097,
    "state": "SD",
    "area_name": "Miner County"
  },
  {
    "fips": 46099,
    "state": "SD",
    "area_name": "Minnehaha County"
  },
  {
    "fips": 46101,
    "state": "SD",
    "area_name": "Moody County"
  },
  {
    "fips": 46103,
    "state": "SD",
    "area_name": "Pennington County"
  },
  {
    "fips": 46105,
    "state": "SD",
    "area_name": "Perkins County"
  },
  {
    "fips": 46107,
    "state": "SD",
    "area_name": "Potter County"
  },
  {
    "fips": 46109,
    "state": "SD",
    "area_name": "Roberts County"
  },
  {
    "fips": 46111,
    "state": "SD",
    "area_name": "Sanborn County"
  },
  {
    "fips": 46102,
    "state": "SD",
    "area_name": "Oglala Lakota County"
  },
  {
    "fips": 46115,
    "state": "SD",
    "area_name": "Spink County"
  },
  {
    "fips": 46117,
    "state": "SD",
    "area_name": "Stanley County"
  },
  {
    "fips": 46119,
    "state": "SD",
    "area_name": "Sully County"
  },
  {
    "fips": 46121,
    "state": "SD",
    "area_name": "Todd County"
  },
  {
    "fips": 46123,
    "state": "SD",
    "area_name": "Tripp County"
  },
  {
    "fips": 46125,
    "state": "SD",
    "area_name": "Turner County"
  },
  {
    "fips": 46127,
    "state": "SD",
    "area_name": "Union County"
  },
  {
    "fips": 46129,
    "state": "SD",
    "area_name": "Walworth County"
  },
  {
    "fips": 46135,
    "state": "SD",
    "area_name": "Yankton County"
  },
  {
    "fips": 46137,
    "state": "SD",
    "area_name": "Ziebach County"
  },
  {
    "fips": 47001,
    "state": "TN",
    "area_name": "Anderson County"
  },
  {
    "fips": 47003,
    "state": "TN",
    "area_name": "Bedford County"
  },
  {
    "fips": 47005,
    "state": "TN",
    "area_name": "Benton County"
  },
  {
    "fips": 47007,
    "state": "TN",
    "area_name": "Bledsoe County"
  },
  {
    "fips": 47009,
    "state": "TN",
    "area_name": "Blount County"
  },
  {
    "fips": 47011,
    "state": "TN",
    "area_name": "Bradley County"
  },
  {
    "fips": 47013,
    "state": "TN",
    "area_name": "Campbell County"
  },
  {
    "fips": 47015,
    "state": "TN",
    "area_name": "Cannon County"
  },
  {
    "fips": 47017,
    "state": "TN",
    "area_name": "Carroll County"
  },
  {
    "fips": 47019,
    "state": "TN",
    "area_name": "Carter County"
  },
  {
    "fips": 47021,
    "state": "TN",
    "area_name": "Cheatham County"
  },
  {
    "fips": 47023,
    "state": "TN",
    "area_name": "Chester County"
  },
  {
    "fips": 47025,
    "state": "TN",
    "area_name": "Claiborne County"
  },
  {
    "fips": 47027,
    "state": "TN",
    "area_name": "Clay County"
  },
  {
    "fips": 47029,
    "state": "TN",
    "area_name": "Cocke County"
  },
  {
    "fips": 47031,
    "state": "TN",
    "area_name": "Coffee County"
  },
  {
    "fips": 47033,
    "state": "TN",
    "area_name": "Crockett County"
  },
  {
    "fips": 47035,
    "state": "TN",
    "area_name": "Cumberland County"
  },
  {
    "fips": 47037,
    "state": "TN",
    "area_name": "Davidson County"
  },
  {
    "fips": 47039,
    "state": "TN",
    "area_name": "Decatur County"
  },
  {
    "fips": 47041,
    "state": "TN",
    "area_name": "DeKalb County"
  },
  {
    "fips": 47043,
    "state": "TN",
    "area_name": "Dickson County"
  },
  {
    "fips": 47045,
    "state": "TN",
    "area_name": "Dyer County"
  },
  {
    "fips": 47047,
    "state": "TN",
    "area_name": "Fayette County"
  },
  {
    "fips": 47049,
    "state": "TN",
    "area_name": "Fentress County"
  },
  {
    "fips": 47051,
    "state": "TN",
    "area_name": "Franklin County"
  },
  {
    "fips": 47053,
    "state": "TN",
    "area_name": "Gibson County"
  },
  {
    "fips": 47055,
    "state": "TN",
    "area_name": "Giles County"
  },
  {
    "fips": 47057,
    "state": "TN",
    "area_name": "Grainger County"
  },
  {
    "fips": 47059,
    "state": "TN",
    "area_name": "Greene County"
  },
  {
    "fips": 47061,
    "state": "TN",
    "area_name": "Grundy County"
  },
  {
    "fips": 47063,
    "state": "TN",
    "area_name": "Hamblen County"
  },
  {
    "fips": 47065,
    "state": "TN",
    "area_name": "Hamilton County"
  },
  {
    "fips": 47067,
    "state": "TN",
    "area_name": "Hancock County"
  },
  {
    "fips": 47069,
    "state": "TN",
    "area_name": "Hardeman County"
  },
  {
    "fips": 47071,
    "state": "TN",
    "area_name": "Hardin County"
  },
  {
    "fips": 47073,
    "state": "TN",
    "area_name": "Hawkins County"
  },
  {
    "fips": 47075,
    "state": "TN",
    "area_name": "Haywood County"
  },
  {
    "fips": 47077,
    "state": "TN",
    "area_name": "Henderson County"
  },
  {
    "fips": 47079,
    "state": "TN",
    "area_name": "Henry County"
  },
  {
    "fips": 47081,
    "state": "TN",
    "area_name": "Hickman County"
  },
  {
    "fips": 47083,
    "state": "TN",
    "area_name": "Houston County"
  },
  {
    "fips": 47085,
    "state": "TN",
    "area_name": "Humphreys County"
  },
  {
    "fips": 47087,
    "state": "TN",
    "area_name": "Jackson County"
  },
  {
    "fips": 47089,
    "state": "TN",
    "area_name": "Jefferson County"
  },
  {
    "fips": 47091,
    "state": "TN",
    "area_name": "Johnson County"
  },
  {
    "fips": 47093,
    "state": "TN",
    "area_name": "Knox County"
  },
  {
    "fips": 47095,
    "state": "TN",
    "area_name": "Lake County"
  },
  {
    "fips": 47097,
    "state": "TN",
    "area_name": "Lauderdale County"
  },
  {
    "fips": 47099,
    "state": "TN",
    "area_name": "Lawrence County"
  },
  {
    "fips": 47101,
    "state": "TN",
    "area_name": "Lewis County"
  },
  {
    "fips": 47103,
    "state": "TN",
    "area_name": "Lincoln County"
  },
  {
    "fips": 47105,
    "state": "TN",
    "area_name": "Loudon County"
  },
  {
    "fips": 47107,
    "state": "TN",
    "area_name": "McMinn County"
  },
  {
    "fips": 47109,
    "state": "TN",
    "area_name": "McNairy County"
  },
  {
    "fips": 47111,
    "state": "TN",
    "area_name": "Macon County"
  },
  {
    "fips": 47113,
    "state": "TN",
    "area_name": "Madison County"
  },
  {
    "fips": 47115,
    "state": "TN",
    "area_name": "Marion County"
  },
  {
    "fips": 47117,
    "state": "TN",
    "area_name": "Marshall County"
  },
  {
    "fips": 47119,
    "state": "TN",
    "area_name": "Maury County"
  },
  {
    "fips": 47121,
    "state": "TN",
    "area_name": "Meigs County"
  },
  {
    "fips": 47123,
    "state": "TN",
    "area_name": "Monroe County"
  },
  {
    "fips": 47125,
    "state": "TN",
    "area_name": "Montgomery County"
  },
  {
    "fips": 47127,
    "state": "TN",
    "area_name": "Moore County"
  },
  {
    "fips": 47129,
    "state": "TN",
    "area_name": "Morgan County"
  },
  {
    "fips": 47131,
    "state": "TN",
    "area_name": "Obion County"
  },
  {
    "fips": 47133,
    "state": "TN",
    "area_name": "Overton County"
  },
  {
    "fips": 47135,
    "state": "TN",
    "area_name": "Perry County"
  },
  {
    "fips": 47137,
    "state": "TN",
    "area_name": "Pickett County"
  },
  {
    "fips": 47139,
    "state": "TN",
    "area_name": "Polk County"
  },
  {
    "fips": 47141,
    "state": "TN",
    "area_name": "Putnam County"
  },
  {
    "fips": 47143,
    "state": "TN",
    "area_name": "Rhea County"
  },
  {
    "fips": 47145,
    "state": "TN",
    "area_name": "Roane County"
  },
  {
    "fips": 47147,
    "state": "TN",
    "area_name": "Robertson County"
  },
  {
    "fips": 47149,
    "state": "TN",
    "area_name": "Rutherford County"
  },
  {
    "fips": 47151,
    "state": "TN",
    "area_name": "Scott County"
  },
  {
    "fips": 47153,
    "state": "TN",
    "area_name": "Sequatchie County"
  },
  {
    "fips": 47155,
    "state": "TN",
    "area_name": "Sevier County"
  },
  {
    "fips": 47157,
    "state": "TN",
    "area_name": "Shelby County"
  },
  {
    "fips": 47159,
    "state": "TN",
    "area_name": "Smith County"
  },
  {
    "fips": 47161,
    "state": "TN",
    "area_name": "Stewart County"
  },
  {
    "fips": 47163,
    "state": "TN",
    "area_name": "Sullivan County"
  },
  {
    "fips": 47165,
    "state": "TN",
    "area_name": "Sumner County"
  },
  {
    "fips": 47167,
    "state": "TN",
    "area_name": "Tipton County"
  },
  {
    "fips": 47169,
    "state": "TN",
    "area_name": "Trousdale County"
  },
  {
    "fips": 47171,
    "state": "TN",
    "area_name": "Unicoi County"
  },
  {
    "fips": 47173,
    "state": "TN",
    "area_name": "Union County"
  },
  {
    "fips": 47175,
    "state": "TN",
    "area_name": "Van Buren County"
  },
  {
    "fips": 47177,
    "state": "TN",
    "area_name": "Warren County"
  },
  {
    "fips": 47179,
    "state": "TN",
    "area_name": "Washington County"
  },
  {
    "fips": 47181,
    "state": "TN",
    "area_name": "Wayne County"
  },
  {
    "fips": 47183,
    "state": "TN",
    "area_name": "Weakley County"
  },
  {
    "fips": 47185,
    "state": "TN",
    "area_name": "White County"
  },
  {
    "fips": 47187,
    "state": "TN",
    "area_name": "Williamson County"
  },
  {
    "fips": 47189,
    "state": "TN",
    "area_name": "Wilson County"
  },
  {
    "fips": 48001,
    "state": "TX",
    "area_name": "Anderson County"
  },
  {
    "fips": 48003,
    "state": "TX",
    "area_name": "Andrews County"
  },
  {
    "fips": 48005,
    "state": "TX",
    "area_name": "Angelina County"
  },
  {
    "fips": 48007,
    "state": "TX",
    "area_name": "Aransas County"
  },
  {
    "fips": 48009,
    "state": "TX",
    "area_name": "Archer County"
  },
  {
    "fips": 48011,
    "state": "TX",
    "area_name": "Armstrong County"
  },
  {
    "fips": 48013,
    "state": "TX",
    "area_name": "Atascosa County"
  },
  {
    "fips": 48015,
    "state": "TX",
    "area_name": "Austin County"
  },
  {
    "fips": 48017,
    "state": "TX",
    "area_name": "Bailey County"
  },
  {
    "fips": 48019,
    "state": "TX",
    "area_name": "Bandera County"
  },
  {
    "fips": 48021,
    "state": "TX",
    "area_name": "Bastrop County"
  },
  {
    "fips": 48023,
    "state": "TX",
    "area_name": "Baylor County"
  },
  {
    "fips": 48025,
    "state": "TX",
    "area_name": "Bee County"
  },
  {
    "fips": 48027,
    "state": "TX",
    "area_name": "Bell County"
  },
  {
    "fips": 48029,
    "state": "TX",
    "area_name": "Bexar County"
  },
  {
    "fips": 48031,
    "state": "TX",
    "area_name": "Blanco County"
  },
  {
    "fips": 48033,
    "state": "TX",
    "area_name": "Borden County"
  },
  {
    "fips": 48035,
    "state": "TX",
    "area_name": "Bosque County"
  },
  {
    "fips": 48037,
    "state": "TX",
    "area_name": "Bowie County"
  },
  {
    "fips": 48039,
    "state": "TX",
    "area_name": "Brazoria County"
  },
  {
    "fips": 48041,
    "state": "TX",
    "area_name": "Brazos County"
  },
  {
    "fips": 48043,
    "state": "TX",
    "area_name": "Brewster County"
  },
  {
    "fips": 48045,
    "state": "TX",
    "area_name": "Briscoe County"
  },
  {
    "fips": 48047,
    "state": "TX",
    "area_name": "Brooks County"
  },
  {
    "fips": 48049,
    "state": "TX",
    "area_name": "Brown County"
  },
  {
    "fips": 48051,
    "state": "TX",
    "area_name": "Burleson County"
  },
  {
    "fips": 48053,
    "state": "TX",
    "area_name": "Burnet County"
  },
  {
    "fips": 48055,
    "state": "TX",
    "area_name": "Caldwell County"
  },
  {
    "fips": 48057,
    "state": "TX",
    "area_name": "Calhoun County"
  },
  {
    "fips": 48059,
    "state": "TX",
    "area_name": "Callahan County"
  },
  {
    "fips": 48061,
    "state": "TX",
    "area_name": "Cameron County"
  },
  {
    "fips": 48063,
    "state": "TX",
    "area_name": "Camp County"
  },
  {
    "fips": 48065,
    "state": "TX",
    "area_name": "Carson County"
  },
  {
    "fips": 48067,
    "state": "TX",
    "area_name": "Cass County"
  },
  {
    "fips": 48069,
    "state": "TX",
    "area_name": "Castro County"
  },
  {
    "fips": 48071,
    "state": "TX",
    "area_name": "Chambers County"
  },
  {
    "fips": 48073,
    "state": "TX",
    "area_name": "Cherokee County"
  },
  {
    "fips": 48075,
    "state": "TX",
    "area_name": "Childress County"
  },
  {
    "fips": 48077,
    "state": "TX",
    "area_name": "Clay County"
  },
  {
    "fips": 48079,
    "state": "TX",
    "area_name": "Cochran County"
  },
  {
    "fips": 48081,
    "state": "TX",
    "area_name": "Coke County"
  },
  {
    "fips": 48083,
    "state": "TX",
    "area_name": "Coleman County"
  },
  {
    "fips": 48085,
    "state": "TX",
    "area_name": "Collin County"
  },
  {
    "fips": 48087,
    "state": "TX",
    "area_name": "Collingsworth County"
  },
  {
    "fips": 48089,
    "state": "TX",
    "area_name": "Colorado County"
  },
  {
    "fips": 48091,
    "state": "TX",
    "area_name": "Comal County"
  },
  {
    "fips": 48093,
    "state": "TX",
    "area_name": "Comanche County"
  },
  {
    "fips": 48095,
    "state": "TX",
    "area_name": "Concho County"
  },
  {
    "fips": 48097,
    "state": "TX",
    "area_name": "Cooke County"
  },
  {
    "fips": 48099,
    "state": "TX",
    "area_name": "Coryell County"
  },
  {
    "fips": 48101,
    "state": "TX",
    "area_name": "Cottle County"
  },
  {
    "fips": 48103,
    "state": "TX",
    "area_name": "Crane County"
  },
  {
    "fips": 48105,
    "state": "TX",
    "area_name": "Crockett County"
  },
  {
    "fips": 48107,
    "state": "TX",
    "area_name": "Crosby County"
  },
  {
    "fips": 48109,
    "state": "TX",
    "area_name": "Culberson County"
  },
  {
    "fips": 48111,
    "state": "TX",
    "area_name": "Dallam County"
  },
  {
    "fips": 48113,
    "state": "TX",
    "area_name": "Dallas County"
  },
  {
    "fips": 48115,
    "state": "TX",
    "area_name": "Dawson County"
  },
  {
    "fips": 48117,
    "state": "TX",
    "area_name": "Deaf Smith County"
  },
  {
    "fips": 48119,
    "state": "TX",
    "area_name": "Delta County"
  },
  {
    "fips": 48121,
    "state": "TX",
    "area_name": "Denton County"
  },
  {
    "fips": 48123,
    "state": "TX",
    "area_name": "DeWitt County"
  },
  {
    "fips": 48125,
    "state": "TX",
    "area_name": "Dickens County"
  },
  {
    "fips": 48127,
    "state": "TX",
    "area_name": "Dimmit County"
  },
  {
    "fips": 48129,
    "state": "TX",
    "area_name": "Donley County"
  },
  {
    "fips": 48131,
    "state": "TX",
    "area_name": "Duval County"
  },
  {
    "fips": 48133,
    "state": "TX",
    "area_name": "Eastland County"
  },
  {
    "fips": 48135,
    "state": "TX",
    "area_name": "Ector County"
  },
  {
    "fips": 48137,
    "state": "TX",
    "area_name": "Edwards County"
  },
  {
    "fips": 48139,
    "state": "TX",
    "area_name": "Ellis County"
  },
  {
    "fips": 48141,
    "state": "TX",
    "area_name": "El Paso County"
  },
  {
    "fips": 48143,
    "state": "TX",
    "area_name": "Erath County"
  },
  {
    "fips": 48145,
    "state": "TX",
    "area_name": "Falls County"
  },
  {
    "fips": 48147,
    "state": "TX",
    "area_name": "Fannin County"
  },
  {
    "fips": 48149,
    "state": "TX",
    "area_name": "Fayette County"
  },
  {
    "fips": 48151,
    "state": "TX",
    "area_name": "Fisher County"
  },
  {
    "fips": 48153,
    "state": "TX",
    "area_name": "Floyd County"
  },
  {
    "fips": 48155,
    "state": "TX",
    "area_name": "Foard County"
  },
  {
    "fips": 48157,
    "state": "TX",
    "area_name": "Fort Bend County"
  },
  {
    "fips": 48159,
    "state": "TX",
    "area_name": "Franklin County"
  },
  {
    "fips": 48161,
    "state": "TX",
    "area_name": "Freestone County"
  },
  {
    "fips": 48163,
    "state": "TX",
    "area_name": "Frio County"
  },
  {
    "fips": 48165,
    "state": "TX",
    "area_name": "Gaines County"
  },
  {
    "fips": 48167,
    "state": "TX",
    "area_name": "Galveston County"
  },
  {
    "fips": 48169,
    "state": "TX",
    "area_name": "Garza County"
  },
  {
    "fips": 48171,
    "state": "TX",
    "area_name": "Gillespie County"
  },
  {
    "fips": 48173,
    "state": "TX",
    "area_name": "Glasscock County"
  },
  {
    "fips": 48175,
    "state": "TX",
    "area_name": "Goliad County"
  },
  {
    "fips": 48177,
    "state": "TX",
    "area_name": "Gonzales County"
  },
  {
    "fips": 48179,
    "state": "TX",
    "area_name": "Gray County"
  },
  {
    "fips": 48181,
    "state": "TX",
    "area_name": "Grayson County"
  },
  {
    "fips": 48183,
    "state": "TX",
    "area_name": "Gregg County"
  },
  {
    "fips": 48185,
    "state": "TX",
    "area_name": "Grimes County"
  },
  {
    "fips": 48187,
    "state": "TX",
    "area_name": "Guadalupe County"
  },
  {
    "fips": 48189,
    "state": "TX",
    "area_name": "Hale County"
  },
  {
    "fips": 48191,
    "state": "TX",
    "area_name": "Hall County"
  },
  {
    "fips": 48193,
    "state": "TX",
    "area_name": "Hamilton County"
  },
  {
    "fips": 48195,
    "state": "TX",
    "area_name": "Hansford County"
  },
  {
    "fips": 48197,
    "state": "TX",
    "area_name": "Hardeman County"
  },
  {
    "fips": 48199,
    "state": "TX",
    "area_name": "Hardin County"
  },
  {
    "fips": 48201,
    "state": "TX",
    "area_name": "Harris County"
  },
  {
    "fips": 48203,
    "state": "TX",
    "area_name": "Harrison County"
  },
  {
    "fips": 48205,
    "state": "TX",
    "area_name": "Hartley County"
  },
  {
    "fips": 48207,
    "state": "TX",
    "area_name": "Haskell County"
  },
  {
    "fips": 48209,
    "state": "TX",
    "area_name": "Hays County"
  },
  {
    "fips": 48211,
    "state": "TX",
    "area_name": "Hemphill County"
  },
  {
    "fips": 48213,
    "state": "TX",
    "area_name": "Henderson County"
  },
  {
    "fips": 48215,
    "state": "TX",
    "area_name": "Hidalgo County"
  },
  {
    "fips": 48217,
    "state": "TX",
    "area_name": "Hill County"
  },
  {
    "fips": 48219,
    "state": "TX",
    "area_name": "Hockley County"
  },
  {
    "fips": 48221,
    "state": "TX",
    "area_name": "Hood County"
  },
  {
    "fips": 48223,
    "state": "TX",
    "area_name": "Hopkins County"
  },
  {
    "fips": 48225,
    "state": "TX",
    "area_name": "Houston County"
  },
  {
    "fips": 48227,
    "state": "TX",
    "area_name": "Howard County"
  },
  {
    "fips": 48229,
    "state": "TX",
    "area_name": "Hudspeth County"
  },
  {
    "fips": 48231,
    "state": "TX",
    "area_name": "Hunt County"
  },
  {
    "fips": 48233,
    "state": "TX",
    "area_name": "Hutchinson County"
  },
  {
    "fips": 48235,
    "state": "TX",
    "area_name": "Irion County"
  },
  {
    "fips": 48237,
    "state": "TX",
    "area_name": "Jack County"
  },
  {
    "fips": 48239,
    "state": "TX",
    "area_name": "Jackson County"
  },
  {
    "fips": 48241,
    "state": "TX",
    "area_name": "Jasper County"
  },
  {
    "fips": 48243,
    "state": "TX",
    "area_name": "Jeff Davis County"
  },
  {
    "fips": 48245,
    "state": "TX",
    "area_name": "Jefferson County"
  },
  {
    "fips": 48247,
    "state": "TX",
    "area_name": "Jim Hogg County"
  },
  {
    "fips": 48249,
    "state": "TX",
    "area_name": "Jim Wells County"
  },
  {
    "fips": 48251,
    "state": "TX",
    "area_name": "Johnson County"
  },
  {
    "fips": 48253,
    "state": "TX",
    "area_name": "Jones County"
  },
  {
    "fips": 48255,
    "state": "TX",
    "area_name": "Karnes County"
  },
  {
    "fips": 48257,
    "state": "TX",
    "area_name": "Kaufman County"
  },
  {
    "fips": 48259,
    "state": "TX",
    "area_name": "Kendall County"
  },
  {
    "fips": 48261,
    "state": "TX",
    "area_name": "Kenedy County"
  },
  {
    "fips": 48263,
    "state": "TX",
    "area_name": "Kent County"
  },
  {
    "fips": 48265,
    "state": "TX",
    "area_name": "Kerr County"
  },
  {
    "fips": 48267,
    "state": "TX",
    "area_name": "Kimble County"
  },
  {
    "fips": 48269,
    "state": "TX",
    "area_name": "King County"
  },
  {
    "fips": 48271,
    "state": "TX",
    "area_name": "Kinney County"
  },
  {
    "fips": 48273,
    "state": "TX",
    "area_name": "Kleberg County"
  },
  {
    "fips": 48275,
    "state": "TX",
    "area_name": "Knox County"
  },
  {
    "fips": 48277,
    "state": "TX",
    "area_name": "Lamar County"
  },
  {
    "fips": 48279,
    "state": "TX",
    "area_name": "Lamb County"
  },
  {
    "fips": 48281,
    "state": "TX",
    "area_name": "Lampasas County"
  },
  {
    "fips": 48283,
    "state": "TX",
    "area_name": "La Salle County"
  },
  {
    "fips": 48285,
    "state": "TX",
    "area_name": "Lavaca County"
  },
  {
    "fips": 48287,
    "state": "TX",
    "area_name": "Lee County"
  },
  {
    "fips": 48289,
    "state": "TX",
    "area_name": "Leon County"
  },
  {
    "fips": 48291,
    "state": "TX",
    "area_name": "Liberty County"
  },
  {
    "fips": 48293,
    "state": "TX",
    "area_name": "Limestone County"
  },
  {
    "fips": 48295,
    "state": "TX",
    "area_name": "Lipscomb County"
  },
  {
    "fips": 48297,
    "state": "TX",
    "area_name": "Live Oak County"
  },
  {
    "fips": 48299,
    "state": "TX",
    "area_name": "Llano County"
  },
  {
    "fips": 48301,
    "state": "TX",
    "area_name": "Loving County"
  },
  {
    "fips": 48303,
    "state": "TX",
    "area_name": "Lubbock County"
  },
  {
    "fips": 48305,
    "state": "TX",
    "area_name": "Lynn County"
  },
  {
    "fips": 48307,
    "state": "TX",
    "area_name": "McCulloch County"
  },
  {
    "fips": 48309,
    "state": "TX",
    "area_name": "McLennan County"
  },
  {
    "fips": 48311,
    "state": "TX",
    "area_name": "McMullen County"
  },
  {
    "fips": 48313,
    "state": "TX",
    "area_name": "Madison County"
  },
  {
    "fips": 48315,
    "state": "TX",
    "area_name": "Marion County"
  },
  {
    "fips": 48317,
    "state": "TX",
    "area_name": "Martin County"
  },
  {
    "fips": 48319,
    "state": "TX",
    "area_name": "Mason County"
  },
  {
    "fips": 48321,
    "state": "TX",
    "area_name": "Matagorda County"
  },
  {
    "fips": 48323,
    "state": "TX",
    "area_name": "Maverick County"
  },
  {
    "fips": 48325,
    "state": "TX",
    "area_name": "Medina County"
  },
  {
    "fips": 48327,
    "state": "TX",
    "area_name": "Menard County"
  },
  {
    "fips": 48329,
    "state": "TX",
    "area_name": "Midland County"
  },
  {
    "fips": 48331,
    "state": "TX",
    "area_name": "Milam County"
  },
  {
    "fips": 48333,
    "state": "TX",
    "area_name": "Mills County"
  },
  {
    "fips": 48335,
    "state": "TX",
    "area_name": "Mitchell County"
  },
  {
    "fips": 48337,
    "state": "TX",
    "area_name": "Montague County"
  },
  {
    "fips": 48339,
    "state": "TX",
    "area_name": "Montgomery County"
  },
  {
    "fips": 48341,
    "state": "TX",
    "area_name": "Moore County"
  },
  {
    "fips": 48343,
    "state": "TX",
    "area_name": "Morris County"
  },
  {
    "fips": 48345,
    "state": "TX",
    "area_name": "Motley County"
  },
  {
    "fips": 48347,
    "state": "TX",
    "area_name": "Nacogdoches County"
  },
  {
    "fips": 48349,
    "state": "TX",
    "area_name": "Navarro County"
  },
  {
    "fips": 48351,
    "state": "TX",
    "area_name": "Newton County"
  },
  {
    "fips": 48353,
    "state": "TX",
    "area_name": "Nolan County"
  },
  {
    "fips": 48355,
    "state": "TX",
    "area_name": "Nueces County"
  },
  {
    "fips": 48357,
    "state": "TX",
    "area_name": "Ochiltree County"
  },
  {
    "fips": 48359,
    "state": "TX",
    "area_name": "Oldham County"
  },
  {
    "fips": 48361,
    "state": "TX",
    "area_name": "Orange County"
  },
  {
    "fips": 48363,
    "state": "TX",
    "area_name": "Palo Pinto County"
  },
  {
    "fips": 48365,
    "state": "TX",
    "area_name": "Panola County"
  },
  {
    "fips": 48367,
    "state": "TX",
    "area_name": "Parker County"
  },
  {
    "fips": 48369,
    "state": "TX",
    "area_name": "Parmer County"
  },
  {
    "fips": 48371,
    "state": "TX",
    "area_name": "Pecos County"
  },
  {
    "fips": 48373,
    "state": "TX",
    "area_name": "Polk County"
  },
  {
    "fips": 48375,
    "state": "TX",
    "area_name": "Potter County"
  },
  {
    "fips": 48377,
    "state": "TX",
    "area_name": "Presidio County"
  },
  {
    "fips": 48379,
    "state": "TX",
    "area_name": "Rains County"
  },
  {
    "fips": 48381,
    "state": "TX",
    "area_name": "Randall County"
  },
  {
    "fips": 48383,
    "state": "TX",
    "area_name": "Reagan County"
  },
  {
    "fips": 48385,
    "state": "TX",
    "area_name": "Real County"
  },
  {
    "fips": 48387,
    "state": "TX",
    "area_name": "Red River County"
  },
  {
    "fips": 48389,
    "state": "TX",
    "area_name": "Reeves County"
  },
  {
    "fips": 48391,
    "state": "TX",
    "area_name": "Refugio County"
  },
  {
    "fips": 48393,
    "state": "TX",
    "area_name": "Roberts County"
  },
  {
    "fips": 48395,
    "state": "TX",
    "area_name": "Robertson County"
  },
  {
    "fips": 48397,
    "state": "TX",
    "area_name": "Rockwall County"
  },
  {
    "fips": 48399,
    "state": "TX",
    "area_name": "Runnels County"
  },
  {
    "fips": 48401,
    "state": "TX",
    "area_name": "Rusk County"
  },
  {
    "fips": 48403,
    "state": "TX",
    "area_name": "Sabine County"
  },
  {
    "fips": 48405,
    "state": "TX",
    "area_name": "San Augustine County"
  },
  {
    "fips": 48407,
    "state": "TX",
    "area_name": "San Jacinto County"
  },
  {
    "fips": 48409,
    "state": "TX",
    "area_name": "San Patricio County"
  },
  {
    "fips": 48411,
    "state": "TX",
    "area_name": "San Saba County"
  },
  {
    "fips": 48413,
    "state": "TX",
    "area_name": "Schleicher County"
  },
  {
    "fips": 48415,
    "state": "TX",
    "area_name": "Scurry County"
  },
  {
    "fips": 48417,
    "state": "TX",
    "area_name": "Shackelford County"
  },
  {
    "fips": 48419,
    "state": "TX",
    "area_name": "Shelby County"
  },
  {
    "fips": 48421,
    "state": "TX",
    "area_name": "Sherman County"
  },
  {
    "fips": 48423,
    "state": "TX",
    "area_name": "Smith County"
  },
  {
    "fips": 48425,
    "state": "TX",
    "area_name": "Somervell County"
  },
  {
    "fips": 48427,
    "state": "TX",
    "area_name": "Starr County"
  },
  {
    "fips": 48429,
    "state": "TX",
    "area_name": "Stephens County"
  },
  {
    "fips": 48431,
    "state": "TX",
    "area_name": "Sterling County"
  },
  {
    "fips": 48433,
    "state": "TX",
    "area_name": "Stonewall County"
  },
  {
    "fips": 48435,
    "state": "TX",
    "area_name": "Sutton County"
  },
  {
    "fips": 48437,
    "state": "TX",
    "area_name": "Swisher County"
  },
  {
    "fips": 48439,
    "state": "TX",
    "area_name": "Tarrant County"
  },
  {
    "fips": 48441,
    "state": "TX",
    "area_name": "Taylor County"
  },
  {
    "fips": 48443,
    "state": "TX",
    "area_name": "Terrell County"
  },
  {
    "fips": 48445,
    "state": "TX",
    "area_name": "Terry County"
  },
  {
    "fips": 48447,
    "state": "TX",
    "area_name": "Throckmorton County"
  },
  {
    "fips": 48449,
    "state": "TX",
    "area_name": "Titus County"
  },
  {
    "fips": 48451,
    "state": "TX",
    "area_name": "Tom Green County"
  },
  {
    "fips": 48453,
    "state": "TX",
    "area_name": "Travis County"
  },
  {
    "fips": 48455,
    "state": "TX",
    "area_name": "Trinity County"
  },
  {
    "fips": 48457,
    "state": "TX",
    "area_name": "Tyler County"
  },
  {
    "fips": 48459,
    "state": "TX",
    "area_name": "Upshur County"
  },
  {
    "fips": 48461,
    "state": "TX",
    "area_name": "Upton County"
  },
  {
    "fips": 48463,
    "state": "TX",
    "area_name": "Uvalde County"
  },
  {
    "fips": 48465,
    "state": "TX",
    "area_name": "Val Verde County"
  },
  {
    "fips": 48467,
    "state": "TX",
    "area_name": "Van Zandt County"
  },
  {
    "fips": 48469,
    "state": "TX",
    "area_name": "Victoria County"
  },
  {
    "fips": 48471,
    "state": "TX",
    "area_name": "Walker County"
  },
  {
    "fips": 48473,
    "state": "TX",
    "area_name": "Waller County"
  },
  {
    "fips": 48475,
    "state": "TX",
    "area_name": "Ward County"
  },
  {
    "fips": 48477,
    "state": "TX",
    "area_name": "Washington County"
  },
  {
    "fips": 48479,
    "state": "TX",
    "area_name": "Webb County"
  },
  {
    "fips": 48481,
    "state": "TX",
    "area_name": "Wharton County"
  },
  {
    "fips": 48483,
    "state": "TX",
    "area_name": "Wheeler County"
  },
  {
    "fips": 48485,
    "state": "TX",
    "area_name": "Wichita County"
  },
  {
    "fips": 48487,
    "state": "TX",
    "area_name": "Wilbarger County"
  },
  {
    "fips": 48489,
    "state": "TX",
    "area_name": "Willacy County"
  },
  {
    "fips": 48491,
    "state": "TX",
    "area_name": "Williamson County"
  },
  {
    "fips": 48493,
    "state": "TX",
    "area_name": "Wilson County"
  },
  {
    "fips": 48495,
    "state": "TX",
    "area_name": "Winkler County"
  },
  {
    "fips": 48497,
    "state": "TX",
    "area_name": "Wise County"
  },
  {
    "fips": 48499,
    "state": "TX",
    "area_name": "Wood County"
  },
  {
    "fips": 48501,
    "state": "TX",
    "area_name": "Yoakum County"
  },
  {
    "fips": 48503,
    "state": "TX",
    "area_name": "Young County"
  },
  {
    "fips": 48505,
    "state": "TX",
    "area_name": "Zapata County"
  },
  {
    "fips": 48507,
    "state": "TX",
    "area_name": "Zavala County"
  },
  {
    "fips": 49001,
    "state": "UT",
    "area_name": "Beaver County"
  },
  {
    "fips": 49003,
    "state": "UT",
    "area_name": "Box Elder County"
  },
  {
    "fips": 49005,
    "state": "UT",
    "area_name": "Cache County"
  },
  {
    "fips": 49007,
    "state": "UT",
    "area_name": "Carbon County"
  },
  {
    "fips": 49009,
    "state": "UT",
    "area_name": "Daggett County"
  },
  {
    "fips": 49011,
    "state": "UT",
    "area_name": "Davis County"
  },
  {
    "fips": 49013,
    "state": "UT",
    "area_name": "Duchesne County"
  },
  {
    "fips": 49015,
    "state": "UT",
    "area_name": "Emery County"
  },
  {
    "fips": 49017,
    "state": "UT",
    "area_name": "Garfield County"
  },
  {
    "fips": 49019,
    "state": "UT",
    "area_name": "Grand County"
  },
  {
    "fips": 49021,
    "state": "UT",
    "area_name": "Iron County"
  },
  {
    "fips": 49023,
    "state": "UT",
    "area_name": "Juab County"
  },
  {
    "fips": 49025,
    "state": "UT",
    "area_name": "Kane County"
  },
  {
    "fips": 49027,
    "state": "UT",
    "area_name": "Millard County"
  },
  {
    "fips": 49029,
    "state": "UT",
    "area_name": "Morgan County"
  },
  {
    "fips": 49031,
    "state": "UT",
    "area_name": "Piute County"
  },
  {
    "fips": 49033,
    "state": "UT",
    "area_name": "Rich County"
  },
  {
    "fips": 49035,
    "state": "UT",
    "area_name": "Salt Lake County"
  },
  {
    "fips": 49037,
    "state": "UT",
    "area_name": "San Juan County"
  },
  {
    "fips": 49039,
    "state": "UT",
    "area_name": "Sanpete County"
  },
  {
    "fips": 49041,
    "state": "UT",
    "area_name": "Sevier County"
  },
  {
    "fips": 49043,
    "state": "UT",
    "area_name": "Summit County"
  },
  {
    "fips": 49045,
    "state": "UT",
    "area_name": "Tooele County"
  },
  {
    "fips": 49047,
    "state": "UT",
    "area_name": "Uintah County"
  },
  {
    "fips": 49049,
    "state": "UT",
    "area_name": "Utah County"
  },
  {
    "fips": 49051,
    "state": "UT",
    "area_name": "Wasatch County"
  },
  {
    "fips": 49053,
    "state": "UT",
    "area_name": "Washington County"
  },
  {
    "fips": 49055,
    "state": "UT",
    "area_name": "Wayne County"
  },
  {
    "fips": 49057,
    "state": "UT",
    "area_name": "Weber County"
  },
  {
    "fips": 50001,
    "state": "VT",
    "area_name": "Addison County"
  },
  {
    "fips": 50003,
    "state": "VT",
    "area_name": "Bennington County"
  },
  {
    "fips": 50005,
    "state": "VT",
    "area_name": "Caledonia County"
  },
  {
    "fips": 50007,
    "state": "VT",
    "area_name": "Chittenden County"
  },
  {
    "fips": 50009,
    "state": "VT",
    "area_name": "Essex County"
  },
  {
    "fips": 50011,
    "state": "VT",
    "area_name": "Franklin County"
  },
  {
    "fips": 50013,
    "state": "VT",
    "area_name": "Grand Isle County"
  },
  {
    "fips": 50015,
    "state": "VT",
    "area_name": "Lamoille County"
  },
  {
    "fips": 50017,
    "state": "VT",
    "area_name": "Orange County"
  },
  {
    "fips": 50019,
    "state": "VT",
    "area_name": "Orleans County"
  },
  {
    "fips": 50021,
    "state": "VT",
    "area_name": "Rutland County"
  },
  {
    "fips": 50023,
    "state": "VT",
    "area_name": "Washington County"
  },
  {
    "fips": 50025,
    "state": "VT",
    "area_name": "Windham County"
  },
  {
    "fips": 50027,
    "state": "VT",
    "area_name": "Windsor County"
  },
  {
    "fips": 51001,
    "state": "VA",
    "area_name": "Accomack County"
  },
  {
    "fips": 51003,
    "state": "VA",
    "area_name": "Albemarle County"
  },
  {
    "fips": 51005,
    "state": "VA",
    "area_name": "Alleghany County"
  },
  {
    "fips": 51007,
    "state": "VA",
    "area_name": "Amelia County"
  },
  {
    "fips": 51009,
    "state": "VA",
    "area_name": "Amherst County"
  },
  {
    "fips": 51011,
    "state": "VA",
    "area_name": "Appomattox County"
  },
  {
    "fips": 51013,
    "state": "VA",
    "area_name": "Arlington County"
  },
  {
    "fips": 51015,
    "state": "VA",
    "area_name": "Augusta County"
  },
  {
    "fips": 51017,
    "state": "VA",
    "area_name": "Bath County"
  },
  {
    "fips": 51019,
    "state": "VA",
    "area_name": "Bedford County"
  },
  {
    "fips": 51021,
    "state": "VA",
    "area_name": "Bland County"
  },
  {
    "fips": 51023,
    "state": "VA",
    "area_name": "Botetourt County"
  },
  {
    "fips": 51025,
    "state": "VA",
    "area_name": "Brunswick County"
  },
  {
    "fips": 51027,
    "state": "VA",
    "area_name": "Buchanan County"
  },
  {
    "fips": 51029,
    "state": "VA",
    "area_name": "Buckingham County"
  },
  {
    "fips": 51031,
    "state": "VA",
    "area_name": "Campbell County"
  },
  {
    "fips": 51033,
    "state": "VA",
    "area_name": "Caroline County"
  },
  {
    "fips": 51035,
    "state": "VA",
    "area_name": "Carroll County"
  },
  {
    "fips": 51036,
    "state": "VA",
    "area_name": "Charles City County"
  },
  {
    "fips": 51037,
    "state": "VA",
    "area_name": "Charlotte County"
  },
  {
    "fips": 51041,
    "state": "VA",
    "area_name": "Chesterfield County"
  },
  {
    "fips": 51043,
    "state": "VA",
    "area_name": "Clarke County"
  },
  {
    "fips": 51045,
    "state": "VA",
    "area_name": "Craig County"
  },
  {
    "fips": 51047,
    "state": "VA",
    "area_name": "Culpeper County"
  },
  {
    "fips": 51049,
    "state": "VA",
    "area_name": "Cumberland County"
  },
  {
    "fips": 51051,
    "state": "VA",
    "area_name": "Dickenson County"
  },
  {
    "fips": 51053,
    "state": "VA",
    "area_name": "Dinwiddie County"
  },
  {
    "fips": 51057,
    "state": "VA",
    "area_name": "Essex County"
  },
  {
    "fips": 51059,
    "state": "VA",
    "area_name": "Fairfax County"
  },
  {
    "fips": 51061,
    "state": "VA",
    "area_name": "Fauquier County"
  },
  {
    "fips": 51063,
    "state": "VA",
    "area_name": "Floyd County"
  },
  {
    "fips": 51065,
    "state": "VA",
    "area_name": "Fluvanna County"
  },
  {
    "fips": 51067,
    "state": "VA",
    "area_name": "Franklin County"
  },
  {
    "fips": 51069,
    "state": "VA",
    "area_name": "Frederick County"
  },
  {
    "fips": 51071,
    "state": "VA",
    "area_name": "Giles County"
  },
  {
    "fips": 51073,
    "state": "VA",
    "area_name": "Gloucester County"
  },
  {
    "fips": 51075,
    "state": "VA",
    "area_name": "Goochland County"
  },
  {
    "fips": 51077,
    "state": "VA",
    "area_name": "Grayson County"
  },
  {
    "fips": 51079,
    "state": "VA",
    "area_name": "Greene County"
  },
  {
    "fips": 51081,
    "state": "VA",
    "area_name": "Greensville County"
  },
  {
    "fips": 51083,
    "state": "VA",
    "area_name": "Halifax County"
  },
  {
    "fips": 51085,
    "state": "VA",
    "area_name": "Hanover County"
  },
  {
    "fips": 51087,
    "state": "VA",
    "area_name": "Henrico County"
  },
  {
    "fips": 51089,
    "state": "VA",
    "area_name": "Henry County"
  },
  {
    "fips": 51091,
    "state": "VA",
    "area_name": "Highland County"
  },
  {
    "fips": 51093,
    "state": "VA",
    "area_name": "Isle of Wight County"
  },
  {
    "fips": 51095,
    "state": "VA",
    "area_name": "James City County"
  },
  {
    "fips": 51097,
    "state": "VA",
    "area_name": "King and Queen County"
  },
  {
    "fips": 51099,
    "state": "VA",
    "area_name": "King George County"
  },
  {
    "fips": 51101,
    "state": "VA",
    "area_name": "King William County"
  },
  {
    "fips": 51103,
    "state": "VA",
    "area_name": "Lancaster County"
  },
  {
    "fips": 51105,
    "state": "VA",
    "area_name": "Lee County"
  },
  {
    "fips": 51107,
    "state": "VA",
    "area_name": "Loudoun County"
  },
  {
    "fips": 51109,
    "state": "VA",
    "area_name": "Louisa County"
  },
  {
    "fips": 51111,
    "state": "VA",
    "area_name": "Lunenburg County"
  },
  {
    "fips": 51113,
    "state": "VA",
    "area_name": "Madison County"
  },
  {
    "fips": 51115,
    "state": "VA",
    "area_name": "Mathews County"
  },
  {
    "fips": 51117,
    "state": "VA",
    "area_name": "Mecklenburg County"
  },
  {
    "fips": 51119,
    "state": "VA",
    "area_name": "Middlesex County"
  },
  {
    "fips": 51121,
    "state": "VA",
    "area_name": "Montgomery County"
  },
  {
    "fips": 51125,
    "state": "VA",
    "area_name": "Nelson County"
  },
  {
    "fips": 51127,
    "state": "VA",
    "area_name": "New Kent County"
  },
  {
    "fips": 51131,
    "state": "VA",
    "area_name": "Northampton County"
  },
  {
    "fips": 51133,
    "state": "VA",
    "area_name": "Northumberland County"
  },
  {
    "fips": 51135,
    "state": "VA",
    "area_name": "Nottoway County"
  },
  {
    "fips": 51137,
    "state": "VA",
    "area_name": "Orange County"
  },
  {
    "fips": 51139,
    "state": "VA",
    "area_name": "Page County"
  },
  {
    "fips": 51141,
    "state": "VA",
    "area_name": "Patrick County"
  },
  {
    "fips": 51143,
    "state": "VA",
    "area_name": "Pittsylvania County"
  },
  {
    "fips": 51145,
    "state": "VA",
    "area_name": "Powhatan County"
  },
  {
    "fips": 51147,
    "state": "VA",
    "area_name": "Prince Edward County"
  },
  {
    "fips": 51149,
    "state": "VA",
    "area_name": "Prince George County"
  },
  {
    "fips": 51153,
    "state": "VA",
    "area_name": "Prince William County"
  },
  {
    "fips": 51155,
    "state": "VA",
    "area_name": "Pulaski County"
  },
  {
    "fips": 51157,
    "state": "VA",
    "area_name": "Rappahannock County"
  },
  {
    "fips": 51159,
    "state": "VA",
    "area_name": "Richmond County"
  },
  {
    "fips": 51161,
    "state": "VA",
    "area_name": "Roanoke County"
  },
  {
    "fips": 51163,
    "state": "VA",
    "area_name": "Rockbridge County"
  },
  {
    "fips": 51165,
    "state": "VA",
    "area_name": "Rockingham County"
  },
  {
    "fips": 51167,
    "state": "VA",
    "area_name": "Russell County"
  },
  {
    "fips": 51169,
    "state": "VA",
    "area_name": "Scott County"
  },
  {
    "fips": 51171,
    "state": "VA",
    "area_name": "Shenandoah County"
  },
  {
    "fips": 51173,
    "state": "VA",
    "area_name": "Smyth County"
  },
  {
    "fips": 51175,
    "state": "VA",
    "area_name": "Southampton County"
  },
  {
    "fips": 51177,
    "state": "VA",
    "area_name": "Spotsylvania County"
  },
  {
    "fips": 51179,
    "state": "VA",
    "area_name": "Stafford County"
  },
  {
    "fips": 51181,
    "state": "VA",
    "area_name": "Surry County"
  },
  {
    "fips": 51183,
    "state": "VA",
    "area_name": "Sussex County"
  },
  {
    "fips": 51185,
    "state": "VA",
    "area_name": "Tazewell County"
  },
  {
    "fips": 51187,
    "state": "VA",
    "area_name": "Warren County"
  },
  {
    "fips": 51191,
    "state": "VA",
    "area_name": "Washington County"
  },
  {
    "fips": 51193,
    "state": "VA",
    "area_name": "Westmoreland County"
  },
  {
    "fips": 51195,
    "state": "VA",
    "area_name": "Wise County"
  },
  {
    "fips": 51197,
    "state": "VA",
    "area_name": "Wythe County"
  },
  {
    "fips": 51199,
    "state": "VA",
    "area_name": "York County"
  },
  {
    "fips": 51510,
    "state": "VA",
    "area_name": "Alexandria city"
  },
  {
    "fips": 51520,
    "state": "VA",
    "area_name": "Bristol city"
  },
  {
    "fips": 51530,
    "state": "VA",
    "area_name": "Buena Vista city"
  },
  {
    "fips": 51540,
    "state": "VA",
    "area_name": "Charlottesville city"
  },
  {
    "fips": 51550,
    "state": "VA",
    "area_name": "Chesapeake city"
  },
  {
    "fips": 51570,
    "state": "VA",
    "area_name": "Colonial Heights city"
  },
  {
    "fips": 51580,
    "state": "VA",
    "area_name": "Covington city"
  },
  {
    "fips": 51590,
    "state": "VA",
    "area_name": "Danville city"
  },
  {
    "fips": 51595,
    "state": "VA",
    "area_name": "Emporia city"
  },
  {
    "fips": 51600,
    "state": "VA",
    "area_name": "Fairfax city"
  },
  {
    "fips": 51610,
    "state": "VA",
    "area_name": "Falls Church city"
  },
  {
    "fips": 51620,
    "state": "VA",
    "area_name": "Franklin city"
  },
  {
    "fips": 51630,
    "state": "VA",
    "area_name": "Fredericksburg city"
  },
  {
    "fips": 51640,
    "state": "VA",
    "area_name": "Galax city"
  },
  {
    "fips": 51650,
    "state": "VA",
    "area_name": "Hampton city"
  },
  {
    "fips": 51660,
    "state": "VA",
    "area_name": "Harrisonburg city"
  },
  {
    "fips": 51670,
    "state": "VA",
    "area_name": "Hopewell city"
  },
  {
    "fips": 51678,
    "state": "VA",
    "area_name": "Lexington city"
  },
  {
    "fips": 51680,
    "state": "VA",
    "area_name": "Lynchburg city"
  },
  {
    "fips": 51683,
    "state": "VA",
    "area_name": "Manassas city"
  },
  {
    "fips": 51685,
    "state": "VA",
    "area_name": "Manassas Park city"
  },
  {
    "fips": 51690,
    "state": "VA",
    "area_name": "Martinsville city"
  },
  {
    "fips": 51700,
    "state": "VA",
    "area_name": "Newport News city"
  },
  {
    "fips": 51710,
    "state": "VA",
    "area_name": "Norfolk city"
  },
  {
    "fips": 51720,
    "state": "VA",
    "area_name": "Norton city"
  },
  {
    "fips": 51730,
    "state": "VA",
    "area_name": "Petersburg city"
  },
  {
    "fips": 51735,
    "state": "VA",
    "area_name": "Poquoson city"
  },
  {
    "fips": 51740,
    "state": "VA",
    "area_name": "Portsmouth city"
  },
  {
    "fips": 51750,
    "state": "VA",
    "area_name": "Radford city"
  },
  {
    "fips": 51760,
    "state": "VA",
    "area_name": "Richmond city"
  },
  {
    "fips": 51770,
    "state": "VA",
    "area_name": "Roanoke city"
  },
  {
    "fips": 51775,
    "state": "VA",
    "area_name": "Salem city"
  },
  {
    "fips": 51790,
    "state": "VA",
    "area_name": "Staunton city"
  },
  {
    "fips": 51800,
    "state": "VA",
    "area_name": "Suffolk city"
  },
  {
    "fips": 51810,
    "state": "VA",
    "area_name": "Virginia Beach city"
  },
  {
    "fips": 51820,
    "state": "VA",
    "area_name": "Waynesboro city"
  },
  {
    "fips": 51830,
    "state": "VA",
    "area_name": "Williamsburg city"
  },
  {
    "fips": 51840,
    "state": "VA",
    "area_name": "Winchester city"
  },
  {
    "fips": 53001,
    "state": "WA",
    "area_name": "Adams County"
  },
  {
    "fips": 53003,
    "state": "WA",
    "area_name": "Asotin County"
  },
  {
    "fips": 53005,
    "state": "WA",
    "area_name": "Benton County"
  },
  {
    "fips": 53007,
    "state": "WA",
    "area_name": "Chelan County"
  },
  {
    "fips": 53009,
    "state": "WA",
    "area_name": "Clallam County"
  },
  {
    "fips": 53011,
    "state": "WA",
    "area_name": "Clark County"
  },
  {
    "fips": 53013,
    "state": "WA",
    "area_name": "Columbia County"
  },
  {
    "fips": 53015,
    "state": "WA",
    "area_name": "Cowlitz County"
  },
  {
    "fips": 53017,
    "state": "WA",
    "area_name": "Douglas County"
  },
  {
    "fips": 53019,
    "state": "WA",
    "area_name": "Ferry County"
  },
  {
    "fips": 53021,
    "state": "WA",
    "area_name": "Franklin County"
  },
  {
    "fips": 53023,
    "state": "WA",
    "area_name": "Garfield County"
  },
  {
    "fips": 53025,
    "state": "WA",
    "area_name": "Grant County"
  },
  {
    "fips": 53027,
    "state": "WA",
    "area_name": "Grays Harbor County"
  },
  {
    "fips": 53029,
    "state": "WA",
    "area_name": "Island County"
  },
  {
    "fips": 53031,
    "state": "WA",
    "area_name": "Jefferson County"
  },
  {
    "fips": 53033,
    "state": "WA",
    "area_name": "King County"
  },
  {
    "fips": 53035,
    "state": "WA",
    "area_name": "Kitsap County"
  },
  {
    "fips": 53037,
    "state": "WA",
    "area_name": "Kittitas County"
  },
  {
    "fips": 53039,
    "state": "WA",
    "area_name": "Klickitat County"
  },
  {
    "fips": 53041,
    "state": "WA",
    "area_name": "Lewis County"
  },
  {
    "fips": 53043,
    "state": "WA",
    "area_name": "Lincoln County"
  },
  {
    "fips": 53045,
    "state": "WA",
    "area_name": "Mason County"
  },
  {
    "fips": 53047,
    "state": "WA",
    "area_name": "Okanogan County"
  },
  {
    "fips": 53049,
    "state": "WA",
    "area_name": "Pacific County"
  },
  {
    "fips": 53051,
    "state": "WA",
    "area_name": "Pend Oreille County"
  },
  {
    "fips": 53053,
    "state": "WA",
    "area_name": "Pierce County"
  },
  {
    "fips": 53055,
    "state": "WA",
    "area_name": "San Juan County"
  },
  {
    "fips": 53057,
    "state": "WA",
    "area_name": "Skagit County"
  },
  {
    "fips": 53059,
    "state": "WA",
    "area_name": "Skamania County"
  },
  {
    "fips": 53061,
    "state": "WA",
    "area_name": "Snohomish County"
  },
  {
    "fips": 53063,
    "state": "WA",
    "area_name": "Spokane County"
  },
  {
    "fips": 53065,
    "state": "WA",
    "area_name": "Stevens County"
  },
  {
    "fips": 53067,
    "state": "WA",
    "area_name": "Thurston County"
  },
  {
    "fips": 53069,
    "state": "WA",
    "area_name": "Wahkiakum County"
  },
  {
    "fips": 53071,
    "state": "WA",
    "area_name": "Walla Walla County"
  },
  {
    "fips": 53073,
    "state": "WA",
    "area_name": "Whatcom County"
  },
  {
    "fips": 53075,
    "state": "WA",
    "area_name": "Whitman County"
  },
  {
    "fips": 53077,
    "state": "WA",
    "area_name": "Yakima County"
  },
  {
    "fips": 54001,
    "state": "WV",
    "area_name": "Barbour County"
  },
  {
    "fips": 54003,
    "state": "WV",
    "area_name": "Berkeley County"
  },
  {
    "fips": 54005,
    "state": "WV",
    "area_name": "Boone County"
  },
  {
    "fips": 54007,
    "state": "WV",
    "area_name": "Braxton County"
  },
  {
    "fips": 54009,
    "state": "WV",
    "area_name": "Brooke County"
  },
  {
    "fips": 54011,
    "state": "WV",
    "area_name": "Cabell County"
  },
  {
    "fips": 54013,
    "state": "WV",
    "area_name": "Calhoun County"
  },
  {
    "fips": 54015,
    "state": "WV",
    "area_name": "Clay County"
  },
  {
    "fips": 54017,
    "state": "WV",
    "area_name": "Doddridge County"
  },
  {
    "fips": 54019,
    "state": "WV",
    "area_name": "Fayette County"
  },
  {
    "fips": 54021,
    "state": "WV",
    "area_name": "Gilmer County"
  },
  {
    "fips": 54023,
    "state": "WV",
    "area_name": "Grant County"
  },
  {
    "fips": 54025,
    "state": "WV",
    "area_name": "Greenbrier County"
  },
  {
    "fips": 54027,
    "state": "WV",
    "area_name": "Hampshire County"
  },
  {
    "fips": 54029,
    "state": "WV",
    "area_name": "Hancock County"
  },
  {
    "fips": 54031,
    "state": "WV",
    "area_name": "Hardy County"
  },
  {
    "fips": 54033,
    "state": "WV",
    "area_name": "Harrison County"
  },
  {
    "fips": 54035,
    "state": "WV",
    "area_name": "Jackson County"
  },
  {
    "fips": 54037,
    "state": "WV",
    "area_name": "Jefferson County"
  },
  {
    "fips": 54039,
    "state": "WV",
    "area_name": "Kanawha County"
  },
  {
    "fips": 54041,
    "state": "WV",
    "area_name": "Lewis County"
  },
  {
    "fips": 54043,
    "state": "WV",
    "area_name": "Lincoln County"
  },
  {
    "fips": 54045,
    "state": "WV",
    "area_name": "Logan County"
  },
  {
    "fips": 54047,
    "state": "WV",
    "area_name": "McDowell County"
  },
  {
    "fips": 54049,
    "state": "WV",
    "area_name": "Marion County"
  },
  {
    "fips": 54051,
    "state": "WV",
    "area_name": "Marshall County"
  },
  {
    "fips": 54053,
    "state": "WV",
    "area_name": "Mason County"
  },
  {
    "fips": 54055,
    "state": "WV",
    "area_name": "Mercer County"
  },
  {
    "fips": 54057,
    "state": "WV",
    "area_name": "Mineral County"
  },
  {
    "fips": 54059,
    "state": "WV",
    "area_name": "Mingo County"
  },
  {
    "fips": 54061,
    "state": "WV",
    "area_name": "Monongalia County"
  },
  {
    "fips": 54063,
    "state": "WV",
    "area_name": "Monroe County"
  },
  {
    "fips": 54065,
    "state": "WV",
    "area_name": "Morgan County"
  },
  {
    "fips": 54067,
    "state": "WV",
    "area_name": "Nicholas County"
  },
  {
    "fips": 54069,
    "state": "WV",
    "area_name": "Ohio County"
  },
  {
    "fips": 54071,
    "state": "WV",
    "area_name": "Pendleton County"
  },
  {
    "fips": 54073,
    "state": "WV",
    "area_name": "Pleasants County"
  },
  {
    "fips": 54075,
    "state": "WV",
    "area_name": "Pocahontas County"
  },
  {
    "fips": 54077,
    "state": "WV",
    "area_name": "Preston County"
  },
  {
    "fips": 54079,
    "state": "WV",
    "area_name": "Putnam County"
  },
  {
    "fips": 54081,
    "state": "WV",
    "area_name": "Raleigh County"
  },
  {
    "fips": 54083,
    "state": "WV",
    "area_name": "Randolph County"
  },
  {
    "fips": 54085,
    "state": "WV",
    "area_name": "Ritchie County"
  },
  {
    "fips": 54087,
    "state": "WV",
    "area_name": "Roane County"
  },
  {
    "fips": 54089,
    "state": "WV",
    "area_name": "Summers County"
  },
  {
    "fips": 54091,
    "state": "WV",
    "area_name": "Taylor County"
  },
  {
    "fips": 54093,
    "state": "WV",
    "area_name": "Tucker County"
  },
  {
    "fips": 54095,
    "state": "WV",
    "area_name": "Tyler County"
  },
  {
    "fips": 54097,
    "state": "WV",
    "area_name": "Upshur County"
  },
  {
    "fips": 54099,
    "state": "WV",
    "area_name": "Wayne County"
  },
  {
    "fips": 54101,
    "state": "WV",
    "area_name": "Webster County"
  },
  {
    "fips": 54103,
    "state": "WV",
    "area_name": "Wetzel County"
  },
  {
    "fips": 54105,
    "state": "WV",
    "area_name": "Wirt County"
  },
  {
    "fips": 54107,
    "state": "WV",
    "area_name": "Wood County"
  },
  {
    "fips": 54109,
    "state": "WV",
    "area_name": "Wyoming County"
  },
  {
    "fips": 55001,
    "state": "WI",
    "area_name": "Adams County"
  },
  {
    "fips": 55003,
    "state": "WI",
    "area_name": "Ashland County"
  },
  {
    "fips": 55005,
    "state": "WI",
    "area_name": "Barron County"
  },
  {
    "fips": 55007,
    "state": "WI",
    "area_name": "Bayfield County"
  },
  {
    "fips": 55009,
    "state": "WI",
    "area_name": "Brown County"
  },
  {
    "fips": 55011,
    "state": "WI",
    "area_name": "Buffalo County"
  },
  {
    "fips": 55013,
    "state": "WI",
    "area_name": "Burnett County"
  },
  {
    "fips": 55015,
    "state": "WI",
    "area_name": "Calumet County"
  },
  {
    "fips": 55017,
    "state": "WI",
    "area_name": "Chippewa County"
  },
  {
    "fips": 55019,
    "state": "WI",
    "area_name": "Clark County"
  },
  {
    "fips": 55021,
    "state": "WI",
    "area_name": "Columbia County"
  },
  {
    "fips": 55023,
    "state": "WI",
    "area_name": "Crawford County"
  },
  {
    "fips": 55025,
    "state": "WI",
    "area_name": "Dane County"
  },
  {
    "fips": 55027,
    "state": "WI",
    "area_name": "Dodge County"
  },
  {
    "fips": 55029,
    "state": "WI",
    "area_name": "Door County"
  },
  {
    "fips": 55031,
    "state": "WI",
    "area_name": "Douglas County"
  },
  {
    "fips": 55033,
    "state": "WI",
    "area_name": "Dunn County"
  },
  {
    "fips": 55035,
    "state": "WI",
    "area_name": "Eau Claire County"
  },
  {
    "fips": 55037,
    "state": "WI",
    "area_name": "Florence County"
  },
  {
    "fips": 55039,
    "state": "WI",
    "area_name": "Fond du Lac County"
  },
  {
    "fips": 55041,
    "state": "WI",
    "area_name": "Forest County"
  },
  {
    "fips": 55043,
    "state": "WI",
    "area_name": "Grant County"
  },
  {
    "fips": 55045,
    "state": "WI",
    "area_name": "Green County"
  },
  {
    "fips": 55047,
    "state": "WI",
    "area_name": "Green Lake County"
  },
  {
    "fips": 55049,
    "state": "WI",
    "area_name": "Iowa County"
  },
  {
    "fips": 55051,
    "state": "WI",
    "area_name": "Iron County"
  },
  {
    "fips": 55053,
    "state": "WI",
    "area_name": "Jackson County"
  },
  {
    "fips": 55055,
    "state": "WI",
    "area_name": "Jefferson County"
  },
  {
    "fips": 55057,
    "state": "WI",
    "area_name": "Juneau County"
  },
  {
    "fips": 55059,
    "state": "WI",
    "area_name": "Kenosha County"
  },
  {
    "fips": 55061,
    "state": "WI",
    "area_name": "Kewaunee County"
  },
  {
    "fips": 55063,
    "state": "WI",
    "area_name": "La Crosse County"
  },
  {
    "fips": 55065,
    "state": "WI",
    "area_name": "Lafayette County"
  },
  {
    "fips": 55067,
    "state": "WI",
    "area_name": "Langlade County"
  },
  {
    "fips": 55069,
    "state": "WI",
    "area_name": "Lincoln County"
  },
  {
    "fips": 55071,
    "state": "WI",
    "area_name": "Manitowoc County"
  },
  {
    "fips": 55073,
    "state": "WI",
    "area_name": "Marathon County"
  },
  {
    "fips": 55075,
    "state": "WI",
    "area_name": "Marinette County"
  },
  {
    "fips": 55077,
    "state": "WI",
    "area_name": "Marquette County"
  },
  {
    "fips": 55078,
    "state": "WI",
    "area_name": "Menominee County"
  },
  {
    "fips": 55079,
    "state": "WI",
    "area_name": "Milwaukee County"
  },
  {
    "fips": 55081,
    "state": "WI",
    "area_name": "Monroe County"
  },
  {
    "fips": 55083,
    "state": "WI",
    "area_name": "Oconto County"
  },
  {
    "fips": 55085,
    "state": "WI",
    "area_name": "Oneida County"
  },
  {
    "fips": 55087,
    "state": "WI",
    "area_name": "Outagamie County"
  },
  {
    "fips": 55089,
    "state": "WI",
    "area_name": "Ozaukee County"
  },
  {
    "fips": 55091,
    "state": "WI",
    "area_name": "Pepin County"
  },
  {
    "fips": 55093,
    "state": "WI",
    "area_name": "Pierce County"
  },
  {
    "fips": 55095,
    "state": "WI",
    "area_name": "Polk County"
  },
  {
    "fips": 55097,
    "state": "WI",
    "area_name": "Portage County"
  },
  {
    "fips": 55099,
    "state": "WI",
    "area_name": "Price County"
  },
  {
    "fips": 55101,
    "state": "WI",
    "area_name": "Racine County"
  },
  {
    "fips": 55103,
    "state": "WI",
    "area_name": "Richland County"
  },
  {
    "fips": 55105,
    "state": "WI",
    "area_name": "Rock County"
  },
  {
    "fips": 55107,
    "state": "WI",
    "area_name": "Rusk County"
  },
  {
    "fips": 55109,
    "state": "WI",
    "area_name": "St. Croix County"
  },
  {
    "fips": 55111,
    "state": "WI",
    "area_name": "Sauk County"
  },
  {
    "fips": 55113,
    "state": "WI",
    "area_name": "Sawyer County"
  },
  {
    "fips": 55115,
    "state": "WI",
    "area_name": "Shawano County"
  },
  {
    "fips": 55117,
    "state": "WI",
    "area_name": "Sheboygan County"
  },
  {
    "fips": 55119,
    "state": "WI",
    "area_name": "Taylor County"
  },
  {
    "fips": 55121,
    "state": "WI",
    "area_name": "Trempealeau County"
  },
  {
    "fips": 55123,
    "state": "WI",
    "area_name": "Vernon County"
  },
  {
    "fips": 55125,
    "state": "WI",
    "area_name": "Vilas County"
  },
  {
    "fips": 55127,
    "state": "WI",
    "area_name": "Walworth County"
  },
  {
    "fips": 55129,
    "state": "WI",
    "area_name": "Washburn County"
  },
  {
    "fips": 55131,
    "state": "WI",
    "area_name": "Washington County"
  },
  {
    "fips": 55133,
    "state": "WI",
    "area_name": "Waukesha County"
  },
  {
    "fips": 55135,
    "state": "WI",
    "area_name": "Waupaca County"
  },
  {
    "fips": 55137,
    "state": "WI",
    "area_name": "Waushara County"
  },
  {
    "fips": 55139,
    "state": "WI",
    "area_name": "Winnebago County"
  },
  {
    "fips": 55141,
    "state": "WI",
    "area_name": "Wood County"
  },
  {
    "fips": 56001,
    "state": "WY",
    "area_name": "Albany County"
  },
  {
    "fips": 56003,
    "state": "WY",
    "area_name": "Big Horn County"
  },
  {
    "fips": 56005,
    "state": "WY",
    "area_name": "Campbell County"
  },
  {
    "fips": 56007,
    "state": "WY",
    "area_name": "Carbon County"
  },
  {
    "fips": 56009,
    "state": "WY",
    "area_name": "Converse County"
  },
  {
    "fips": 56011,
    "state": "WY",
    "area_name": "Crook County"
  },
  {
    "fips": 56013,
    "state": "WY",
    "area_name": "Fremont County"
  },
  {
    "fips": 56015,
    "state": "WY",
    "area_name": "Goshen County"
  },
  {
    "fips": 56017,
    "state": "WY",
    "area_name": "Hot Springs County"
  },
  {
    "fips": 56019,
    "state": "WY",
    "area_name": "Johnson County"
  },
  {
    "fips": 56021,
    "state": "WY",
    "area_name": "Laramie County"
  },
  {
    "fips": 56023,
    "state": "WY",
    "area_name": "Lincoln County"
  },
  {
    "fips": 56025,
    "state": "WY",
    "area_name": "Natrona County"
  },
  {
    "fips": 56027,
    "state": "WY",
    "area_name": "Niobrara County"
  },
  {
    "fips": 56029,
    "state": "WY",
    "area_name": "Park County"
  },
  {
    "fips": 56031,
    "state": "WY",
    "area_name": "Platte County"
  },
  {
    "fips": 56033,
    "state": "WY",
    "area_name": "Sheridan County"
  },
  {
    "fips": 56035,
    "state": "WY",
    "area_name": "Sublette County"
  },
  {
    "fips": 56037,
    "state": "WY",
    "area_name": "Sweetwater County"
  },
  {
    "fips": 56039,
    "state": "WY",
    "area_name": "Teton County"
  },
  {
    "fips": 56041,
    "state": "WY",
    "area_name": "Uinta County"
  },
  {
    "fips": 56043,
    "state": "WY",
    "area_name": "Washakie County"
  },
  {
    "fips": 56045,
    "state": "WY",
    "area_name": "Weston County"
  }
]